import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string | number; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  Decimal: { input: any; output: any; }
  ExpectedErrorType: { input: any; output: any; }
  GenericScalar: { input: any; output: any; }
  JSONString: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

export type AddApplicationAnswers = {
  __typename?: 'AddApplicationAnswers';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AddBenefitAnswers = {
  __typename?: 'AddBenefitAnswers';
  error?: Maybe<Scalars['String']['output']>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type AddDummyIncomeDocument = {
  __typename?: 'AddDummyIncomeDocument';
  errorMessage?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AddressAutocomplete = {
  __typename?: 'AddressAutocomplete';
  description?: Maybe<Scalars['String']['output']>;
  placeId?: Maybe<Scalars['String']['output']>;
};

export type AddressDetails = {
  __typename?: 'AddressDetails';
  address1?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type AddressValidation = {
  __typename?: 'AddressValidation';
  address1?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  formattedAddress?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

/** An enumeration. */
export enum ApplicationAnswersCategory {
  /** Assistance Orgs */
  AssistanceOrgs = 'ASSISTANCE_ORGS',
  /** Bank Account */
  BankAccount = 'BANK_ACCOUNT',
  /** Combined Household Income */
  CombinedHouseholdIncome = 'COMBINED_HOUSEHOLD_INCOME',
  /** Covid */
  Covid = 'COVID',
  /** General */
  General = 'GENERAL',
  /** Has Applied To Other Programs */
  HasAppliedToOtherPrograms = 'HAS_APPLIED_TO_OTHER_PROGRAMS',
  /** Heard About Program */
  HeardAboutProgram = 'HEARD_ABOUT_PROGRAM',
  /** Homeless Status */
  HomelessStatus = 'HOMELESS_STATUS',
  /** Household Members */
  HouseholdMembers = 'HOUSEHOLD_MEMBERS',
  /** Household Members Under 18 */
  HouseholdMembersUnder_18 = 'HOUSEHOLD_MEMBERS_UNDER_18',
  /** Household Residency */
  HouseholdResidency = 'HOUSEHOLD_RESIDENCY',
  /** Housing Status */
  HousingStatus = 'HOUSING_STATUS',
  /** Id */
  Id = 'ID',
  /** Incarceration */
  Incarceration = 'INCARCERATION',
  /** Income Earner */
  IncomeEarner = 'INCOME_EARNER',
  /** Income Threshold */
  IncomeThreshold = 'INCOME_THRESHOLD',
  /** Children Pregnant */
  Pregnancy = 'PREGNANCY',
  /** Proof Of Income Category */
  ProofOfIncomeCategory = 'PROOF_OF_INCOME_CATEGORY',
  /** Proof Of Residency Category */
  ProofOfResidencyCategory = 'PROOF_OF_RESIDENCY_CATEGORY',
  /** Sign Verification */
  SignVerification = 'SIGN_VERIFICATION',
  /** Single Income Attestation */
  SingleIncomeAttestation = 'SINGLE_INCOME_ATTESTATION',
  /** Smartphone Access */
  SmartphoneAccess = 'SMARTPHONE_ACCESS',
  /** Ssi Benefits */
  SsiBenefits = 'SSI_BENEFITS',
  /** Taxable Income */
  TaxableIncome = 'TAXABLE_INCOME'
}

export type ApplicationAnswersInputType = {
  category?: InputMaybe<Scalars['String']['input']>;
  householdMemberId?: InputMaybe<Scalars['ID']['input']>;
  personApplicationId?: InputMaybe<Scalars['ID']['input']>;
  response?: InputMaybe<Scalars['String']['input']>;
};

/** An enumeration. */
export enum ApplicationDetailsStatus {
  /** Approved */
  Approved = 'APPROVED',
  /** Rejected */
  Rejected = 'REJECTED'
}

export type ApplicationDetailsType = Node & {
  __typename?: 'ApplicationDetailsType';
  answers: ProgramApplicationAnswerTypeConnection;
  applicationSubmittedNotificationSent?: Maybe<Scalars['DateTime']['output']>;
  assignedAdmin?: Maybe<UserType>;
  benefitsScreening?: Maybe<BenefitsScreeningType>;
  completed?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  flags: PersonFlagTypeConnection;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  intercomKey?: Maybe<Scalars['String']['output']>;
  invitations?: Maybe<InvitationType>;
  isLocked: Scalars['Boolean']['output'];
  language?: Maybe<Scalars['String']['output']>;
  legacyApplicationId?: Maybe<Scalars['Int']['output']>;
  note: Array<NoteType>;
  person: PersonType;
  pk?: Maybe<Scalars['Int']['output']>;
  program: ProgramType;
  reachedVerifyScreen: Scalars['Boolean']['output'];
  requestedBenefitsCounseling: Scalars['Boolean']['output'];
  selectedFor?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ApplicationDetailsStatus>;
  updatedAt: Scalars['DateTime']['output'];
  verified: Scalars['Boolean']['output'];
};


export type ApplicationDetailsTypeAnswersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ApplicationDetailsTypeFlagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ApplicationDetailsTypeConnection = {
  __typename?: 'ApplicationDetailsTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ApplicationDetailsTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ApplicationDetailsType` and its cursor. */
export type ApplicationDetailsTypeEdge = {
  __typename?: 'ApplicationDetailsTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ApplicationDetailsType>;
};

export type Apply = {
  __typename?: 'Apply';
  application?: Maybe<ApplicationDetailsType>;
  error?: Maybe<Scalars['Boolean']['output']>;
};

export type ApproveDocument = {
  __typename?: 'ApproveDocument';
  errorMessage?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Archive account and revoke refresh tokens.
 *
 * User must be verified and confirm password.
 */
export type ArchiveAccount = {
  __typename?: 'ArchiveAccount';
  errors?: Maybe<Scalars['ExpectedErrorType']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** An enumeration. */
export enum BenefitAnswerCategory {
  /** Acp How */
  AcpHow = 'ACP_HOW',
  /** Acp Program */
  AcpProgram = 'ACP_PROGRAM',
  /** Calendly Appointment */
  CalendlyAppointment = 'CALENDLY_APPOINTMENT',
  /** Cal Fresh Amount */
  CalFreshAmount = 'CAL_FRESH_AMOUNT',
  /** Cal Works Amount */
  CalWorksAmount = 'CAL_WORKS_AMOUNT',
  /** Counseling Auto Enrolled */
  CounselingAutoEnrolled = 'COUNSELING_AUTO_ENROLLED',
  /** Decline Speak Counselor */
  DeclineSpeakCounselor = 'DECLINE_SPEAK_COUNSELOR',
  /** Earned Income */
  EarnedIncome = 'EARNED_INCOME',
  /** Head Start Re Qualifying */
  HeadStartReQualifying = 'HEAD_START_RE_QUALIFYING',
  /** Housing Assistance */
  HousingAssistance = 'HOUSING_ASSISTANCE',
  /** No Benefits */
  NoBenefits = 'NO_BENEFITS',
  /** Unearned Income */
  UnearnedIncome = 'UNEARNED_INCOME'
}

export type BenefitAnswerInputType = {
  answer?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  householdMemberId?: InputMaybe<Scalars['ID']['input']>;
  personId?: InputMaybe<Scalars['ID']['input']>;
};

export type BenefitAnswerType = Node & {
  __typename?: 'BenefitAnswerType';
  answer: Scalars['String']['output'];
  category: BenefitAnswerCategory;
  createdAt: Scalars['DateTime']['output'];
  householdMember?: Maybe<HouseholdMemberType>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  person: PersonType;
  pk?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type BenefitAnswerTypeConnection = {
  __typename?: 'BenefitAnswerTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<BenefitAnswerTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `BenefitAnswerType` and its cursor. */
export type BenefitAnswerTypeEdge = {
  __typename?: 'BenefitAnswerTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<BenefitAnswerType>;
};

/** An enumeration. */
export enum BenefitSelectedCategory {
  /** Affordable Connectivity */
  AffordableConnectivity = 'AFFORDABLE_CONNECTIVITY',
  /** Cal Fresh */
  CalFresh = 'CAL_FRESH',
  /** Cal Works */
  CalWorks = 'CAL_WORKS',
  /** Head Start */
  HeadStart = 'HEAD_START',
  /** Hud Housing */
  HudHousing = 'HUD_HOUSING',
  /** None */
  None = 'NONE',
  /** Ssi */
  Ssi = 'SSI'
}

export type BenefitSelectedInputType = {
  category?: InputMaybe<Scalars['String']['input']>;
  personId?: InputMaybe<Scalars['ID']['input']>;
};

export type BenefitSelectedType = Node & {
  __typename?: 'BenefitSelectedType';
  category: BenefitSelectedCategory;
  createdAt: Scalars['DateTime']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  person: PersonType;
  pk?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type BenefitSelectedTypeConnection = {
  __typename?: 'BenefitSelectedTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<BenefitSelectedTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `BenefitSelectedType` and its cursor. */
export type BenefitSelectedTypeEdge = {
  __typename?: 'BenefitSelectedTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<BenefitSelectedType>;
};

export type BenefitsCounselorType = {
  __typename?: 'BenefitsCounselorType';
  benefitsAppointments: Array<BenefitsScreeningAppointmentType>;
  benefitsScreenings: Array<BenefitsScreeningType>;
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isManager: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  note: Array<NoteType>;
  updatedAt: Scalars['DateTime']['output'];
};

/** An enumeration. */
export enum BenefitsScreeningAction {
  /** Dismissed */
  Dismissed = 'DISMISSED',
  /** Drop */
  Drop = 'DROP',
  /** Enroll */
  Enroll = 'ENROLL'
}

export type BenefitsScreeningAppointmentType = {
  __typename?: 'BenefitsScreeningAppointmentType';
  benefitsScreening: BenefitsScreeningType;
  counselor: BenefitsCounselorType;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  scheduled: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type BenefitsScreeningType = {
  __typename?: 'BenefitsScreeningType';
  action?: Maybe<BenefitsScreeningAction>;
  applicantEdits?: Maybe<Scalars['String']['output']>;
  application: ApplicationDetailsType;
  benefitsAppointment?: Maybe<BenefitsScreeningAppointmentType>;
  counselor: BenefitsCounselorType;
  createdAt: Scalars['DateTime']['output'];
  householdEdits?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  recommendation?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type CalendlyEventType = {
  __typename?: 'CalendlyEventType';
  createdAt?: Maybe<Scalars['String']['output']>;
  endTime?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  personId?: Maybe<Scalars['Int']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type CheckSixDigitVerificationCodeForPerson = {
  __typename?: 'CheckSixDigitVerificationCodeForPerson';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CommunicationSettingType = {
  __typename?: 'CommunicationSettingType';
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  emailNotificationsEnabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  person: PersonType;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  smsNotificationsEnabled: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
  whatsappNotificationsEnabled: Scalars['Boolean']['output'];
};

export type ConfigurationData = {
  __typename?: 'ConfigurationData';
  actualConfig?: Maybe<Scalars['String']['output']>;
  organizationConfig?: Maybe<Scalars['String']['output']>;
  programLevelConfig?: Maybe<Scalars['String']['output']>;
};

/** Input type for consent data during registration. */
export type ConsentInput = {
  consentGiven: Scalars['Boolean']['input'];
  consentTypeId: Scalars['ID']['input'];
};

/** GraphQL type for ConsentRecord model. */
export type ConsentRecordType = {
  __typename?: 'ConsentRecordType';
  /** Whether consent was given or denied */
  consentGiven: Scalars['Boolean']['output'];
  consentType: ConsentTypeType;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
};

/** GraphQL type for ConsentType model. */
export type ConsentTypeType = {
  __typename?: 'ConsentTypeType';
  /** Order to display consent items */
  displayOrder: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  /** Default requirement status */
  isRequired: Scalars['Boolean']['output'];
  /** Internal identifier (e.g., 'privacy_policy') */
  name: Scalars['String']['output'];
  /** i18n key (e.g., 'consent_privacy_policy_label') */
  translationKey: Scalars['String']['output'];
};

export type CreateNote = {
  __typename?: 'CreateNote';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Delete account permanently or make `user.is_active=False`.
 *
 * The behavior is defined on settings.
 * Anyway user refresh tokens are revoked.
 *
 * User must be verified and confirm password.
 */
export type DeleteAccount = {
  __typename?: 'DeleteAccount';
  errors?: Maybe<Scalars['ExpectedErrorType']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteDocument = {
  __typename?: 'DeleteDocument';
  errorMessage?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DocumentData = {
  __typename?: 'DocumentData';
  document?: Maybe<Scalars['String']['output']>;
  encoding?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** An enumeration. */
export enum DocumentDocumentType {
  /** Drivers License */
  DriversLicense = 'DRIVERS_LICENSE',
  /** Id Card */
  IdCard = 'ID_CARD',
  /** Other */
  Other = 'OTHER',
  /** Proof Of Income */
  ProofOfIncome = 'PROOF_OF_INCOME',
  /** Proof Of Pregnancy Parenting */
  ProofOfPregnancyParenting = 'PROOF_OF_PREGNANCY_PARENTING',
  /** Proof Of Residency */
  ProofOfResidency = 'PROOF_OF_RESIDENCY'
}

export type DocumentRequireType = Node & {
  __typename?: 'DocumentRequireType';
  createdAt: Scalars['DateTime']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  program: ProgramType;
  required: Scalars['Boolean']['output'];
  type?: Maybe<DocumentRequirementType>;
  updatedAt: Scalars['DateTime']['output'];
};

export type DocumentRequireTypeConnection = {
  __typename?: 'DocumentRequireTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<DocumentRequireTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `DocumentRequireType` and its cursor. */
export type DocumentRequireTypeEdge = {
  __typename?: 'DocumentRequireTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<DocumentRequireType>;
};

/** An enumeration. */
export enum DocumentRequirementType {
  /** Drivers License */
  DriversLicense = 'DRIVERS_LICENSE',
  /** Id Card */
  IdCard = 'ID_CARD',
  /** Other */
  Other = 'OTHER',
  /** Proof Of Income */
  ProofOfIncome = 'PROOF_OF_INCOME',
  /** Proof Of Pregnancy Parenting */
  ProofOfPregnancyParenting = 'PROOF_OF_PREGNANCY_PARENTING',
  /** Proof Of Residency */
  ProofOfResidency = 'PROOF_OF_RESIDENCY'
}

export type DocumentType = Node & {
  __typename?: 'DocumentType';
  createdAt: Scalars['DateTime']['output'];
  documentOriginalName?: Maybe<Scalars['String']['output']>;
  documentType?: Maybe<DocumentDocumentType>;
  householdMember?: Maybe<HouseholdMemberType>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  person: PersonType;
  pk?: Maybe<Scalars['Int']['output']>;
  rejected?: Maybe<Scalars['Boolean']['output']>;
  requestedAs?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  uploadedAt: Scalars['DateTime']['output'];
  verifiedBy?: Maybe<UserType>;
};

export type DocumentTypeConnection = {
  __typename?: 'DocumentTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<DocumentTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `DocumentType` and its cursor. */
export type DocumentTypeEdge = {
  __typename?: 'DocumentTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<DocumentType>;
};

export type DocumentUpload = {
  __typename?: 'DocumentUpload';
  documentUploadSuccess?: Maybe<Scalars['Boolean']['output']>;
};

export type EditUserAndPerson = {
  __typename?: 'EditUserAndPerson';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

/** An enumeration. */
export enum FaqNinjaWizardLanguage {
  /** English */
  En = 'EN',
  /** Spanish */
  Es = 'ES',
  /** Persian */
  Fa = 'FA',
  /** Khmer */
  Km = 'KM',
  /** Tagalog */
  Tl = 'TL',
  /** Vietnamese */
  Vi = 'VI'
}

export type FaqNinjaWizardType = {
  __typename?: 'FaqNinjaWizardType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  language: FaqNinjaWizardLanguage;
  ninjaCode: Scalars['String']['output'];
  org: OrganizationType;
  updatedAt: Scalars['DateTime']['output'];
};

export type FieldErrorType = {
  __typename?: 'FieldErrorType';
  code?: Maybe<Scalars['String']['output']>;
  fieldName?: Maybe<Scalars['String']['output']>;
};

/** An enumeration. */
export enum FlagsFlagType {
  /** Duplicate */
  Duplicate = 'DUPLICATE',
  /** Geolocation */
  Geolocation = 'GEOLOCATION',
  /** Income */
  Income = 'INCOME',
  /** Is Outside Us */
  IsOutsideUs = 'IS_OUTSIDE_US',
  /** No Dependents */
  NoDependents = 'NO_DEPENDENTS',
  /** Po Box */
  PoBox = 'PO_BOX'
}

export type GeneratePersonInvitation = {
  __typename?: 'GeneratePersonInvitation';
  errorMessage?: Maybe<Scalars['String']['output']>;
  inviteCode?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type GenerateReportMutation = {
  __typename?: 'GenerateReportMutation';
  errorMessage?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type GetLanguages = {
  __typename?: 'GetLanguages';
  languages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type GetPerson = {
  __typename?: 'GetPerson';
  applicationAnswers?: Maybe<Array<Maybe<ProgramApplicationAnswerType>>>;
  documents?: Maybe<Array<Maybe<DocumentType>>>;
  flags?: Maybe<Array<Maybe<PersonFlagType>>>;
  householdMembers?: Maybe<Array<Maybe<HouseholdMemberType>>>;
  locationDetails?: Maybe<LocationDetailsType>;
  person?: Maybe<PersonType>;
  profile?: Maybe<ProfileType>;
};

export type GetPrograms = {
  __typename?: 'GetPrograms';
  programId?: Maybe<Scalars['ID']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type HealthCheckData = {
  __typename?: 'HealthCheckData';
  amountToTransferHyperwallet?: Maybe<Scalars['Float']['output']>;
  amountToTransferHyperwalletWithThreshold?: Maybe<Scalars['Float']['output']>;
  amountToTransferHyperwalletWithThresholdWithProjected?: Maybe<Scalars['Float']['output']>;
  amountToTransferUsio?: Maybe<Scalars['Float']['output']>;
  amountToTransferUsioWithThreshold?: Maybe<Scalars['Float']['output']>;
  amountToTransferUsioWithThresholdWithProjected?: Maybe<Scalars['Float']['output']>;
  distributorId?: Maybe<Scalars['Int']['output']>;
  fivePercentOfTotalUsers?: Maybe<Scalars['Float']['output']>;
  fivePercentOfTotalUsersRounded?: Maybe<Scalars['Int']['output']>;
  fivePercentOfTotalUsersWithProjectedUsersRounded?: Maybe<Scalars['Int']['output']>;
  fundingAccountToken?: Maybe<Scalars['String']['output']>;
  hyperwalletBalance?: Maybe<Scalars['Float']['output']>;
  hyperwalletHealth?: Maybe<Scalars['Boolean']['output']>;
  hyperwalletSubprogramId?: Maybe<Scalars['String']['output']>;
  moneyStatusHyperwallet?: Maybe<Scalars['Boolean']['output']>;
  moneyStatusUsio?: Maybe<Scalars['Boolean']['output']>;
  notSignedUpUsers?: Maybe<Scalars['Int']['output']>;
  programId?: Maybe<Scalars['Int']['output']>;
  programName?: Maybe<Scalars['String']['output']>;
  programUrl?: Maybe<Scalars['String']['output']>;
  projectedUsers?: Maybe<Scalars['Int']['output']>;
  timestamp?: Maybe<Scalars['String']['output']>;
  totalPersons?: Maybe<Scalars['Int']['output']>;
  totalUsers?: Maybe<Scalars['Int']['output']>;
  upcomingHyperwalletPayments?: Maybe<Scalars['Float']['output']>;
  upcomingUsioPayments?: Maybe<Scalars['Float']['output']>;
  usersPrepaidCard?: Maybe<Scalars['Int']['output']>;
  usersPrepaidCardAndActiveStatus?: Maybe<Scalars['Int']['output']>;
  usersWithTransferMethod?: Maybe<Scalars['Int']['output']>;
  usioBalance?: Maybe<Scalars['Float']['output']>;
  usioHealth?: Maybe<Scalars['Boolean']['output']>;
};

export type HouseholdMemberInputType = {
  blindDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  dob?: InputMaybe<Scalars['String']['input']>;
  earnedIncome?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  relation?: InputMaybe<Scalars['String']['input']>;
  unearnedIncome?: InputMaybe<Scalars['Float']['input']>;
};

export type HouseholdMemberType = {
  __typename?: 'HouseholdMemberType';
  benefitAnswers: BenefitAnswerTypeConnection;
  blindDisabled?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  dob?: Maybe<Scalars['Date']['output']>;
  documents: DocumentTypeConnection;
  earnedIncome?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  person: PersonType;
  relation: Scalars['String']['output'];
  unearnedIncome?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};


export type HouseholdMemberTypeBenefitAnswersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type HouseholdMemberTypeDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ImportPersonFromRetool = {
  __typename?: 'ImportPersonFromRetool';
  errorMessage?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type InvitationType = {
  __typename?: 'InvitationType';
  application?: Maybe<ApplicationDetailsType>;
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  invitationReminderSent?: Maybe<Scalars['DateTime']['output']>;
  invitationSent?: Maybe<Scalars['DateTime']['output']>;
  isSuperuser: Scalars['Boolean']['output'];
  isTestUser: Scalars['Boolean']['output'];
  onboardingNotificationSent?: Maybe<Scalars['DateTime']['output']>;
  onboardingReminderNotificationSent?: Maybe<Scalars['DateTime']['output']>;
  paymentAmount?: Maybe<Scalars['Decimal']['output']>;
  person: PersonType;
  program: ProgramType;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<UserType>;
};

export type InviteCodeValidationQueryResponse = {
  __typename?: 'InviteCodeValidationQueryResponse';
  alreadySignedUp?: Maybe<Scalars['Boolean']['output']>;
  person?: Maybe<PersonType>;
};

export type LocationDetailsType = {
  __typename?: 'LocationDetailsType';
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  latitude?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['String']['output']>;
  person: PersonType;
  state?: Maybe<Scalars['String']['output']>;
  tractCode?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type LogType = {
  __typename?: 'LogType';
  action: LogsAction;
  createdAt: Scalars['DateTime']['output'];
  entityType: LogsEntityType;
  id: Scalars['ID']['output'];
  modelId?: Maybe<Scalars['Int']['output']>;
  modelName: LogsModelName;
  newValue?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  originalValue?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<UserType>;
};

export type Logout = {
  __typename?: 'Logout';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

/** An enumeration. */
export enum LogsAction {
  /** Add */
  Add = 'ADD',
  /** Approve */
  Approve = 'APPROVE',
  /** Delete */
  Delete = 'DELETE',
  /** Email */
  Email = 'EMAIL',
  /** Phone */
  Phone = 'PHONE',
  /** Randomize Assigned Admin */
  RandomizeAssignedAdmin = 'RANDOMIZE_ASSIGNED_ADMIN',
  /** Request New Document */
  RequestNewDocument = 'REQUEST_NEW_DOCUMENT',
  /** Send */
  Send = 'SEND',
  /** Text */
  Text = 'TEXT',
  /** Update */
  Update = 'UPDATE'
}

/** An enumeration. */
export enum LogsEntityType {
  /** Application Status */
  ApplicationStatus = 'APPLICATION_STATUS',
  /** Automatic Reminder */
  AutomaticReminder = 'AUTOMATIC_REMINDER',
  /** Benefits Appointment Updates */
  BenefitsAppointmentUpdates = 'BENEFITS_APPOINTMENT_UPDATES',
  /** Benefits Counselor Outreach */
  BenefitsCounselorOutreach = 'BENEFITS_COUNSELOR_OUTREACH',
  /** Benefits Screening Updates */
  BenefitsScreeningUpdates = 'BENEFITS_SCREENING_UPDATES',
  /** Document */
  Document = 'DOCUMENT',
  /** Flag */
  Flag = 'FLAG',
  /** Invitation For Non Responders */
  InvitationForNonResponders = 'INVITATION_FOR_NON_RESPONDERS',
  /** Payment Run */
  PaymentRun = 'PAYMENT_RUN',
  /** Schedule Payment Removal */
  PaymentScheduleRemoval = 'PAYMENT_SCHEDULE_REMOVAL',
  /** Payment Scheduling */
  PaymentScheduling = 'PAYMENT_SCHEDULING',
  /** Randomization */
  Randomization = 'RANDOMIZATION',
  /** Transfer Method Bank Account */
  TransferMethodBankAccount = 'TRANSFER_METHOD_BANK_ACCOUNT',
  /** Transfer Method Paypal Account */
  TransferMethodPaypalAccount = 'TRANSFER_METHOD_PAYPAL_ACCOUNT',
  /** Transfer Method Prepaid Card */
  TransferMethodPrepaidCard = 'TRANSFER_METHOD_PREPAID_CARD',
  /** Transfer Method Venmo Account */
  TransferMethodVenmoAccount = 'TRANSFER_METHOD_VENMO_ACCOUNT',
  /** User Data */
  UserData = 'USER_DATA'
}

/** An enumeration. */
export enum LogsModelName {
  /** Applicationdetails */
  Applicationdetails = 'APPLICATIONDETAILS',
  /** Benefitsappointment */
  Benefitsappointment = 'BENEFITSAPPOINTMENT',
  /** Benefitsscreening */
  Benefitsscreening = 'BENEFITSSCREENING',
  /** Invitation */
  Invitation = 'INVITATION',
  /** Payment */
  Payment = 'PAYMENT',
  /** Scheduledpayment */
  Scheduledpayment = 'SCHEDULEDPAYMENT',
  /** Transfermethod */
  Transfermethod = 'TRANSFERMETHOD'
}

export type MakeFlagInactive = {
  __typename?: 'MakeFlagInactive';
  errorMessage?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type MultipleDocumentsUpload = {
  __typename?: 'MultipleDocumentsUpload';
  documentUploadSuccess?: Maybe<Scalars['Boolean']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addApplicationAnswers?: Maybe<AddApplicationAnswers>;
  addBenefitAnswers?: Maybe<AddBenefitAnswers>;
  addIncomeDocument?: Maybe<AddDummyIncomeDocument>;
  addNote?: Maybe<CreateNote>;
  addNotesOnApplication?: Maybe<RetoolUpdateApplicationNotes>;
  apply?: Maybe<Apply>;
  approveDocument?: Maybe<ApproveDocument>;
  /**
   * Archive account and revoke refresh tokens.
   *
   * User must be verified and confirm password.
   */
  archiveAccount?: Maybe<ArchiveAccount>;
  assignCounselorToBenefitsScreening?: Maybe<RetoolAssignCounselorToBenefitsScreeningMutation>;
  changeProjectedUsersCount?: Maybe<RetoolChangeProjectedUsersCount>;
  checkSixDigitVerificationCodeForPerson?: Maybe<CheckSixDigitVerificationCodeForPerson>;
  /**
   * Delete account permanently or make `user.is_active=False`.
   *
   * The behavior is defined on settings.
   * Anyway user refresh tokens are revoked.
   *
   * User must be verified and confirm password.
   */
  deleteAccount?: Maybe<DeleteAccount>;
  deleteDocument?: Maybe<DeleteDocument>;
  documentUpload?: Maybe<DocumentUpload>;
  editUserAndPerson?: Maybe<EditUserAndPerson>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  freezeRetoolUser?: Maybe<RetoolFreezeUser>;
  generatePersonInvitation?: Maybe<GeneratePersonInvitation>;
  generateReport?: Maybe<GenerateReportMutation>;
  getLanguages?: Maybe<GetLanguages>;
  getPerson?: Maybe<GetPerson>;
  getPrograms?: Maybe<GetPrograms>;
  handleDroppedAddedApplications?: Maybe<RetoolHandleDroppedApplications>;
  importPersonFromRetool?: Maybe<ImportPersonFromRetool>;
  logBenefitsCounselingOutreach?: Maybe<RetoolLogBenefitsCounselingOutreach>;
  logout?: Maybe<Logout>;
  makeFlagInactive?: Maybe<MakeFlagInactive>;
  multipleDocumentsUpload?: Maybe<MultipleDocumentsUpload>;
  orderReplacementCard?: Maybe<OrderReplacementCard>;
  passwordChange?: Maybe<PasswordChangeExtended>;
  passwordReset?: Maybe<PasswordResetExtended>;
  recoverApplication?: Maybe<RecoverApplication>;
  /** Same as `grapgql_jwt` implementation, with standard output. */
  refreshToken?: Maybe<RefreshToken>;
  register?: Maybe<RegisterExtended>;
  /**
   * Extended registration mutation that handles consent requirements.
   * Validates that all required consents are provided before creating the user.
   */
  registerWithConsent?: Maybe<RegisterWithConsent>;
  /**
   * Remove user secondary email.
   *
   * Require password confirmation.
   */
  removeSecondaryEmail?: Maybe<RemoveSecondaryEmail>;
  requestDocument?: Maybe<RequestDocument>;
  requestSingleDocument?: Maybe<RequestSingleDocument>;
  /**
   * Sends activation email.
   *
   * It is called resend because theoretically
   * the first activation email was sent when
   * the user registered.
   *
   * If there is no user with the requested email,
   * a successful response is returned.
   */
  resendActivationEmail?: Maybe<ResendActivationEmail>;
  resendOnboardingEmail?: Maybe<ResendOnboardingEmail>;
  resetTranslationCache?: Maybe<ResetTranslationsCache>;
  resolveApplication?: Maybe<ResolveApplication>;
  retoolAddSurveyPayment?: Maybe<RetoolAddSurveyPayment>;
  retoolMakePayments?: Maybe<RetoolMakePayments>;
  retoolMovePaymentsToScheduledTask?: Maybe<RetoolMovePaymentsToScheduledTask>;
  retoolPrintScheduledPayments?: Maybe<RetoolPrintScheduledPayments>;
  retoolRemovePaymentsFromScheduledTask?: Maybe<RetoolRemovePaymentsFromScheduledTask>;
  retoolRemoveScheduledPayment?: Maybe<RetoolRemoveScheduledPayment>;
  retoolRemoveTask?: Maybe<RetoolRemoveTask>;
  retoolTableImporter?: Maybe<RetoolTableImporterMutation>;
  retoolUpdateScheduledPaymentAmounts?: Maybe<RetoolUpdateScheduledPaymentAmounts>;
  /** Same as `grapgql_jwt` implementation, with standard output. */
  revokeToken?: Maybe<RevokeToken>;
  saveHouseholdMembers?: Maybe<SaveHouseholdMembers>;
  saveSixDigitVerificationCodeForPerson?: Maybe<SaveSixDigitVerificationCodeForPerson>;
  selectBenefits?: Maybe<SelectBenefits>;
  sendAllEmailTemplates?: Maybe<SendAllEmailTemplates>;
  sendConfirmation?: Maybe<SendConfirmation>;
  sendDocumentReminder?: Maybe<SendDocumentReminder>;
  sendDocumentsUploadConfirmation?: Maybe<SendDocumentsUploadConfirmation>;
  sendOnboardingNotification?: Maybe<SendOnboardingNotification>;
  sendOnboardingNotificationReminder?: Maybe<SendOnboardingNotificationReminder>;
  /**
   * Send password reset email.
   *
   * For non verified users, send an activation
   * email instead.
   *
   * Accepts both primary and secondary email.
   *
   * If there is no user with the requested email,
   * a successful response is returned.
   */
  sendPasswordResetEmail?: Maybe<SendPasswordResetEmail>;
  sendPrepaidCardEmailAndText?: Maybe<ResendPrepaidCardEmailAndTextMessage>;
  sendResetPasswordEmail?: Maybe<SendResetPasswordEmail>;
  sendRetoolOnboardingInvitation?: Maybe<SendRetoolOnboardingInvitation>;
  sendRetoolReportEmail?: Maybe<SendRetoolReportEmail>;
  /**
   * Send activation to secondary email.
   *
   * User must be verified and confirm password.
   */
  sendSecondaryEmailActivation?: Maybe<SendSecondaryEmailActivation>;
  sendSonomaOnboardingNotification?: Maybe<SendSonomaOnboardingNotification>;
  sendSupportEmail?: Maybe<SendSupportEmail>;
  sendTextMessage?: Maybe<SendTextMessage>;
  speakBenefitsCounselor?: Maybe<SpeakBenefitsCounselor>;
  success?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Swap between primary and secondary emails.
   *
   * Require password confirmation.
   */
  swapEmails?: Maybe<SwapEmails>;
  tokenAuth?: Maybe<ObtainJsonWebTokenExtended>;
  transferMethodAddBankAccount?: Maybe<TransferMethodAddBankAccount>;
  transferMethodAddPaypal?: Maybe<TransferMethodAddPaypal>;
  transferMethodAddPrepaidCard?: Maybe<TransferMethodAddPrepaidCard>;
  transferMethodAddVenmo?: Maybe<TransferMethodAddVenmo>;
  transferMethodRemove?: Maybe<TransferMethodRemove>;
  /**
   * Update user model fields, defined on settings.
   *
   * User must be verified.
   */
  updateAccount?: Maybe<UpdateAccount>;
  updateBenefitsScreeningDetails?: Maybe<RetoolUpdateBenefitsScreeningDetails>;
  updateBlindDisabled?: Maybe<UpdateBlindDisabled>;
  updateConfigurations?: Maybe<UpdateConfigurations>;
  updateDetails?: Maybe<UpdateDetails>;
  updateDetailsFromRetool?: Maybe<UpdateDetailsFromRetool>;
  updateHouseholdMember?: Maybe<UpdateHouseholdMember>;
  updateLanguage?: Maybe<UpdateLanguage>;
  updatePersonEmailPhone?: Maybe<RetoolUpdatePerson>;
  updateSettings?: Maybe<UpdateSettings>;
  updateUserEmailPhone?: Maybe<RetoolUpdateUser>;
  updateUserOrPerson?: Maybe<RetoolUpdateUserOrPersonAddress>;
  uploadCsv?: Maybe<UploadCsvRetoolMutation>;
  uploadMutation?: Maybe<UploadMutation>;
  uploadPersonFromRetool?: Maybe<UploadPersonMutation>;
  /**
   * Verify user account.
   *
   * Receive the token that was sent by email.
   * If the token is valid, make the user verified
   * by making the `user.status.verified` field true.
   */
  verifyAccount?: Maybe<VerifyAccount>;
  /**
   * Verify user secondary email.
   *
   * Receive the token that was sent by email.
   * User is already verified when using this mutation.
   *
   * If the token is valid, add the secondary email
   * to `user.status.secondary_email` field.
   *
   * Note that until the secondary email is verified,
   * it has not been saved anywhere beyond the token,
   * so it can still be used to create a new account.
   * After being verified, it will no longer be available.
   */
  verifySecondaryEmail?: Maybe<VerifySecondaryEmail>;
  /** Same as `grapgql_jwt` implementation, with standard output. */
  verifyToken?: Maybe<VerifyToken>;
};


export type MutationAddApplicationAnswersArgs = {
  answers: Array<ApplicationAnswersInputType>;
};


export type MutationAddBenefitAnswersArgs = {
  answers: Array<BenefitAnswerInputType>;
};


export type MutationAddIncomeDocumentArgs = {
  adminId?: InputMaybe<Scalars['ID']['input']>;
  personId: Scalars['ID']['input'];
  retoolPassword?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAddNoteArgs = {
  application: Scalars['ID']['input'];
  note: Scalars['String']['input'];
};


export type MutationAddNotesOnApplicationArgs = {
  adminId?: InputMaybe<Scalars['ID']['input']>;
  applicationId: Scalars['ID']['input'];
  benefitsCounselorId?: InputMaybe<Scalars['ID']['input']>;
  note: Scalars['String']['input'];
  retoolPassword: Scalars['String']['input'];
};


export type MutationApplyArgs = {
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  applicationId?: InputMaybe<Scalars['ID']['input']>;
  blindDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  dob?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  ethnicity?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  gender?: InputMaybe<Scalars['String']['input']>;
  isHomeless?: InputMaybe<Scalars['Boolean']['input']>;
  language: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  postalCode?: InputMaybe<Scalars['String']['input']>;
  programUrl: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
};


export type MutationApproveDocumentArgs = {
  adminId: Scalars['ID']['input'];
  documentId: Scalars['ID']['input'];
  retoolPassword?: InputMaybe<Scalars['String']['input']>;
};


export type MutationArchiveAccountArgs = {
  password: Scalars['String']['input'];
};


export type MutationAssignCounselorToBenefitsScreeningArgs = {
  benefitsScreeningId: Scalars['ID']['input'];
  counselorId: Scalars['ID']['input'];
  retoolPassword: Scalars['String']['input'];
};


export type MutationChangeProjectedUsersCountArgs = {
  programId: Scalars['ID']['input'];
  retoolPassword: Scalars['String']['input'];
  value: Scalars['Int']['input'];
};


export type MutationCheckSixDigitVerificationCodeForPersonArgs = {
  personId: Scalars['String']['input'];
  verificationCode: Scalars['String']['input'];
};


export type MutationDeleteAccountArgs = {
  password: Scalars['String']['input'];
};


export type MutationDeleteDocumentArgs = {
  documentId: Scalars['ID']['input'];
  retoolPassword?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDocumentUploadArgs = {
  documentType: Scalars['String']['input'];
  file: Scalars['Upload']['input'];
  householdMemberId?: InputMaybe<Scalars['ID']['input']>;
  personId: Scalars['ID']['input'];
};


export type MutationEditUserAndPersonArgs = {
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  dob: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  language: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};


export type MutationFreezeRetoolUserArgs = {
  adminId: Scalars['ID']['input'];
  retoolPassword: Scalars['String']['input'];
  unfreeze?: InputMaybe<Scalars['Boolean']['input']>;
  userId: Scalars['ID']['input'];
};


export type MutationGeneratePersonInvitationArgs = {
  personIdHashed?: InputMaybe<Scalars['ID']['input']>;
  personIdInteger?: InputMaybe<Scalars['Int']['input']>;
  programIdHashed?: InputMaybe<Scalars['ID']['input']>;
  programIdInteger?: InputMaybe<Scalars['Int']['input']>;
  retoolPassword: Scalars['String']['input'];
};


export type MutationGenerateReportArgs = {
  endDate: Scalars['Date']['input'];
  programId: Scalars['ID']['input'];
  retoolPassword?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['Date']['input'];
};


export type MutationGetLanguagesArgs = {
  includeClosedPeriod?: InputMaybe<Scalars['Boolean']['input']>;
  programUrl?: InputMaybe<Scalars['String']['input']>;
};


export type MutationGetPersonArgs = {
  id: Scalars['String']['input'];
};


export type MutationGetProgramsArgs = {
  includeClosedPeriod?: InputMaybe<Scalars['Boolean']['input']>;
  programUrl?: InputMaybe<Scalars['String']['input']>;
};


export type MutationHandleDroppedAddedApplicationsArgs = {
  addedApplicationId: Scalars['ID']['input'];
  droppedApplicationId: Scalars['ID']['input'];
  retoolPassword: Scalars['String']['input'];
};


export type MutationImportPersonFromRetoolArgs = {
  id: Scalars['ID']['input'];
  retoolPassword: Scalars['String']['input'];
};


export type MutationLogBenefitsCounselingOutreachArgs = {
  benefitsScreeningId: Scalars['ID']['input'];
  outreachType: Scalars['String']['input'];
  retoolPassword: Scalars['String']['input'];
};


export type MutationMakeFlagInactiveArgs = {
  id: Scalars['ID']['input'];
  personId: Scalars['ID']['input'];
  relatedPersonId?: InputMaybe<Scalars['ID']['input']>;
  retoolPassword?: InputMaybe<Scalars['String']['input']>;
};


export type MutationMultipleDocumentsUploadArgs = {
  documentType: Scalars['String']['input'];
  files: Array<InputMaybe<Scalars['Upload']['input']>>;
  householdMemberId?: InputMaybe<Scalars['ID']['input']>;
  personId: Scalars['ID']['input'];
  previousFiles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationOrderReplacementCardArgs = {
  addressLine1: Scalars['String']['input'];
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  password: Scalars['String']['input'];
  postalCode: Scalars['Int']['input'];
  state: Scalars['String']['input'];
  usioCardId: Scalars['Int']['input'];
};


export type MutationPasswordChangeArgs = {
  newPassword1: Scalars['String']['input'];
  newPassword2: Scalars['String']['input'];
  oldPassword: Scalars['String']['input'];
};


export type MutationPasswordResetArgs = {
  newPassword1: Scalars['String']['input'];
  newPassword2: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationRecoverApplicationArgs = {
  email: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};


export type MutationRefreshTokenArgs = {
  refreshToken: Scalars['String']['input'];
};


export type MutationRegisterArgs = {
  email: Scalars['String']['input'];
  password1: Scalars['String']['input'];
  password2: Scalars['String']['input'];
  securityQuestionAnswer: Scalars['String']['input'];
  securityQuestionQuestion: Scalars['String']['input'];
};


export type MutationRegisterWithConsentArgs = {
  consents: Array<InputMaybe<ConsentInput>>;
  email: Scalars['String']['input'];
  password1: Scalars['String']['input'];
  password2: Scalars['String']['input'];
  securityQuestionAnswer: Scalars['String']['input'];
  securityQuestionQuestion: Scalars['String']['input'];
};


export type MutationRemoveSecondaryEmailArgs = {
  password: Scalars['String']['input'];
};


export type MutationRequestDocumentArgs = {
  personId: Scalars['ID']['input'];
  requestedDocumentList: Array<InputMaybe<Scalars['String']['input']>>;
};


export type MutationRequestSingleDocumentArgs = {
  documentId: Scalars['ID']['input'];
  personId: Scalars['ID']['input'];
  retoolPassword?: InputMaybe<Scalars['String']['input']>;
};


export type MutationResendActivationEmailArgs = {
  email: Scalars['String']['input'];
};


export type MutationResendOnboardingEmailArgs = {
  personId: Scalars['ID']['input'];
};


export type MutationResetTranslationCacheArgs = {
  programId: Scalars['ID']['input'];
  retoolPassword?: InputMaybe<Scalars['String']['input']>;
};


export type MutationResolveApplicationArgs = {
  adminId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['String']['input'];
  retoolPassword?: InputMaybe<Scalars['String']['input']>;
  status: Scalars['String']['input'];
};


export type MutationRetoolAddSurveyPaymentArgs = {
  adminId: Scalars['ID']['input'];
  amount: Scalars['Decimal']['input'];
  retoolPassword: Scalars['String']['input'];
  userIds: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type MutationRetoolMakePaymentsArgs = {
  adminId: Scalars['ID']['input'];
  retoolPassword: Scalars['String']['input'];
  scheduledPaymentIds: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type MutationRetoolMovePaymentsToScheduledTaskArgs = {
  adminId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  retoolPassword: Scalars['String']['input'];
  scheduledPaymentIds: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type MutationRetoolPrintScheduledPaymentsArgs = {
  programId: Scalars['ID']['input'];
  retoolPassword: Scalars['String']['input'];
};


export type MutationRetoolRemovePaymentsFromScheduledTaskArgs = {
  adminId: Scalars['ID']['input'];
  paymentScheduledByTaskIds: Array<InputMaybe<Scalars['ID']['input']>>;
  retoolPassword: Scalars['String']['input'];
};


export type MutationRetoolRemoveScheduledPaymentArgs = {
  adminId: Scalars['ID']['input'];
  note: Scalars['String']['input'];
  retoolPassword: Scalars['String']['input'];
  scheduledPaymentId: Scalars['ID']['input'];
};


export type MutationRetoolRemoveTaskArgs = {
  adminId: Scalars['ID']['input'];
  retoolPassword: Scalars['String']['input'];
  taskId: Scalars['ID']['input'];
};


export type MutationRetoolTableImporterArgs = {
  programId: Scalars['ID']['input'];
  retoolPassword?: InputMaybe<Scalars['String']['input']>;
  retoolPersonId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationRetoolUpdateScheduledPaymentAmountsArgs = {
  adminId: Scalars['ID']['input'];
  newAmount: Scalars['Decimal']['input'];
  retoolPassword: Scalars['String']['input'];
  userEmail?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationRevokeTokenArgs = {
  refreshToken: Scalars['String']['input'];
};


export type MutationSaveHouseholdMembersArgs = {
  householdMembers: Array<HouseholdMemberInputType>;
  personId: Scalars['ID']['input'];
};


export type MutationSaveSixDigitVerificationCodeForPersonArgs = {
  personId: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};


export type MutationSelectBenefitsArgs = {
  benefits: Array<BenefitSelectedInputType>;
};


export type MutationSendAllEmailTemplatesArgs = {
  isEmail?: InputMaybe<Scalars['Boolean']['input']>;
  isSms?: InputMaybe<Scalars['Boolean']['input']>;
  personId: Scalars['ID']['input'];
  retoolPassword: Scalars['String']['input'];
};


export type MutationSendConfirmationArgs = {
  applicationDetailsId: Scalars['ID']['input'];
};


export type MutationSendDocumentReminderArgs = {
  personId: Scalars['ID']['input'];
  retoolPassword?: InputMaybe<Scalars['String']['input']>;
  templateName?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSendDocumentsUploadConfirmationArgs = {
  documentType?: InputMaybe<Scalars['String']['input']>;
  personId: Scalars['ID']['input'];
};


export type MutationSendOnboardingNotificationArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  programId: Scalars['String']['input'];
  retoolPassword?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSendOnboardingNotificationReminderArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  programId: Scalars['Int']['input'];
};


export type MutationSendPasswordResetEmailArgs = {
  email: Scalars['String']['input'];
};


export type MutationSendPrepaidCardEmailAndTextArgs = {
  retoolPassword: Scalars['String']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationSendResetPasswordEmailArgs = {
  password: Scalars['String']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationSendRetoolOnboardingInvitationArgs = {
  personId: Scalars['Int']['input'];
  programId: Scalars['Int']['input'];
  retoolPassword: Scalars['String']['input'];
};


export type MutationSendRetoolReportEmailArgs = {
  endDateString: Scalars['String']['input'];
  programId: Scalars['ID']['input'];
  retoolPassword: Scalars['String']['input'];
  startDateString: Scalars['String']['input'];
};


export type MutationSendSecondaryEmailActivationArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationSendSonomaOnboardingNotificationArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSendSupportEmailArgs = {
  userCategory: Scalars['String']['input'];
  userEmail?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  userMessage: Scalars['String']['input'];
  userName: Scalars['String']['input'];
};


export type MutationSendTextMessageArgs = {
  organizationId?: InputMaybe<Scalars['Int']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
  text: Scalars['String']['input'];
};


export type MutationSpeakBenefitsCounselorArgs = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  language: Scalars['String']['input'];
  personId: Scalars['ID']['input'];
  phoneNumber: Scalars['String']['input'];
};


export type MutationSwapEmailsArgs = {
  password: Scalars['String']['input'];
};


export type MutationTokenAuthArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
};


export type MutationTransferMethodAddBankAccountArgs = {
  accountPurpose: Scalars['String']['input'];
  addressLine1: Scalars['String']['input'];
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  bankAccountId: Scalars['String']['input'];
  branchId: Scalars['String']['input'];
  city: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  state: Scalars['String']['input'];
};


export type MutationTransferMethodAddPaypalArgs = {
  email: Scalars['String']['input'];
};


export type MutationTransferMethodAddPrepaidCardArgs = {
  addressLine1: Scalars['String']['input'];
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  inPersonPickup?: InputMaybe<Scalars['Boolean']['input']>;
  language: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  state: Scalars['String']['input'];
};


export type MutationTransferMethodAddVenmoArgs = {
  phoneNumber: Scalars['String']['input'];
};


export type MutationTransferMethodRemoveArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUpdateBenefitsScreeningDetailsArgs = {
  action?: InputMaybe<Scalars['String']['input']>;
  applicantEdits?: InputMaybe<Scalars['String']['input']>;
  applicationId?: InputMaybe<Scalars['ID']['input']>;
  benefitsAppointmentId?: InputMaybe<Scalars['ID']['input']>;
  benefitsScreeningId?: InputMaybe<Scalars['ID']['input']>;
  counselorId?: InputMaybe<Scalars['ID']['input']>;
  householdEdits?: InputMaybe<Scalars['String']['input']>;
  recommendation?: InputMaybe<Scalars['String']['input']>;
  retoolPassword: Scalars['String']['input'];
  scheduledDate?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateBlindDisabledArgs = {
  blindDisabled: Scalars['Boolean']['input'];
  inviteCode?: InputMaybe<Scalars['String']['input']>;
  verificationCode?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateConfigurationsArgs = {
  configurations: Scalars['JSONString']['input'];
};


export type MutationUpdateDetailsArgs = {
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  dob?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateDetailsFromRetoolArgs = {
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  dob?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  frozen?: InputMaybe<Scalars['Boolean']['input']>;
  invalidLoginAttempts?: InputMaybe<Scalars['Int']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  personIdHashed?: InputMaybe<Scalars['ID']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  retoolPassword?: InputMaybe<Scalars['String']['input']>;
  securityAnswer?: InputMaybe<Scalars['String']['input']>;
  securityQuestion?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  userIdHashed?: InputMaybe<Scalars['ID']['input']>;
  usioCardholderToken?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateHouseholdMemberArgs = {
  householdMemberData: HouseholdMemberInputType;
  householdMemberHashedId?: InputMaybe<Scalars['ID']['input']>;
  householdMemberIntId?: InputMaybe<Scalars['ID']['input']>;
  personId: Scalars['ID']['input'];
  retoolPassword?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateLanguageArgs = {
  language: Scalars['String']['input'];
};


export type MutationUpdatePersonEmailPhoneArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  personId: Scalars['Int']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  retoolPassword: Scalars['String']['input'];
};


export type MutationUpdateSettingsArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  emailNotificationsEnabled: Scalars['Boolean']['input'];
  optedForWhatsapp?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  smsNotificationsEnabled: Scalars['Boolean']['input'];
  transferMethodId: Scalars['ID']['input'];
};


export type MutationUpdateUserEmailPhoneArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  retoolPassword: Scalars['String']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationUpdateUserOrPersonArgs = {
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  personId?: InputMaybe<Scalars['Int']['input']>;
  retoolPassword: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUploadCsvArgs = {
  content: Scalars['String']['input'];
  retoolPassword: Scalars['String']['input'];
};


export type MutationUploadMutationArgs = {
  file?: InputMaybe<Scalars['Upload']['input']>;
  fileString?: InputMaybe<Scalars['String']['input']>;
  retoolPassword?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUploadPersonFromRetoolArgs = {
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  blindDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  dob?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  ethnicity?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['Int']['input'];
  paymentAmount?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  programId: Scalars['Int']['input'];
  researchId?: InputMaybe<Scalars['String']['input']>;
  retoolPassword: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  tractCode?: InputMaybe<Scalars['String']['input']>;
};


export type MutationVerifyAccountArgs = {
  token: Scalars['String']['input'];
};


export type MutationVerifySecondaryEmailArgs = {
  token: Scalars['String']['input'];
};


export type MutationVerifyTokenArgs = {
  token: Scalars['String']['input'];
};

/** An object with an ID */
export type Node = {
  /** The ID of the object. */
  id: Scalars['ID']['output'];
};

export type NoteType = {
  __typename?: 'NoteType';
  admin?: Maybe<UserType>;
  application: ApplicationDetailsType;
  benefitsCounselor?: Maybe<BenefitsCounselorType>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ObtainJsonWebTokenExtended = {
  __typename?: 'ObtainJSONWebTokenExtended';
  errors?: Maybe<Scalars['ExpectedErrorType']['output']>;
  refreshToken?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  unarchiving?: Maybe<Scalars['Boolean']['output']>;
  user?: Maybe<UserNode>;
};

export type OnboardingLogosType = Node & {
  __typename?: 'OnboardingLogosType';
  createdAt: Scalars['DateTime']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  image: Scalars['String']['output'];
  organization?: Maybe<OrganizationType>;
  position?: Maybe<Scalars['Int']['output']>;
  program?: Maybe<ProgramType>;
  updatedAt: Scalars['DateTime']['output'];
  url: Scalars['String']['output'];
};

export type OnboardingLogosTypeConnection = {
  __typename?: 'OnboardingLogosTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<OnboardingLogosTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `OnboardingLogosType` and its cursor. */
export type OnboardingLogosTypeEdge = {
  __typename?: 'OnboardingLogosTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<OnboardingLogosType>;
};

export type OrderReplacementCard = {
  __typename?: 'OrderReplacementCard';
  errorMessage?: Maybe<FieldErrorType>;
  success?: Maybe<Scalars['Boolean']['output']>;
  transferMethod?: Maybe<TransferMethodObjectType>;
};

export type OrganizationConfigsType = {
  __typename?: 'OrganizationConfigsType';
  facebookLink?: Maybe<Scalars['String']['output']>;
  gaMeasurementId?: Maybe<Scalars['String']['output']>;
  googleTagManagerId?: Maybe<Scalars['String']['output']>;
  instagramLink?: Maybe<Scalars['String']['output']>;
  isTypeformBound?: Maybe<Scalars['Boolean']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  pickupNotificationEmail?: Maybe<Scalars['String']['output']>;
  prepaidCardPickupLocations?: Maybe<Scalars['String']['output']>;
  replyToEmail?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  twitterLink?: Maybe<Scalars['String']['output']>;
  typeformId?: Maybe<Scalars['String']['output']>;
  typeformSubdomain?: Maybe<Scalars['String']['output']>;
  websiteLink?: Maybe<Scalars['String']['output']>;
  whatsappPhoneNumber?: Maybe<Scalars['String']['output']>;
};

export type OrganizationType = Node & {
  __typename?: 'OrganizationType';
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  version: Scalars['Int']['output'];
  webAppUrl: Scalars['String']['output'];
};

/** The Relay compliant `PageInfo` type, containing data necessary to paginate this connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PasswordChangeExtended = {
  __typename?: 'PasswordChangeExtended';
  errors?: Maybe<Scalars['ExpectedErrorType']['output']>;
  refreshToken?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  token?: Maybe<Scalars['String']['output']>;
};

export type PasswordResetExtended = {
  __typename?: 'PasswordResetExtended';
  errors?: Maybe<Scalars['ExpectedErrorType']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** An enumeration. */
export enum PaymentProfilePaymentFrequencyType {
  /** Bimonthly */
  Bimonthly = 'BIMONTHLY',
  /** Other */
  Other = 'OTHER',
  /** Quarterly */
  Quarterly = 'QUARTERLY',
  /** Yearly */
  Yearly = 'YEARLY'
}

export type PaymentProfileType = {
  __typename?: 'PaymentProfileType';
  createdAt: Scalars['DateTime']['output'];
  endDate?: Maybe<Scalars['DateTime']['output']>;
  frozen: Scalars['Boolean']['output'];
  hyperwalletToken?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  numberOfMonths?: Maybe<Scalars['Decimal']['output']>;
  numberOfPayments?: Maybe<Scalars['Decimal']['output']>;
  paymentAmount?: Maybe<Scalars['Decimal']['output']>;
  paymentFrequencyType?: Maybe<PaymentProfilePaymentFrequencyType>;
  scheduledPayments: ScheduledPaymentTypeConnection;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  transferMethods: TransferMethodObjectTypeConnection;
  updatedAt: Scalars['DateTime']['output'];
  user: UserType;
  usioToken?: Maybe<Scalars['String']['output']>;
};


export type PaymentProfileTypeScheduledPaymentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PaymentProfileTypeTransferMethodsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type PaymentScheduledByTaskType = Node & {
  __typename?: 'PaymentScheduledByTaskType';
  createdAt: Scalars['DateTime']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  scheduledPayment?: Maybe<ScheduledPaymentType>;
  task?: Maybe<ScheduledTaskType>;
  updatedAt: Scalars['DateTime']['output'];
};

export type PaymentScheduledByTaskTypeConnection = {
  __typename?: 'PaymentScheduledByTaskTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PaymentScheduledByTaskTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `PaymentScheduledByTaskType` and its cursor. */
export type PaymentScheduledByTaskTypeEdge = {
  __typename?: 'PaymentScheduledByTaskTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<PaymentScheduledByTaskType>;
};

/** An enumeration. */
export enum PaymentStatus {
  /** Cancelled */
  Cancelled = 'CANCELLED',
  /** Completed */
  Completed = 'COMPLETED',
  /** Created */
  Created = 'CREATED',
  /** Expired */
  Expired = 'EXPIRED',
  /** Failed */
  Failed = 'FAILED',
  /** Incorrect Funding Program */
  IncorrectFundingProgram = 'INCORRECT_FUNDING_PROGRAM',
  /** In Progress */
  InProgress = 'IN_PROGRESS',
  /** Pending */
  Pending = 'PENDING',
  /** Pending Account Activation */
  PendingAccountActivation = 'PENDING_ACCOUNT_ACTIVATION',
  /** Pending Id Verification */
  PendingIdVerification = 'PENDING_ID_VERIFICATION',
  /** Pending Tax Verification */
  PendingTaxVerification = 'PENDING_TAX_VERIFICATION',
  /** Pending Transaction Verification */
  PendingTransactionVerification = 'PENDING_TRANSACTION_VERIFICATION',
  /** Pending Transfer Method Action */
  PendingTransferMethodAction = 'PENDING_TRANSFER_METHOD_ACTION',
  /** Recalled */
  Recalled = 'RECALLED',
  /** Returned */
  Returned = 'RETURNED',
  /** Scheduled */
  Scheduled = 'SCHEDULED',
  /** Unclaimed */
  Unclaimed = 'UNCLAIMED'
}

export type PaymentType = Node & {
  __typename?: 'PaymentType';
  admin?: Maybe<UserType>;
  amount: Scalars['Decimal']['output'];
  createdAt: Scalars['DateTime']['output'];
  hyperwalletToken?: Maybe<Scalars['String']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  program: ProgramType;
  scheduledPayment?: Maybe<ScheduledPaymentType>;
  status: PaymentStatus;
  transferMethod: TransferMethodObjectType;
  updatedAt: Scalars['DateTime']['output'];
  user: UserType;
  usioToken?: Maybe<Scalars['String']['output']>;
};

export type PaymentTypeConnection = {
  __typename?: 'PaymentTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PaymentTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `PaymentType` and its cursor. */
export type PaymentTypeEdge = {
  __typename?: 'PaymentTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<PaymentType>;
};

export type PaymentWithTransferMethodType = {
  __typename?: 'PaymentWithTransferMethodType';
  lastTransferMethodUpdate?: Maybe<Scalars['DateTime']['output']>;
  payment?: Maybe<PaymentType>;
};

export type PersonFlagType = Node & {
  __typename?: 'PersonFlagType';
  application?: Maybe<ApplicationDetailsType>;
  createdAt: Scalars['DateTime']['output'];
  flagType: FlagsFlagType;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  inactive: Scalars['Boolean']['output'];
  matchedPerson?: Maybe<PersonType>;
  person?: Maybe<PersonType>;
  pk?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type PersonFlagTypeConnection = {
  __typename?: 'PersonFlagTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PersonFlagTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `PersonFlagType` and its cursor. */
export type PersonFlagTypeEdge = {
  __typename?: 'PersonFlagTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<PersonFlagType>;
};

export type PersonType = Node & {
  __typename?: 'PersonType';
  applicationDetail?: Maybe<ApplicationDetailsType>;
  applicationDetails?: Maybe<Array<Maybe<ApplicationDetailsType>>>;
  benefitAnswers: BenefitAnswerTypeConnection;
  cbo?: Maybe<Scalars['String']['output']>;
  communicationSetting?: Maybe<CommunicationSettingType>;
  communicationSettings: Array<CommunicationSettingType>;
  createdAt: Scalars['DateTime']['output'];
  documents: DocumentTypeConnection;
  filter?: Maybe<Scalars['String']['output']>;
  flags: PersonFlagTypeConnection;
  flagsPerson: PersonFlagTypeConnection;
  householdMembers: Array<HouseholdMemberType>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  intercomKey?: Maybe<Scalars['String']['output']>;
  invitation?: Maybe<Array<Maybe<InvitationType>>>;
  invitations: Array<InvitationType>;
  language?: Maybe<Scalars['String']['output']>;
  locationDetail?: Maybe<LocationDetailsType>;
  locationDetails: Array<LocationDetailsType>;
  notes?: Maybe<Scalars['String']['output']>;
  pk?: Maybe<Scalars['Int']['output']>;
  policyEngine: Array<PolicyEngineType>;
  profile?: Maybe<ProfileType>;
  profileData?: Maybe<ProfileType>;
  researchId?: Maybe<Scalars['String']['output']>;
  selectedBenefits: BenefitSelectedTypeConnection;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<UserType>;
  users: UserTypeConnection;
};


export type PersonTypeBenefitAnswersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PersonTypeDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PersonTypeFlagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PersonTypeFlagsPersonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PersonTypeSelectedBenefitsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PersonTypeUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  email_Icontains?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type PersonTypeConnection = {
  __typename?: 'PersonTypeConnection';
  edgeCount?: Maybe<Scalars['Int']['output']>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PersonTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `PersonType` and its cursor. */
export type PersonTypeEdge = {
  __typename?: 'PersonTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<PersonType>;
};

export type PolicyEngineType = {
  __typename?: 'PolicyEngineType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  person: PersonType;
  result?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  withGi: Scalars['JSONString']['output'];
  withoutGi: Scalars['JSONString']['output'];
};

export type ProfileType = {
  __typename?: 'ProfileType';
  blindDisabled?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  dob?: Maybe<Scalars['String']['output']>;
  earnedIncome?: Maybe<Scalars['String']['output']>;
  ethnicity?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  language?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  medianHouseholdIncome?: Maybe<Scalars['Decimal']['output']>;
  person: PersonType;
  pk?: Maybe<Scalars['Int']['output']>;
  unearnedIncome?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ProgramApplicationAnswerType = Node & {
  __typename?: 'ProgramApplicationAnswerType';
  application: ApplicationDetailsType;
  category: ApplicationAnswersCategory;
  createdAt: Scalars['DateTime']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  pk?: Maybe<Scalars['Int']['output']>;
  response: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ProgramApplicationAnswerTypeConnection = {
  __typename?: 'ProgramApplicationAnswerTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ProgramApplicationAnswerTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ProgramApplicationAnswerType` and its cursor. */
export type ProgramApplicationAnswerTypeEdge = {
  __typename?: 'ProgramApplicationAnswerTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ProgramApplicationAnswerType>;
};

export type ProgramPaymentData = {
  __typename?: 'ProgramPaymentData';
  error?: Maybe<Scalars['String']['output']>;
  programName?: Maybe<Scalars['String']['output']>;
  scheduledPaymentsCount?: Maybe<Scalars['Int']['output']>;
  upcomingPaymentsCount?: Maybe<Scalars['Int']['output']>;
};

/** An enumeration. */
export enum ProgramPaymentFrequency {
  /** Bimonthly */
  Bimonthly = 'BIMONTHLY',
  /** Other */
  Other = 'OTHER',
  /** Quarterly */
  Quarterly = 'QUARTERLY',
  /** Yearly */
  Yearly = 'YEARLY'
}

export type ProgramType = Node & {
  __typename?: 'ProgramType';
  addressAutocompleteLocationRestriction?: Maybe<Scalars['String']['output']>;
  applicationDetails: ApplicationDetailsTypeConnection;
  applicationEndDate: Scalars['DateTime']['output'];
  applicationHouseholdIncome?: Maybe<Scalars['Decimal']['output']>;
  applicationHouseholdIncomeThreshold?: Maybe<Scalars['Decimal']['output']>;
  applicationStartDate: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  documentRequirement: DocumentRequireTypeConnection;
  endDate: Scalars['DateTime']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  invitations: Array<InvitationType>;
  isActiveProgram: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  numberOfMonths?: Maybe<Scalars['Decimal']['output']>;
  numberOfPayments?: Maybe<Scalars['Decimal']['output']>;
  onboardingLogos: OnboardingLogosTypeConnection;
  organization: OrganizationType;
  paymentAmount: Scalars['Decimal']['output'];
  paymentFrequency: ProgramPaymentFrequency;
  payments: PaymentTypeConnection;
  pk?: Maybe<Scalars['Int']['output']>;
  programDuration: Scalars['JSONString']['output'];
  programEndingEmail?: Maybe<Scalars['String']['output']>;
  programStyles: StylesTypeConnection;
  reportEmail?: Maybe<Scalars['String']['output']>;
  retoolImportedPersons: RetoolImportedPersonTypeConnection;
  scheduledPayments: ScheduledPaymentTypeConnection;
  scheduledTask: ScheduledTaskTypeConnection;
  ssiBenefitsWizardEnabled: Scalars['Boolean']['output'];
  startDate: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  urlFragment: Scalars['String']['output'];
  users: UserTypeConnection;
};


export type ProgramTypeApplicationDetailsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ProgramTypeDocumentRequirementArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ProgramTypeOnboardingLogosArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ProgramTypePaymentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ProgramTypeProgramStylesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ProgramTypeRetoolImportedPersonsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ProgramTypeScheduledPaymentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ProgramTypeScheduledTaskArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ProgramTypeUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  email_Icontains?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type Query = {
  __typename?: 'Query';
  addressAutocomplete?: Maybe<Array<Maybe<AddressAutocomplete>>>;
  addressDetails?: Maybe<AddressDetails>;
  addressValidation?: Maybe<AddressValidation>;
  adminNotes?: Maybe<Array<NoteType>>;
  allBenefitsScreenings?: Maybe<Array<Maybe<BenefitsScreeningType>>>;
  allHealthCheckData?: Maybe<Array<Maybe<HealthCheckData>>>;
  allScheduledTasksAndPayments?: Maybe<Array<Maybe<ScheduledTaskType>>>;
  allUserAnswers?: Maybe<Array<Maybe<ProgramApplicationAnswerType>>>;
  applicationLogs?: Maybe<Array<LogType>>;
  applicationsForBenefitsCounselorApp?: Maybe<Array<Maybe<ApplicationDetailsType>>>;
  benefitsAnswers?: Maybe<Array<Maybe<BenefitAnswerType>>>;
  benefitsScreeners?: Maybe<Array<Maybe<BenefitsScreeningType>>>;
  benefitsScreeningById?: Maybe<BenefitsScreeningType>;
  cardBalance?: Maybe<Scalars['Float']['output']>;
  codeValidation?: Maybe<InviteCodeValidationQueryResponse>;
  configurationsJson?: Maybe<Scalars['JSONString']['output']>;
  consentTypes?: Maybe<Array<Maybe<ConsentTypeType>>>;
  counselorsForBenefitsScreeningApp?: Maybe<Array<Maybe<BenefitsCounselorType>>>;
  countHouseholdMembers?: Maybe<Scalars['Float']['output']>;
  document?: Maybe<DocumentData>;
  documentRequirement?: Maybe<Array<Maybe<DocumentRequireType>>>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  healthCheckData?: Maybe<HealthCheckData>;
  languages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listOfUploadedDocuments?: Maybe<Scalars['ID']['output']>;
  listOfUploadedDocumentsIncludingName?: Maybe<Array<Maybe<DocumentType>>>;
  me?: Maybe<UserType>;
  myLastPayment?: Maybe<ScheduledPaymentType>;
  myRecentPayments?: Maybe<Array<Maybe<PaymentType>>>;
  myUpcomingPayment?: Maybe<ScheduledPaymentType>;
  myUpcomingScheduledPayments?: Maybe<Array<Maybe<ScheduledPaymentType>>>;
  nextPaymentDate?: Maybe<Scalars['String']['output']>;
  ninjaWizardData?: Maybe<FaqNinjaWizardType>;
  notSignedUpPersons?: Maybe<PersonTypeConnection>;
  onboardingLogos?: Maybe<Array<Maybe<OnboardingLogosType>>>;
  organization?: Maybe<OrganizationType>;
  organizationConfigs?: Maybe<OrganizationConfigsType>;
  paymentsWithTransferUpdates?: Maybe<Array<Maybe<PaymentWithTransferMethodType>>>;
  personApplication?: Maybe<PersonType>;
  personForRetool?: Maybe<PersonType>;
  personWithHashedId?: Maybe<PersonType>;
  persons?: Maybe<PersonTypeConnection>;
  personsForOnboardingNotifications?: Maybe<Array<Maybe<PersonType>>>;
  policyEngineData?: Maybe<PolicyEngineType>;
  program?: Maybe<ProgramType>;
  programs?: Maybe<Array<Maybe<ProgramType>>>;
  retoolConfigurationsJson?: Maybe<ConfigurationData>;
  retoolImportedPersons?: Maybe<RetoolImportedPersonTypeConnection>;
  retoolProjectedUsersCount?: Maybe<Scalars['Int']['output']>;
  scheduledEvent?: Maybe<CalendlyEventType>;
  scheduledPaymentsById?: Maybe<ScheduledPaymentType>;
  selectedBenefits?: Maybe<Array<Maybe<BenefitSelectedType>>>;
  styles?: Maybe<StylesType>;
  surveyAvailable?: Maybe<Scalars['Boolean']['output']>;
  surveySummary?: Maybe<SurveySummary>;
  templateAdvancedCsv?: Maybe<Scalars['String']['output']>;
  templateCsv?: Maybe<Scalars['String']['output']>;
  transactionDetails?: Maybe<Array<Maybe<TransactionDetailsTypeQuery>>>;
  transactionDetailsPortal?: Maybe<Array<Maybe<TransactionDetailsTypeQueryPortal>>>;
  translations?: Maybe<Scalars['JSONString']['output']>;
  upcomingPaymentsData?: Maybe<Array<Maybe<ProgramPaymentData>>>;
  upcomingScheduledPayments?: Maybe<Array<Maybe<ScheduledPaymentType>>>;
  user?: Maybe<UserType>;
  userAnswers?: Maybe<ProgramApplicationAnswerType>;
  userByEmailAddress?: Maybe<UserType>;
  userForRetool?: Maybe<UserType>;
  users?: Maybe<Array<Maybe<UserType>>>;
  usioCardBalanceForRetool?: Maybe<Scalars['Float']['output']>;
  usioCardBalanceForUserForRetool?: Maybe<Scalars['Float']['output']>;
};


export type QueryAddressAutocompleteArgs = {
  value?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAddressDetailsArgs = {
  placeId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAddressValidationArgs = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdminNotesArgs = {
  application?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAllBenefitsScreeningsArgs = {
  programId: Scalars['String']['input'];
  retoolPassword: Scalars['String']['input'];
};


export type QueryAllHealthCheckDataArgs = {
  retoolPassword?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllScheduledTasksAndPaymentsArgs = {
  programId: Scalars['ID']['input'];
  retoolPassword: Scalars['String']['input'];
};


export type QueryAllUserAnswersArgs = {
  applicationId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryApplicationLogsArgs = {
  benefitsScreeningId: Scalars['ID']['input'];
  entityType: Scalars['String']['input'];
  outreachType?: InputMaybe<Scalars['String']['input']>;
  retoolPassword: Scalars['String']['input'];
};


export type QueryApplicationsForBenefitsCounselorAppArgs = {
  programId: Scalars['ID']['input'];
  retoolPassword: Scalars['String']['input'];
};


export type QueryBenefitsAnswersArgs = {
  personId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryBenefitsScreenersArgs = {
  counselorId: Scalars['ID']['input'];
  retoolPassword: Scalars['String']['input'];
};


export type QueryBenefitsScreeningByIdArgs = {
  benefitsScreeningId: Scalars['ID']['input'];
  retoolPassword: Scalars['String']['input'];
};


export type QueryCardBalanceArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCodeValidationArgs = {
  inviteCode?: InputMaybe<Scalars['String']['input']>;
  resetToken?: InputMaybe<Scalars['String']['input']>;
  verificationCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCounselorsForBenefitsScreeningAppArgs = {
  retoolPassword: Scalars['String']['input'];
};


export type QueryCountHouseholdMembersArgs = {
  personId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryDocumentArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  retoolPassword?: InputMaybe<Scalars['String']['input']>;
};


export type QueryHealthCheckDataArgs = {
  programId?: InputMaybe<Scalars['ID']['input']>;
  retoolPassword?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryListOfUploadedDocumentsArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryListOfUploadedDocumentsIncludingNameArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryNextPaymentDateArgs = {
  programId: Scalars['ID']['input'];
  retoolPassword: Scalars['String']['input'];
};


export type QueryNinjaWizardDataArgs = {
  language?: InputMaybe<Scalars['String']['input']>;
};


export type QueryNotSignedUpPersonsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  assignedAdmin?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  invitations_InvitationSent?: InputMaybe<Scalars['DateTime']['input']>;
  invitations_InvitationSent_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  invitations_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  isLocked?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['JSONString']['input']>;
  selectedFor_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryOnboardingLogosArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPaymentsWithTransferUpdatesArgs = {
  programId: Scalars['ID']['input'];
  retoolPassword: Scalars['String']['input'];
};


export type QueryPersonApplicationArgs = {
  applicationId?: InputMaybe<Scalars['String']['input']>;
  inviteCode?: InputMaybe<Scalars['String']['input']>;
  verificationCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPersonForRetoolArgs = {
  personId: Scalars['Int']['input'];
  retoolPassword: Scalars['String']['input'];
};


export type QueryPersonWithHashedIdArgs = {
  hashedId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPersonsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  assignedAdmin?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  invitations_InvitationSent?: InputMaybe<Scalars['DateTime']['input']>;
  invitations_InvitationSent_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  invitations_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  isLocked?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  retoolPassword?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['JSONString']['input']>;
  selectedFor_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPersonsForOnboardingNotificationsArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  reminder?: InputMaybe<Scalars['Boolean']['input']>;
  retoolPassword?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPolicyEngineDataArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryRetoolConfigurationsJsonArgs = {
  programId?: InputMaybe<Scalars['ID']['input']>;
  retoolPassword?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRetoolImportedPersonsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  applicationStatus?: InputMaybe<RetoolImportedPersonApplicationStatus>;
  applicationStatus_Contains?: InputMaybe<RetoolImportedPersonApplicationStatus>;
  applicationStatus_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  assignedAdmin?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  invitationSent?: InputMaybe<Scalars['DateTime']['input']>;
  invitationSent_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  inviteCode_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  isLocked?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  programIdHashed?: InputMaybe<Scalars['ID']['input']>;
  retoolPassword?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['JSONString']['input']>;
  selectedFor_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryRetoolProjectedUsersCountArgs = {
  programId?: InputMaybe<Scalars['ID']['input']>;
  retoolPassword?: InputMaybe<Scalars['String']['input']>;
};


export type QueryScheduledEventArgs = {
  personId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryScheduledPaymentsByIdArgs = {
  programId: Scalars['ID']['input'];
  retoolPassword: Scalars['String']['input'];
  upcomingId: Scalars['ID']['input'];
};


export type QuerySelectedBenefitsArgs = {
  personId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryTemplateAdvancedCsvArgs = {
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  programId: Scalars['ID']['input'];
  retoolPassword: Scalars['String']['input'];
};


export type QueryTemplateCsvArgs = {
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  programId: Scalars['ID']['input'];
  retoolPassword: Scalars['String']['input'];
};


export type QueryTransactionDetailsArgs = {
  retoolPassword: Scalars['String']['input'];
  transferMethodId: Scalars['ID']['input'];
};


export type QueryUpcomingPaymentsDataArgs = {
  retoolPassword?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUpcomingScheduledPaymentsArgs = {
  programId: Scalars['ID']['input'];
  retoolPassword: Scalars['String']['input'];
};


export type QueryUserArgs = {
  cacheType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryUserAnswersArgs = {
  forType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryUserByEmailAddressArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  retoolPassword?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUserForRetoolArgs = {
  retoolPassword: Scalars['String']['input'];
  userId: Scalars['Int']['input'];
};


export type QueryUsioCardBalanceForRetoolArgs = {
  retoolPassword: Scalars['String']['input'];
  transferMethodId: Scalars['Int']['input'];
};


export type QueryUsioCardBalanceForUserForRetoolArgs = {
  retoolPassword: Scalars['String']['input'];
  userId: Scalars['Int']['input'];
};

export type RecoverApplication = {
  __typename?: 'RecoverApplication';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

/** Same as `grapgql_jwt` implementation, with standard output. */
export type RefreshToken = {
  __typename?: 'RefreshToken';
  errors?: Maybe<Scalars['ExpectedErrorType']['output']>;
  payload?: Maybe<Scalars['GenericScalar']['output']>;
  refreshToken?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  token?: Maybe<Scalars['String']['output']>;
};

export type RegisterExtended = {
  __typename?: 'RegisterExtended';
  errors?: Maybe<Scalars['ExpectedErrorType']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Extended registration mutation that handles consent requirements.
 * Validates that all required consents are provided before creating the user.
 */
export type RegisterWithConsent = {
  __typename?: 'RegisterWithConsent';
  errors?: Maybe<Scalars['GenericScalar']['output']>;
  password?: Maybe<Scalars['GenericScalar']['output']>;
  password2?: Maybe<Scalars['GenericScalar']['output']>;
  refreshToken?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  token?: Maybe<Scalars['String']['output']>;
};

/**
 * Remove user secondary email.
 *
 * Require password confirmation.
 */
export type RemoveSecondaryEmail = {
  __typename?: 'RemoveSecondaryEmail';
  errors?: Maybe<Scalars['ExpectedErrorType']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type RequestDocument = {
  __typename?: 'RequestDocument';
  documentRequestSuccess?: Maybe<Scalars['Boolean']['output']>;
};

export type RequestSingleDocument = {
  __typename?: 'RequestSingleDocument';
  errorMessage?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Sends activation email.
 *
 * It is called resend because theoretically
 * the first activation email was sent when
 * the user registered.
 *
 * If there is no user with the requested email,
 * a successful response is returned.
 */
export type ResendActivationEmail = {
  __typename?: 'ResendActivationEmail';
  errors?: Maybe<Scalars['ExpectedErrorType']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ResendOnboardingEmail = {
  __typename?: 'ResendOnboardingEmail';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ResendPrepaidCardEmailAndTextMessage = {
  __typename?: 'ResendPrepaidCardEmailAndTextMessage';
  errorMessage?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ResetTranslationsCache = {
  __typename?: 'ResetTranslationsCache';
  errorMessage?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ResolveApplication = {
  __typename?: 'ResolveApplication';
  errorMessage?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type RetoolAddSurveyPayment = {
  __typename?: 'RetoolAddSurveyPayment';
  results?: Maybe<Array<Maybe<SurveyPaymentResult>>>;
};

export type RetoolAssignCounselorToBenefitsScreeningMutation = {
  __typename?: 'RetoolAssignCounselorToBenefitsScreeningMutation';
  errorMessage?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type RetoolChangeProjectedUsersCount = {
  __typename?: 'RetoolChangeProjectedUsersCount';
  errorMessage?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type RetoolFreezeUser = {
  __typename?: 'RetoolFreezeUser';
  errorMessage?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type RetoolHandleDroppedApplications = {
  __typename?: 'RetoolHandleDroppedApplications';
  errorMessage?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** An enumeration. */
export enum RetoolImportedPersonApplicationStatus {
  /** Approved */
  Approved = 'APPROVED',
  /** Rejected */
  Rejected = 'REJECTED'
}

/** An enumeration. */
export enum RetoolImportedPersonPaymentFrequencyType {
  /** Bimonthly */
  Bimonthly = 'BIMONTHLY',
  /** Other */
  Other = 'OTHER',
  /** Quarterly */
  Quarterly = 'QUARTERLY',
  /** Yearly */
  Yearly = 'YEARLY'
}

export type RetoolImportedPersonType = Node & {
  __typename?: 'RetoolImportedPersonType';
  addressLat?: Maybe<Scalars['String']['output']>;
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  addressLng?: Maybe<Scalars['String']['output']>;
  applicationStatus?: Maybe<RetoolImportedPersonApplicationStatus>;
  assignedAdmin?: Maybe<UserType>;
  blindDisabled?: Maybe<Scalars['Boolean']['output']>;
  cbo?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  dob?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  endDate?: Maybe<Scalars['DateTime']['output']>;
  ethnicity?: Maybe<Scalars['String']['output']>;
  filter?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  hyperwalletToken?: Maybe<Scalars['String']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  intercomKey?: Maybe<Scalars['String']['output']>;
  invitationReminderSent?: Maybe<Scalars['DateTime']['output']>;
  invitationSent?: Maybe<Scalars['DateTime']['output']>;
  inviteCode?: Maybe<Scalars['String']['output']>;
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  isSuperuser: Scalars['Boolean']['output'];
  isTestUser: Scalars['Boolean']['output'];
  language?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  medianHouseholdIncome?: Maybe<Scalars['Decimal']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  numberOfMonths?: Maybe<Scalars['Decimal']['output']>;
  numberOfPayments?: Maybe<Scalars['Decimal']['output']>;
  onboardingNotificationSent?: Maybe<Scalars['DateTime']['output']>;
  onboardingReminderNotificationSent?: Maybe<Scalars['DateTime']['output']>;
  organization?: Maybe<OrganizationType>;
  paymentAmount?: Maybe<Scalars['Decimal']['output']>;
  paymentFrequencyType?: Maybe<RetoolImportedPersonPaymentFrequencyType>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  pk?: Maybe<Scalars['Int']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  program?: Maybe<ProgramType>;
  reachedVerifyScreen?: Maybe<Scalars['Boolean']['output']>;
  requestedBenefitsCounseling?: Maybe<Scalars['DateTime']['output']>;
  researchId?: Maybe<Scalars['String']['output']>;
  resetUserOnLogout: Scalars['Boolean']['output'];
  selectedFor?: Maybe<Scalars['String']['output']>;
  startDate: Scalars['DateTime']['output'];
  state?: Maybe<Scalars['String']['output']>;
  tractCode?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  verifyInvitationReminderSent?: Maybe<Scalars['DateTime']['output']>;
  verifyInvitationSent?: Maybe<Scalars['DateTime']['output']>;
};

export type RetoolImportedPersonTypeConnection = {
  __typename?: 'RetoolImportedPersonTypeConnection';
  edgeCount?: Maybe<Scalars['Int']['output']>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<RetoolImportedPersonTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `RetoolImportedPersonType` and its cursor. */
export type RetoolImportedPersonTypeEdge = {
  __typename?: 'RetoolImportedPersonTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<RetoolImportedPersonType>;
};

export type RetoolLogBenefitsCounselingOutreach = {
  __typename?: 'RetoolLogBenefitsCounselingOutreach';
  errorMessage?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type RetoolMakePayments = {
  __typename?: 'RetoolMakePayments';
  errorMessage?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type RetoolMovePaymentsToScheduledTask = {
  __typename?: 'RetoolMovePaymentsToScheduledTask';
  errorMessage?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type RetoolPrintScheduledPayments = {
  __typename?: 'RetoolPrintScheduledPayments';
  errorMessage?: Maybe<Scalars['String']['output']>;
  scheduledPayments?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  settingsUsed?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type RetoolRemovePaymentsFromScheduledTask = {
  __typename?: 'RetoolRemovePaymentsFromScheduledTask';
  errorMessage?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type RetoolRemoveScheduledPayment = {
  __typename?: 'RetoolRemoveScheduledPayment';
  errorMessage?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type RetoolRemoveTask = {
  __typename?: 'RetoolRemoveTask';
  errorMessage?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type RetoolTableImporterMutation = {
  __typename?: 'RetoolTableImporterMutation';
  errorMessage?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type RetoolUpdateApplicationNotes = {
  __typename?: 'RetoolUpdateApplicationNotes';
  errorMessage?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type RetoolUpdateBenefitsScreeningDetails = {
  __typename?: 'RetoolUpdateBenefitsScreeningDetails';
  errorMessage?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type RetoolUpdatePerson = {
  __typename?: 'RetoolUpdatePerson';
  errorMessage?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type RetoolUpdateScheduledPaymentAmounts = {
  __typename?: 'RetoolUpdateScheduledPaymentAmounts';
  result?: Maybe<UpdateScheduledPaymentAmountsResult>;
};

export type RetoolUpdateUser = {
  __typename?: 'RetoolUpdateUser';
  errorMessage?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type RetoolUpdateUserOrPersonAddress = {
  __typename?: 'RetoolUpdateUserOrPersonAddress';
  errorMessage?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Same as `grapgql_jwt` implementation, with standard output. */
export type RevokeToken = {
  __typename?: 'RevokeToken';
  errors?: Maybe<Scalars['ExpectedErrorType']['output']>;
  revoked?: Maybe<Scalars['Int']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SaveHouseholdMembers = {
  __typename?: 'SaveHouseholdMembers';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SaveSixDigitVerificationCodeForPerson = {
  __typename?: 'SaveSixDigitVerificationCodeForPerson';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ScheduledPaymentType = Node & {
  __typename?: 'ScheduledPaymentType';
  admin?: Maybe<UserType>;
  amount: Scalars['Decimal']['output'];
  createdAt: Scalars['DateTime']['output'];
  extraPayment: Scalars['Boolean']['output'];
  fulfillmentPayment?: Maybe<PaymentType>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  localScheduledDate: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  paymentProfile?: Maybe<PaymentProfileType>;
  payments: PaymentTypeConnection;
  pending: Scalars['Boolean']['output'];
  program: ProgramType;
  scheduledDate: Scalars['DateTime']['output'];
  taskScheduledPayments: PaymentScheduledByTaskTypeConnection;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<UserType>;
};


export type ScheduledPaymentTypePaymentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ScheduledPaymentTypeTaskScheduledPaymentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ScheduledPaymentTypeConnection = {
  __typename?: 'ScheduledPaymentTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ScheduledPaymentTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ScheduledPaymentType` and its cursor. */
export type ScheduledPaymentTypeEdge = {
  __typename?: 'ScheduledPaymentTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ScheduledPaymentType>;
};

export type ScheduledTaskType = Node & {
  __typename?: 'ScheduledTaskType';
  admin?: Maybe<UserType>;
  amount: Scalars['Decimal']['output'];
  completed: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  paymentScheduledByTasks?: Maybe<Array<Maybe<PaymentScheduledByTaskType>>>;
  pending: Scalars['Boolean']['output'];
  program?: Maybe<ProgramType>;
  runTime: Scalars['DateTime']['output'];
  sent2dayMessage: Scalars['Boolean']['output'];
  sentMessage: Scalars['Boolean']['output'];
  tasks: PaymentScheduledByTaskTypeConnection;
  updatedAt: Scalars['DateTime']['output'];
};


export type ScheduledTaskTypeTasksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ScheduledTaskTypeConnection = {
  __typename?: 'ScheduledTaskTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ScheduledTaskTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ScheduledTaskType` and its cursor. */
export type ScheduledTaskTypeEdge = {
  __typename?: 'ScheduledTaskTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ScheduledTaskType>;
};

export type SelectBenefits = {
  __typename?: 'SelectBenefits';
  error?: Maybe<Scalars['String']['output']>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type SendAllEmailTemplates = {
  __typename?: 'SendAllEmailTemplates';
  errorMessage?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SendConfirmation = {
  __typename?: 'SendConfirmation';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type SendDocumentReminder = {
  __typename?: 'SendDocumentReminder';
  errorMessage?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SendDocumentsUploadConfirmation = {
  __typename?: 'SendDocumentsUploadConfirmation';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type SendOnboardingNotification = {
  __typename?: 'SendOnboardingNotification';
  errorMessage?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SendOnboardingNotificationReminder = {
  __typename?: 'SendOnboardingNotificationReminder';
  success?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Send password reset email.
 *
 * For non verified users, send an activation
 * email instead.
 *
 * Accepts both primary and secondary email.
 *
 * If there is no user with the requested email,
 * a successful response is returned.
 */
export type SendPasswordResetEmail = {
  __typename?: 'SendPasswordResetEmail';
  errors?: Maybe<Scalars['ExpectedErrorType']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SendResetPasswordEmail = {
  __typename?: 'SendResetPasswordEmail';
  errorMessage?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SendRetoolOnboardingInvitation = {
  __typename?: 'SendRetoolOnboardingInvitation';
  errorMessage?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SendRetoolReportEmail = {
  __typename?: 'SendRetoolReportEmail';
  errorMessage?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Send activation to secondary email.
 *
 * User must be verified and confirm password.
 */
export type SendSecondaryEmailActivation = {
  __typename?: 'SendSecondaryEmailActivation';
  errors?: Maybe<Scalars['ExpectedErrorType']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SendSonomaOnboardingNotification = {
  __typename?: 'SendSonomaOnboardingNotification';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SendSupportEmail = {
  __typename?: 'SendSupportEmail';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SendTextMessage = {
  __typename?: 'SendTextMessage';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SpeakBenefitsCounselor = {
  __typename?: 'SpeakBenefitsCounselor';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type StylesType = Node & {
  __typename?: 'StylesType';
  backgroundColor: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  hoverColor: Scalars['String']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  languageSwitcherActiveColor?: Maybe<Scalars['String']['output']>;
  languageSwitcherInactiveColor?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<OrganizationType>;
  primaryColor: Scalars['String']['output'];
  program?: Maybe<ProgramType>;
  secondaryColor: Scalars['String']['output'];
  sidebarImage: Scalars['String']['output'];
  sidebarLogo: Scalars['String']['output'];
  sidebarLogoMobile: Scalars['String']['output'];
  tertiaryColor: Scalars['String']['output'];
  textColor?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type StylesTypeConnection = {
  __typename?: 'StylesTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<StylesTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `StylesType` and its cursor. */
export type StylesTypeEdge = {
  __typename?: 'StylesTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<StylesType>;
};

export type SurveyPaymentResult = {
  __typename?: 'SurveyPaymentResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  scheduledPayment?: Maybe<ScheduledPaymentType>;
  success?: Maybe<Scalars['Boolean']['output']>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export type SurveySummary = {
  __typename?: 'SurveySummary';
  completed?: Maybe<Array<Maybe<UserType>>>;
  notCompleted?: Maybe<Array<Maybe<UserType>>>;
  submittedAt?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/**
 * Swap between primary and secondary emails.
 *
 * Require password confirmation.
 */
export type SwapEmails = {
  __typename?: 'SwapEmails';
  errors?: Maybe<Scalars['ExpectedErrorType']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type TransactionDetailsTypeQuery = {
  __typename?: 'TransactionDetailsTypeQuery';
  amount?: Maybe<Scalars['Float']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  fromCardId?: Maybe<Scalars['String']['output']>;
  mcc?: Maybe<Scalars['String']['output']>;
  merchantDescription?: Maybe<Scalars['String']['output']>;
  newBalance?: Maybe<Scalars['String']['output']>;
  pending?: Maybe<Scalars['String']['output']>;
  procCode?: Maybe<Scalars['String']['output']>;
  toCardId?: Maybe<Scalars['String']['output']>;
  transactionType?: Maybe<Scalars['String']['output']>;
  trxId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type TransactionDetailsTypeQueryPortal = {
  __typename?: 'TransactionDetailsTypeQueryPortal';
  amount?: Maybe<Scalars['Float']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  fromCardId?: Maybe<Scalars['String']['output']>;
  mcc?: Maybe<Scalars['String']['output']>;
  merchantDescription?: Maybe<Scalars['String']['output']>;
  newBalance?: Maybe<Scalars['String']['output']>;
  pending?: Maybe<Scalars['String']['output']>;
  procCode?: Maybe<Scalars['String']['output']>;
  toCardId?: Maybe<Scalars['String']['output']>;
  transactionType?: Maybe<Scalars['String']['output']>;
  trxId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type TransferMethodAddBankAccount = {
  __typename?: 'TransferMethodAddBankAccount';
  error?: Maybe<FieldErrorType>;
  errorLabel?: Maybe<FieldErrorType>;
  user?: Maybe<UserType>;
};

export type TransferMethodAddPaypal = {
  __typename?: 'TransferMethodAddPaypal';
  error?: Maybe<FieldErrorType>;
  user?: Maybe<UserType>;
};

export type TransferMethodAddPrepaidCard = {
  __typename?: 'TransferMethodAddPrepaidCard';
  error?: Maybe<FieldErrorType>;
  user?: Maybe<UserType>;
};

export type TransferMethodAddVenmo = {
  __typename?: 'TransferMethodAddVenmo';
  error?: Maybe<FieldErrorType>;
  user?: Maybe<UserType>;
};

export type TransferMethodObjectType = Node & {
  __typename?: 'TransferMethodObjectType';
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deleted: Scalars['Boolean']['output'];
  halfLiner: Scalars['String']['output'];
  hyperwalletToken?: Maybe<Scalars['String']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  inPersonPickup: Scalars['Boolean']['output'];
  isCurrentMethod: Scalars['Boolean']['output'];
  oneLiner: Scalars['String']['output'];
  paymentProfile?: Maybe<PaymentProfileType>;
  payments: PaymentTypeConnection;
  state?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['String']['output']>;
  type: TransferMethodType;
  updatedAt: Scalars['DateTime']['output'];
  usioToken?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};


export type TransferMethodObjectTypePaymentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type TransferMethodObjectTypeConnection = {
  __typename?: 'TransferMethodObjectTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TransferMethodObjectTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `TransferMethodObjectType` and its cursor. */
export type TransferMethodObjectTypeEdge = {
  __typename?: 'TransferMethodObjectTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<TransferMethodObjectType>;
};

export type TransferMethodRemove = {
  __typename?: 'TransferMethodRemove';
  error?: Maybe<FieldErrorType>;
  user?: Maybe<UserType>;
};

/** An enumeration. */
export enum TransferMethodType {
  /** Bank Account */
  BankAccount = 'BANK_ACCOUNT',
  /** Paypal Account */
  PaypalAccount = 'PAYPAL_ACCOUNT',
  /** Prepaid Card */
  PrepaidCard = 'PREPAID_CARD',
  /** Venmo Account */
  VenmoAccount = 'VENMO_ACCOUNT'
}

/**
 * Update user model fields, defined on settings.
 *
 * User must be verified.
 */
export type UpdateAccount = {
  __typename?: 'UpdateAccount';
  errors?: Maybe<Scalars['ExpectedErrorType']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateBlindDisabled = {
  __typename?: 'UpdateBlindDisabled';
  error?: Maybe<Scalars['String']['output']>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateConfigurations = {
  __typename?: 'UpdateConfigurations';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateDetails = {
  __typename?: 'UpdateDetails';
  error?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateDetailsFromRetool = {
  __typename?: 'UpdateDetailsFromRetool';
  error?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateHouseholdMember = {
  __typename?: 'UpdateHouseholdMember';
  errorMessage?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateLanguage = {
  __typename?: 'UpdateLanguage';
  user?: Maybe<UserType>;
};

export type UpdateScheduledPaymentAmountsResult = {
  __typename?: 'UpdateScheduledPaymentAmountsResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  newAmount?: Maybe<Scalars['Decimal']['output']>;
  oldAmount?: Maybe<Scalars['Decimal']['output']>;
  skippedPaymentsInfo?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  success?: Maybe<Scalars['Boolean']['output']>;
  updatedCount?: Maybe<Scalars['Int']['output']>;
  updatedPaymentDates?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  userEmail?: Maybe<Scalars['String']['output']>;
};

export type UpdateSettings = {
  __typename?: 'UpdateSettings';
  error?: Maybe<FieldErrorType>;
  user?: Maybe<UserType>;
};

export type UploadCsvRetoolMutation = {
  __typename?: 'UploadCSVRetoolMutation';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UploadMutation = {
  __typename?: 'UploadMutation';
  errorMessage?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UploadPersonMutation = {
  __typename?: 'UploadPersonMutation';
  errorMessage?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UserNode = Node & {
  __typename?: 'UserNode';
  archived?: Maybe<Scalars['Boolean']['output']>;
  assignedApplications: ApplicationDetailsTypeConnection;
  cbo?: Maybe<Scalars['String']['output']>;
  consentRecords: Array<ConsentRecordType>;
  createdAt: Scalars['DateTime']['output'];
  createdTask: ScheduledTaskTypeConnection;
  email: Scalars['String']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  invitations?: Maybe<InvitationType>;
  isActive: Scalars['Boolean']['output'];
  isSuperadmin?: Maybe<Scalars['Int']['output']>;
  logs: Array<LogType>;
  note: Array<NoteType>;
  paymentProfile?: Maybe<PaymentProfileType>;
  payments: PaymentTypeConnection;
  person?: Maybe<PersonType>;
  pk?: Maybe<Scalars['Int']['output']>;
  program: ProgramType;
  ranPayments: PaymentTypeConnection;
  ranScheduledPayments: ScheduledPaymentTypeConnection;
  researchId?: Maybe<Scalars['String']['output']>;
  retoolImportedPersons: RetoolImportedPersonTypeConnection;
  scheduledPayments: ScheduledPaymentTypeConnection;
  secondaryEmail?: Maybe<Scalars['String']['output']>;
  twoStepVerified: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
  verified?: Maybe<Scalars['Boolean']['output']>;
  verifiedDocuments: DocumentTypeConnection;
};


export type UserNodeAssignedApplicationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserNodeCreatedTaskArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserNodePaymentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserNodeRanPaymentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserNodeRanScheduledPaymentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserNodeRetoolImportedPersonsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserNodeScheduledPaymentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserNodeVerifiedDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type UserType = Node & {
  __typename?: 'UserType';
  assignedApplications: ApplicationDetailsTypeConnection;
  cbo?: Maybe<Scalars['String']['output']>;
  communicationSetting?: Maybe<CommunicationSettingType>;
  consentRecords: Array<ConsentRecordType>;
  createdAt: Scalars['DateTime']['output'];
  createdTask: ScheduledTaskTypeConnection;
  email: Scalars['String']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  invalidLoginAttempts: Scalars['Int']['output'];
  invitations?: Maybe<InvitationType>;
  isActive: Scalars['Boolean']['output'];
  isSuperadmin?: Maybe<Scalars['Int']['output']>;
  isSuperuser: Scalars['Int']['output'];
  isTestUser: Scalars['Boolean']['output'];
  lastLogin?: Maybe<Scalars['DateTime']['output']>;
  lastLoginAttempt?: Maybe<Scalars['DateTime']['output']>;
  locationDetail?: Maybe<LocationDetailsType>;
  logs: Array<LogType>;
  note: Array<NoteType>;
  notes?: Maybe<Scalars['String']['output']>;
  password: Scalars['String']['output'];
  paymentProfile?: Maybe<PaymentProfileType>;
  payments: PaymentTypeConnection;
  person?: Maybe<PersonType>;
  pk?: Maybe<Scalars['Int']['output']>;
  profile?: Maybe<ProfileType>;
  program: ProgramType;
  ranPayments: PaymentTypeConnection;
  ranScheduledPayments: ScheduledPaymentTypeConnection;
  researchId?: Maybe<Scalars['String']['output']>;
  resetUserOnLogout: Scalars['Boolean']['output'];
  retoolImportedPersons: RetoolImportedPersonTypeConnection;
  scheduledPayments: ScheduledPaymentTypeConnection;
  securityQuestionAnswer: Scalars['String']['output'];
  securityQuestionQuestion: Scalars['String']['output'];
  twoStepVerified: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
  verifiedDocuments: DocumentTypeConnection;
};


export type UserTypeAssignedApplicationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypeCreatedTaskArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypePaymentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypeRanPaymentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypeRanScheduledPaymentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypeRetoolImportedPersonsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypeScheduledPaymentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypeVerifiedDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type UserTypeConnection = {
  __typename?: 'UserTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<UserTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `UserType` and its cursor. */
export type UserTypeEdge = {
  __typename?: 'UserTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<UserType>;
};

/**
 * Verify user account.
 *
 * Receive the token that was sent by email.
 * If the token is valid, make the user verified
 * by making the `user.status.verified` field true.
 */
export type VerifyAccount = {
  __typename?: 'VerifyAccount';
  errors?: Maybe<Scalars['ExpectedErrorType']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Verify user secondary email.
 *
 * Receive the token that was sent by email.
 * User is already verified when using this mutation.
 *
 * If the token is valid, add the secondary email
 * to `user.status.secondary_email` field.
 *
 * Note that until the secondary email is verified,
 * it has not been saved anywhere beyond the token,
 * so it can still be used to create a new account.
 * After being verified, it will no longer be available.
 */
export type VerifySecondaryEmail = {
  __typename?: 'VerifySecondaryEmail';
  errors?: Maybe<Scalars['ExpectedErrorType']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Same as `grapgql_jwt` implementation, with standard output. */
export type VerifyToken = {
  __typename?: 'VerifyToken';
  errors?: Maybe<Scalars['ExpectedErrorType']['output']>;
  payload?: Maybe<Scalars['GenericScalar']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateLanguageMutationVariables = Exact<{
  language: Scalars['String']['input'];
}>;


export type UpdateLanguageMutation = { __typename?: 'Mutation', updateLanguage?: { __typename?: 'UpdateLanguage', user?: { __typename?: 'UserType', id: string } | null } | null };

export type AddApplicationAnswersMutationVariables = Exact<{
  answers: Array<ApplicationAnswersInputType> | ApplicationAnswersInputType;
}>;


export type AddApplicationAnswersMutation = { __typename?: 'Mutation', addApplicationAnswers?: { __typename?: 'AddApplicationAnswers', success?: boolean | null } | null };

export type ApplyMutationVariables = Exact<{
  email: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  addressLine1: Scalars['String']['input'];
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  city: Scalars['String']['input'];
  dob?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  programUrl: Scalars['String']['input'];
  language: Scalars['String']['input'];
  ethnicity?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  blindDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  isHomeless?: InputMaybe<Scalars['Boolean']['input']>;
  applicationId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type ApplyMutation = { __typename?: 'Mutation', apply?: { __typename?: 'Apply', error?: boolean | null, application?: { __typename?: 'ApplicationDetailsType', id: string, intercomKey?: string | null, person: { __typename?: 'PersonType', id: string } } | null } | null };

export type GetProgramsMutationVariables = Exact<{
  programUrl: Scalars['String']['input'];
  includeClosedPeriod?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetProgramsMutation = { __typename?: 'Mutation', getPrograms?: { __typename?: 'GetPrograms', success?: boolean | null } | null };

export type GetPersonMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetPersonMutation = { __typename?: 'Mutation', getPerson?: { __typename?: 'GetPerson', person?: { __typename?: 'PersonType', createdAt: any, updatedAt: any, id: string, communicationSetting?: { __typename?: 'CommunicationSettingType', email: string, phoneNumber?: string | null } | null, invitations: Array<{ __typename?: 'InvitationType', invitationSent?: any | null, code: string }>, applicationDetails?: Array<{ __typename?: 'ApplicationDetailsType', status?: ApplicationDetailsStatus | null, id: string, selectedFor?: string | null, isLocked: boolean, completed?: boolean | null, assignedAdmin?: { __typename?: 'UserType', profile?: { __typename?: 'ProfileType', firstName?: string | null, lastName?: string | null } | null } | null } | null> | null, benefitAnswers: { __typename?: 'BenefitAnswerTypeConnection', edges: Array<{ __typename?: 'BenefitAnswerTypeEdge', node?: { __typename?: 'BenefitAnswerType', answer: string, category: BenefitAnswerCategory, householdMember?: { __typename?: 'HouseholdMemberType', id: string } | null } | null } | null> }, householdMembers: Array<{ __typename?: 'HouseholdMemberType', id: string, name: string, dob?: any | null, relation: string, blindDisabled?: boolean | null, earnedIncome?: string | null, unearnedIncome?: string | null }>, locationDetail?: { __typename?: 'LocationDetailsType', addressLine1?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: string | null, tractCode?: string | null } | null, profile?: { __typename?: 'ProfileType', firstName?: string | null, lastName?: string | null, dob?: string | null, ethnicity?: string | null, language?: string | null, blindDisabled?: boolean | null, gender?: string | null, medianHouseholdIncome?: any | null, earnedIncome?: string | null, unearnedIncome?: string | null } | null } | null, documents?: Array<{ __typename?: 'DocumentType', id: string, documentType?: DocumentDocumentType | null, name?: string | null, rejected?: boolean | null, documentOriginalName?: string | null, updatedAt: any, createdAt: any, uploadedAt: any, requestedAs?: string | null, verifiedBy?: { __typename?: 'UserType', email: string, profile?: { __typename?: 'ProfileType', firstName?: string | null, lastName?: string | null } | null } | null } | null> | null, flags?: Array<{ __typename?: 'PersonFlagType', flagType: FlagsFlagType, inactive: boolean, id: string, person?: { __typename?: 'PersonType', id: string, pk?: number | null } | null, matchedPerson?: { __typename?: 'PersonType', id: string, profile?: { __typename?: 'ProfileType', firstName?: string | null, lastName?: string | null } | null, flagsPerson: { __typename?: 'PersonFlagTypeConnection', edges: Array<{ __typename?: 'PersonFlagTypeEdge', node?: { __typename?: 'PersonFlagType', inactive: boolean, pk?: number | null, id: string, person?: { __typename?: 'PersonType', pk?: number | null, id: string } | null } | null } | null> } } | null } | null> | null, householdMembers?: Array<{ __typename?: 'HouseholdMemberType', name: string, dob?: any | null, relation: string } | null> | null, applicationAnswers?: Array<{ __typename?: 'ProgramApplicationAnswerType', category: ApplicationAnswersCategory, response: string } | null> | null } | null };

export type MakeFlagInactiveMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  relatedPersonId?: InputMaybe<Scalars['ID']['input']>;
  personId: Scalars['ID']['input'];
}>;


export type MakeFlagInactiveMutation = { __typename?: 'Mutation', makeFlagInactive?: { __typename?: 'MakeFlagInactive', success?: boolean | null } | null };

export type DocumentUploadMutationVariables = Exact<{
  file: Scalars['Upload']['input'];
  personId: Scalars['ID']['input'];
  documentType: Scalars['String']['input'];
  householdMemberId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type DocumentUploadMutation = { __typename?: 'Mutation', documentUpload?: { __typename?: 'DocumentUpload', documentUploadSuccess?: boolean | null } | null };

export type MultipleDocumentsUploadMutationVariables = Exact<{
  files: Array<InputMaybe<Scalars['Upload']['input']>> | InputMaybe<Scalars['Upload']['input']>;
  personId: Scalars['ID']['input'];
  documentType: Scalars['String']['input'];
  householdMemberId?: InputMaybe<Scalars['ID']['input']>;
  previousFiles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type MultipleDocumentsUploadMutation = { __typename?: 'Mutation', multipleDocumentsUpload?: { __typename?: 'MultipleDocumentsUpload', documentUploadSuccess?: boolean | null } | null };

export type RequestDocumentMutationVariables = Exact<{
  requestedDocumentList: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
  personId: Scalars['ID']['input'];
}>;


export type RequestDocumentMutation = { __typename?: 'Mutation', requestDocument?: { __typename?: 'RequestDocument', documentRequestSuccess?: boolean | null } | null };

export type SendConfirmationMutationVariables = Exact<{
  applicationDetailsId: Scalars['ID']['input'];
}>;


export type SendConfirmationMutation = { __typename?: 'Mutation', sendConfirmation?: { __typename?: 'SendConfirmation', ok?: boolean | null } | null };

export type SendDocumentsUploadConfirmationMutationVariables = Exact<{
  personId: Scalars['ID']['input'];
  documentType?: InputMaybe<Scalars['String']['input']>;
}>;


export type SendDocumentsUploadConfirmationMutation = { __typename?: 'Mutation', sendDocumentsUploadConfirmation?: { __typename?: 'SendDocumentsUploadConfirmation', ok?: boolean | null } | null };

export type SaveHouseholdMembersMutationVariables = Exact<{
  personId: Scalars['ID']['input'];
  householdMembers: Array<HouseholdMemberInputType> | HouseholdMemberInputType;
}>;


export type SaveHouseholdMembersMutation = { __typename?: 'Mutation', saveHouseholdMembers?: { __typename?: 'SaveHouseholdMembers', success?: boolean | null } | null };

export type RecoverApplicationMutationVariables = Exact<{
  email: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
}>;


export type RecoverApplicationMutation = { __typename?: 'Mutation', recoverApplication?: { __typename?: 'RecoverApplication', ok?: boolean | null } | null };

export type ListOfUploadedDocumentsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ListOfUploadedDocumentsQuery = { __typename?: 'Query', listOfUploadedDocuments?: string | null };

export type ListOfUploadedDocumentsIncludingNameQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ListOfUploadedDocumentsIncludingNameQuery = { __typename?: 'Query', listOfUploadedDocumentsIncludingName?: Array<{ __typename?: 'DocumentType', name?: string | null, documentType?: DocumentDocumentType | null } | null> | null };

export type CountHouseholdMembersQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CountHouseholdMembersQuery = { __typename?: 'Query', countHouseholdMembers?: number | null };

export type AddressAutocompleteQueryQueryVariables = Exact<{
  value?: InputMaybe<Scalars['String']['input']>;
}>;


export type AddressAutocompleteQueryQuery = { __typename?: 'Query', addressAutocomplete?: Array<{ __typename?: 'AddressAutocomplete', placeId?: string | null, description?: string | null } | null> | null };

export type AddressDetailsQueryQueryVariables = Exact<{
  placeId?: InputMaybe<Scalars['String']['input']>;
}>;


export type AddressDetailsQueryQuery = { __typename?: 'Query', addressDetails?: { __typename?: 'AddressDetails', address1?: string | null, city?: string | null, state?: string | null, postalCode?: string | null } | null };

export type GetApplicationBasicInfoQueryVariables = Exact<{
  applicationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetApplicationBasicInfoQuery = { __typename?: 'Query', personApplication?: { __typename?: 'PersonType', applicationDetail?: { __typename?: 'ApplicationDetailsType', id: string, completed?: boolean | null } | null, profile?: { __typename?: 'ProfileType', firstName?: string | null, lastName?: string | null, dob?: string | null, blindDisabled?: boolean | null, earnedIncome?: string | null, unearnedIncome?: string | null, gender?: string | null, ethnicity?: string | null, language?: string | null, person: { __typename?: 'PersonType', id: string } } | null, communicationSetting?: { __typename?: 'CommunicationSettingType', email: string, phoneNumber?: string | null } | null, locationDetail?: { __typename?: 'LocationDetailsType', addressLine1?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, zipCode?: string | null } | null, householdMembers: Array<{ __typename?: 'HouseholdMemberType', name: string, dob?: any | null, relation: string, blindDisabled?: boolean | null, earnedIncome?: string | null, unearnedIncome?: string | null }>, documents: { __typename?: 'DocumentTypeConnection', edges: Array<{ __typename?: 'DocumentTypeEdge', node?: { __typename?: 'DocumentType', id: string, documentType?: DocumentDocumentType | null, name?: string | null, documentOriginalName?: string | null, updatedAt: any, createdAt: any, rejected?: boolean | null, uploadedAt: any, requestedAs?: string | null, verifiedBy?: { __typename?: 'UserType', email: string, profile?: { __typename?: 'ProfileType', firstName?: string | null, lastName?: string | null } | null } | null, person: { __typename?: 'PersonType', id: string }, householdMember?: { __typename?: 'HouseholdMemberType', id: string } | null } | null } | null> } } | null };

export type GetApplicationHouseholdMembersQueryVariables = Exact<{
  applicationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetApplicationHouseholdMembersQuery = { __typename?: 'Query', personApplication?: { __typename?: 'PersonType', householdMembers: Array<{ __typename?: 'HouseholdMemberType', id: string, name: string, dob?: any | null, relation: string, blindDisabled?: boolean | null, earnedIncome?: string | null, unearnedIncome?: string | null }> } | null };

export type PasswordChangeMutationVariables = Exact<{
  oldPassword: Scalars['String']['input'];
  newPassword1: Scalars['String']['input'];
  newPassword2: Scalars['String']['input'];
}>;


export type PasswordChangeMutation = { __typename?: 'Mutation', passwordChange?: { __typename?: 'PasswordChangeExtended', success?: boolean | null, errors?: any | null } | null };

export type BenefitsAnswersMutationVariables = Exact<{
  answers: Array<BenefitAnswerInputType> | BenefitAnswerInputType;
}>;


export type BenefitsAnswersMutation = { __typename?: 'Mutation', addBenefitAnswers?: { __typename?: 'AddBenefitAnswers', ok?: boolean | null, error?: string | null } | null };

export type BenefitsSelectionMutationVariables = Exact<{
  benefits: Array<BenefitSelectedInputType> | BenefitSelectedInputType;
}>;


export type BenefitsSelectionMutation = { __typename?: 'Mutation', selectBenefits?: { __typename?: 'SelectBenefits', ok?: boolean | null, error?: string | null } | null };

export type UpdateBlindDisabledMutationVariables = Exact<{
  blindDisabled: Scalars['Boolean']['input'];
  inviteCode?: InputMaybe<Scalars['String']['input']>;
  verificationCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateBlindDisabledMutation = { __typename?: 'Mutation', updateBlindDisabled?: { __typename?: 'UpdateBlindDisabled', ok?: boolean | null, error?: string | null } | null };

export type BenefitsAnswerQueryQueryVariables = Exact<{
  personId: Scalars['ID']['input'];
}>;


export type BenefitsAnswerQueryQuery = { __typename?: 'Query', benefitsAnswers?: Array<{ __typename?: 'BenefitAnswerType', answer: string, category: BenefitAnswerCategory, householdMember?: { __typename?: 'HouseholdMemberType', id: string, name: string, dob?: any | null, relation: string, blindDisabled?: boolean | null } | null } | null> | null };

export type SelectedBenefitsQueryVariables = Exact<{
  personId: Scalars['ID']['input'];
}>;


export type SelectedBenefitsQuery = { __typename?: 'Query', selectedBenefits?: Array<{ __typename?: 'BenefitSelectedType', category: BenefitSelectedCategory } | null> | null };

export type GetApplicationDataQueryVariables = Exact<{
  inviteCode?: InputMaybe<Scalars['String']['input']>;
  verificationCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetApplicationDataQuery = { __typename?: 'Query', personApplication?: { __typename?: 'PersonType', profile?: { __typename?: 'ProfileType', firstName?: string | null, lastName?: string | null, dob?: string | null, blindDisabled?: boolean | null, earnedIncome?: string | null, unearnedIncome?: string | null } | null, householdMembers: Array<{ __typename?: 'HouseholdMemberType', id: string, name: string, dob?: any | null, relation: string, blindDisabled?: boolean | null, earnedIncome?: string | null, unearnedIncome?: string | null }> } | null };

export type GetCalendlyScheduledEventQueryVariables = Exact<{
  personId: Scalars['ID']['input'];
}>;


export type GetCalendlyScheduledEventQuery = { __typename?: 'Query', scheduledEvent?: { __typename?: 'CalendlyEventType', createdAt?: string | null, name?: string | null, status?: string | null, startTime?: string | null, endTime?: string | null } | null };

export type RegisterMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password1: Scalars['String']['input'];
  password2: Scalars['String']['input'];
  securityQuestionQuestion: Scalars['String']['input'];
  securityQuestionAnswer: Scalars['String']['input'];
}>;


export type RegisterMutation = { __typename?: 'Mutation', register?: { __typename?: 'RegisterExtended', success?: boolean | null, errors?: any | null } | null };

export type SaveSixDigitVerificationCodeForPersonMutationVariables = Exact<{
  personId: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
}>;


export type SaveSixDigitVerificationCodeForPersonMutation = { __typename?: 'Mutation', saveSixDigitVerificationCodeForPerson?: { __typename?: 'SaveSixDigitVerificationCodeForPerson', success?: boolean | null } | null };

export type CheckSixDigitVerificationCodeForPersonMutationVariables = Exact<{
  personId: Scalars['String']['input'];
  verificationCode: Scalars['String']['input'];
}>;


export type CheckSixDigitVerificationCodeForPersonMutation = { __typename?: 'Mutation', checkSixDigitVerificationCodeForPerson?: { __typename?: 'CheckSixDigitVerificationCodeForPerson', success?: boolean | null } | null };

export type OnboardingLogosQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type OnboardingLogosQuery = { __typename?: 'Query', onboardingLogos?: Array<{ __typename?: 'OnboardingLogosType', position?: number | null, image: string, url: string } | null> | null };

export type SpeakBenefitsCounselorMutationVariables = Exact<{
  firstName: Scalars['String']['input'];
  language: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  email: Scalars['String']['input'];
  personId: Scalars['ID']['input'];
}>;


export type SpeakBenefitsCounselorMutation = { __typename?: 'Mutation', speakBenefitsCounselor?: { __typename?: 'SpeakBenefitsCounselor', ok?: boolean | null } | null };

export type PersonFragment = { __typename?: 'PersonType', id: string, communicationSetting?: { __typename?: 'CommunicationSettingType', phoneNumber?: string | null, email: string } | null, invitations: Array<{ __typename?: 'InvitationType', code: string, paymentAmount?: any | null, program: { __typename?: 'ProgramType', id: string } }>, applicationDetails?: Array<{ __typename?: 'ApplicationDetailsType', program: { __typename?: 'ProgramType', urlFragment: string } } | null> | null, profile?: { __typename?: 'ProfileType', blindDisabled?: boolean | null, language?: string | null, firstName?: string | null, lastName?: string | null, dob?: string | null, earnedIncome?: string | null, unearnedIncome?: string | null } | null };

export type CodeValidationQueryVariables = Exact<{
  inviteCode?: InputMaybe<Scalars['String']['input']>;
  resetToken?: InputMaybe<Scalars['String']['input']>;
  verificationCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type CodeValidationQuery = { __typename?: 'Query', codeValidation?: { __typename?: 'InviteCodeValidationQueryResponse', alreadySignedUp?: boolean | null, person?: { __typename?: 'PersonType', id: string, communicationSetting?: { __typename?: 'CommunicationSettingType', phoneNumber?: string | null, email: string } | null, invitations: Array<{ __typename?: 'InvitationType', code: string, paymentAmount?: any | null, program: { __typename?: 'ProgramType', id: string } }>, applicationDetails?: Array<{ __typename?: 'ApplicationDetailsType', program: { __typename?: 'ProgramType', urlFragment: string } } | null> | null, profile?: { __typename?: 'ProfileType', blindDisabled?: boolean | null, language?: string | null, firstName?: string | null, lastName?: string | null, dob?: string | null, earnedIncome?: string | null, unearnedIncome?: string | null } | null } | null } | null };

export type GetApplicationAnswersQueryVariables = Exact<{
  applicationId: Scalars['ID']['input'];
}>;


export type GetApplicationAnswersQuery = { __typename?: 'Query', allUserAnswers?: Array<{ __typename?: 'ProgramApplicationAnswerType', category: ApplicationAnswersCategory, response: string } | null> | null };

export type SendPasswordResetEmailMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type SendPasswordResetEmailMutation = { __typename?: 'Mutation', sendPasswordResetEmail?: { __typename?: 'SendPasswordResetEmail', success?: boolean | null, errors?: any | null } | null };

export type MyRecentPaymentsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyRecentPaymentsQuery = { __typename?: 'Query', myRecentPayments?: Array<{ __typename?: 'PaymentType', id: string, amount: any, createdAt: any, status: PaymentStatus, transferMethod: { __typename?: 'TransferMethodObjectType', oneLiner: string, halfLiner: string, type: TransferMethodType } } | null> | null };

export type MyScheduledPaymentsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyScheduledPaymentsQuery = { __typename?: 'Query', myUpcomingScheduledPayments?: Array<{ __typename?: 'ScheduledPaymentType', id: string, scheduledDate: any, amount: any } | null> | null };

export type MyUpcomingPaymentQueryVariables = Exact<{ [key: string]: never; }>;


export type MyUpcomingPaymentQuery = { __typename?: 'Query', myUpcomingPayment?: { __typename?: 'ScheduledPaymentType', id: string, scheduledDate: any, amount: any } | null, myLastPayment?: { __typename?: 'ScheduledPaymentType', id: string, scheduledDate: any, amount: any } | null };

export type GetTransactionDetailsPortalQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTransactionDetailsPortalQuery = { __typename?: 'Query', transactionDetailsPortal?: Array<{ __typename?: 'TransactionDetailsTypeQueryPortal', amount?: number | null, pending?: string | null, type?: string | null, mcc?: string | null, newBalance?: string | null, merchantDescription?: string | null, date?: string | null } | null> | null };

export type StylesQueryVariables = Exact<{ [key: string]: never; }>;


export type StylesQuery = { __typename?: 'Query', styles?: { __typename?: 'StylesType', primaryColor: string, secondaryColor: string, tertiaryColor: string, hoverColor: string, backgroundColor: string, sidebarLogo: string, sidebarLogoMobile: string, sidebarImage: string } | null };

export type CardBalanceQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CardBalanceQuery = { __typename?: 'Query', cardBalance?: number | null };

export type GetInitialDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInitialDataQuery = { __typename?: 'Query', translations?: any | null, languages?: Array<string | null> | null, program?: { __typename?: 'ProgramType', name: string, paymentFrequency: ProgramPaymentFrequency, paymentAmount: any, programDuration: any, numberOfMonths?: any | null, ssiBenefitsWizardEnabled: boolean, id: string, urlFragment: string, isActiveProgram: boolean } | null, organizationConfigs?: { __typename?: 'OrganizationConfigsType', facebookLink?: string | null, instagramLink?: string | null, phoneNumber?: string | null, replyToEmail?: string | null, timezone?: string | null, twitterLink?: string | null, typeformId?: string | null, typeformSubdomain?: string | null, websiteLink?: string | null, isTypeformBound?: boolean | null, whatsappPhoneNumber?: string | null, gaMeasurementId?: string | null, googleTagManagerId?: string | null, prepaidCardPickupLocations?: string | null } | null, organization?: { __typename?: 'OrganizationType', version: number, webAppUrl: string, name: string, id: string } | null, documentRequirement?: Array<{ __typename?: 'DocumentRequireType', type?: DocumentRequirementType | null, required: boolean } | null> | null, consentTypes?: Array<{ __typename: 'ConsentTypeType', id: string, name: string, translationKey: string, isRequired: boolean, displayOrder: number } | null> | null };

export type LoginMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type LoginMutation = { __typename?: 'Mutation', tokenAuth?: { __typename?: 'ObtainJSONWebTokenExtended', success?: boolean | null, token?: string | null, refreshToken?: string | null, errors?: any | null } | null };

export type PasswordResetMutationVariables = Exact<{
  token: Scalars['String']['input'];
  newPassword1: Scalars['String']['input'];
  newPassword2: Scalars['String']['input'];
}>;


export type PasswordResetMutation = { __typename?: 'Mutation', passwordReset?: { __typename?: 'PasswordResetExtended', success?: boolean | null, errors?: any | null } | null };

export type GetPersonWithHashedIdQueryVariables = Exact<{
  hashedId: Scalars['String']['input'];
}>;


export type GetPersonWithHashedIdQuery = { __typename?: 'Query', personWithHashedId?: { __typename?: 'PersonType', id: string, createdAt: any, updatedAt: any, pk?: number | null, communicationSetting?: { __typename?: 'CommunicationSettingType', phoneNumber?: string | null, email: string } | null, invitations: Array<{ __typename?: 'InvitationType', code: string }>, applicationDetails?: Array<{ __typename?: 'ApplicationDetailsType', status?: ApplicationDetailsStatus | null, isLocked: boolean, reachedVerifyScreen: boolean, selectedFor?: string | null, answers: { __typename?: 'ProgramApplicationAnswerTypeConnection', edges: Array<{ __typename?: 'ProgramApplicationAnswerTypeEdge', node?: { __typename?: 'ProgramApplicationAnswerType', category: ApplicationAnswersCategory, response: string } | null } | null> } } | null> | null, benefitAnswers: { __typename?: 'BenefitAnswerTypeConnection', edges: Array<{ __typename?: 'BenefitAnswerTypeEdge', node?: { __typename?: 'BenefitAnswerType', answer: string, category: BenefitAnswerCategory, householdMember?: { __typename?: 'HouseholdMemberType', id: string } | null } | null } | null> }, documents: { __typename?: 'DocumentTypeConnection', edges: Array<{ __typename?: 'DocumentTypeEdge', node?: { __typename?: 'DocumentType', id: string, documentType?: DocumentDocumentType | null, name?: string | null, updatedAt: any, createdAt: any, uploadedAt: any, requestedAs?: string | null, verifiedBy?: { __typename?: 'UserType', email: string, profile?: { __typename?: 'ProfileType', firstName?: string | null, lastName?: string | null } | null } | null } | null } | null> }, profile?: { __typename?: 'ProfileType', blindDisabled?: boolean | null, firstName?: string | null, lastName?: string | null, dob?: string | null, medianHouseholdIncome?: any | null, earnedIncome?: string | null, unearnedIncome?: string | null, language?: string | null } | null, locationDetail?: { __typename?: 'LocationDetailsType', addressLine1?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: string | null, tractCode?: string | null } | null, householdMembers: Array<{ __typename?: 'HouseholdMemberType', id: string, name: string, dob?: any | null, relation: string, blindDisabled?: boolean | null, earnedIncome?: string | null, unearnedIncome?: string | null }> } | null };

export type RefreshTokenMutationVariables = Exact<{
  refreshToken: Scalars['String']['input'];
}>;


export type RefreshTokenMutation = { __typename?: 'Mutation', refreshToken?: { __typename?: 'RefreshToken', token?: string | null, payload?: any | null, success?: boolean | null, errors?: any | null, refreshToken?: string | null } | null };

export type TransferMethodsFragment = { __typename?: 'PaymentProfileType', transferMethods: { __typename?: 'TransferMethodObjectTypeConnection', edges: Array<{ __typename?: 'TransferMethodObjectTypeEdge', node?: { __typename?: 'TransferMethodObjectType', id: string, type: TransferMethodType, halfLiner: string, oneLiner: string, isCurrentMethod: boolean, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, zipCode?: string | null, statusCode?: string | null, deleted: boolean } | null } | null> } };

export type UpdateDetailsMutationVariables = Exact<{
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  dob?: InputMaybe<Scalars['String']['input']>;
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateDetailsMutation = { __typename?: 'Mutation', updateDetails?: { __typename?: 'UpdateDetails', success?: boolean | null } | null };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', logout?: { __typename?: 'Logout', ok?: boolean | null } | null };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me?: { __typename?: 'UserType', id: string, email: string, createdAt: any, pk?: number | null, isSuperuser: number, communicationSetting?: { __typename?: 'CommunicationSettingType', phoneNumber?: string | null, email: string, smsNotificationsEnabled: boolean, emailNotificationsEnabled: boolean, whatsappNotificationsEnabled: boolean } | null, paymentProfile?: { __typename?: 'PaymentProfileType', paymentAmount?: any | null, paymentFrequencyType?: PaymentProfilePaymentFrequencyType | null, hyperwalletToken?: string | null, numberOfMonths?: any | null, frozen: boolean, transferMethods: { __typename?: 'TransferMethodObjectTypeConnection', edges: Array<{ __typename?: 'TransferMethodObjectTypeEdge', node?: { __typename?: 'TransferMethodObjectType', id: string, type: TransferMethodType, halfLiner: string, oneLiner: string, isCurrentMethod: boolean, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, zipCode?: string | null, statusCode?: string | null, deleted: boolean } | null } | null> } } | null, person?: { __typename?: 'PersonType', id: string, intercomKey?: string | null, applicationDetails?: Array<{ __typename?: 'ApplicationDetailsType', program: { __typename?: 'ProgramType', id: string, urlFragment: string, organization: { __typename?: 'OrganizationType', id: string } } } | null> | null, profile?: { __typename?: 'ProfileType', language?: string | null, firstName?: string | null, lastName?: string | null, earnedIncome?: string | null, unearnedIncome?: string | null, dob?: string | null } | null, locationDetail?: { __typename?: 'LocationDetailsType', addressLine1?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: string | null } | null } | null } | null };

export type SurveyAvailableQueryVariables = Exact<{ [key: string]: never; }>;


export type SurveyAvailableQuery = { __typename?: 'Query', surveyAvailable?: boolean | null };

export type UsersQueryVariables = Exact<{ [key: string]: never; }>;


export type UsersQuery = { __typename?: 'Query', users?: Array<{ __typename?: 'UserType', pk?: number | null, communicationSetting?: { __typename?: 'CommunicationSettingType', phoneNumber?: string | null } | null, person?: { __typename?: 'PersonType', profile?: { __typename?: 'ProfileType', firstName?: string | null, language?: string | null, lastName?: string | null, dob?: string | null, earnedIncome?: string | null, unearnedIncome?: string | null } | null } | null, paymentProfile?: { __typename?: 'PaymentProfileType', paymentAmount?: any | null, paymentFrequencyType?: PaymentProfilePaymentFrequencyType | null, startDate?: any | null, frozen: boolean } | null } | null> | null };

export type FieldErrorFragment = { __typename?: 'FieldErrorType', fieldName?: string | null, code?: string | null };

export type TransferMethodRemoveMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TransferMethodRemoveMutation = { __typename?: 'Mutation', transferMethodRemove?: { __typename?: 'TransferMethodRemove', user?: { __typename?: 'UserType', id: string } | null } | null };

export type SendSupportEmailMutationVariables = Exact<{
  userMessage: Scalars['String']['input'];
  userName: Scalars['String']['input'];
  userEmail?: InputMaybe<Scalars['String']['input']>;
  userCategory: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
}>;


export type SendSupportEmailMutation = { __typename?: 'Mutation', sendSupportEmail?: { __typename?: 'SendSupportEmail', success?: boolean | null } | null };

export type FaqNinjaWizardTypeQueryVariables = Exact<{
  language: Scalars['String']['input'];
}>;


export type FaqNinjaWizardTypeQuery = { __typename?: 'Query', ninjaWizardData?: { __typename?: 'FaqNinjaWizardType', id: string, ninjaCode: string, language: FaqNinjaWizardLanguage, org: { __typename?: 'OrganizationType', name: string } } | null };

export type RegisterWithConsentMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password1: Scalars['String']['input'];
  password2: Scalars['String']['input'];
  securityQuestionQuestion: Scalars['String']['input'];
  securityQuestionAnswer: Scalars['String']['input'];
  consents: Array<InputMaybe<ConsentInput>> | InputMaybe<ConsentInput>;
}>;


export type RegisterWithConsentMutation = { __typename?: 'Mutation', registerWithConsent?: { __typename?: 'RegisterWithConsent', success?: boolean | null, errors?: any | null, password?: any | null, password2?: any | null, token?: string | null, refreshToken?: string | null } | null };

export type UpdateSettingsMutationVariables = Exact<{
  transferMethodId: Scalars['ID']['input'];
  emailNotificationsEnabled: Scalars['Boolean']['input'];
  smsNotificationsEnabled: Scalars['Boolean']['input'];
  optedForWhatsapp: Scalars['Boolean']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateSettingsMutation = { __typename?: 'Mutation', updateSettings?: { __typename?: 'UpdateSettings', user?: { __typename?: 'UserType', id: string, communicationSetting?: { __typename?: 'CommunicationSettingType', emailNotificationsEnabled: boolean, smsNotificationsEnabled: boolean, whatsappNotificationsEnabled: boolean } | null, paymentProfile?: { __typename?: 'PaymentProfileType', transferMethods: { __typename?: 'TransferMethodObjectTypeConnection', edges: Array<{ __typename?: 'TransferMethodObjectTypeEdge', node?: { __typename?: 'TransferMethodObjectType', id: string, type: TransferMethodType, halfLiner: string, oneLiner: string, isCurrentMethod: boolean, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, zipCode?: string | null, statusCode?: string | null, deleted: boolean } | null } | null> } } | null } | null, error?: { __typename?: 'FieldErrorType', fieldName?: string | null, code?: string | null } | null } | null };

export type SettingsPageUserFragment = { __typename?: 'UserType', id: string, communicationSetting?: { __typename?: 'CommunicationSettingType', emailNotificationsEnabled: boolean, smsNotificationsEnabled: boolean, whatsappNotificationsEnabled: boolean } | null, paymentProfile?: { __typename?: 'PaymentProfileType', transferMethods: { __typename?: 'TransferMethodObjectTypeConnection', edges: Array<{ __typename?: 'TransferMethodObjectTypeEdge', node?: { __typename?: 'TransferMethodObjectType', id: string, type: TransferMethodType, halfLiner: string, oneLiner: string, isCurrentMethod: boolean, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, zipCode?: string | null, statusCode?: string | null, deleted: boolean } | null } | null> } } | null };

export type SettingsPageQueryVariables = Exact<{ [key: string]: never; }>;


export type SettingsPageQuery = { __typename?: 'Query', me?: { __typename?: 'UserType', id: string, communicationSetting?: { __typename?: 'CommunicationSettingType', emailNotificationsEnabled: boolean, smsNotificationsEnabled: boolean, whatsappNotificationsEnabled: boolean } | null, paymentProfile?: { __typename?: 'PaymentProfileType', transferMethods: { __typename?: 'TransferMethodObjectTypeConnection', edges: Array<{ __typename?: 'TransferMethodObjectTypeEdge', node?: { __typename?: 'TransferMethodObjectType', id: string, type: TransferMethodType, halfLiner: string, oneLiner: string, isCurrentMethod: boolean, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, zipCode?: string | null, statusCode?: string | null, deleted: boolean } | null } | null> } } | null } | null };

export type TransferMethodAddBankAccountMutationVariables = Exact<{
  bankAccountId: Scalars['String']['input'];
  branchId: Scalars['String']['input'];
  accountPurpose: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  addressLine1: Scalars['String']['input'];
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  state: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
}>;


export type TransferMethodAddBankAccountMutation = { __typename?: 'Mutation', transferMethodAddBankAccount?: { __typename?: 'TransferMethodAddBankAccount', user?: { __typename?: 'UserType', id: string, paymentProfile?: { __typename?: 'PaymentProfileType', transferMethods: { __typename?: 'TransferMethodObjectTypeConnection', edges: Array<{ __typename?: 'TransferMethodObjectTypeEdge', node?: { __typename?: 'TransferMethodObjectType', id: string, type: TransferMethodType, halfLiner: string, oneLiner: string, isCurrentMethod: boolean, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, zipCode?: string | null, statusCode?: string | null, deleted: boolean } | null } | null> } } | null } | null, error?: { __typename?: 'FieldErrorType', fieldName?: string | null, code?: string | null } | null, errorLabel?: { __typename?: 'FieldErrorType', fieldName?: string | null, code?: string | null } | null } | null };

export type TransferMethodAddPaypalMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type TransferMethodAddPaypalMutation = { __typename?: 'Mutation', transferMethodAddPaypal?: { __typename?: 'TransferMethodAddPaypal', user?: { __typename?: 'UserType', id: string, paymentProfile?: { __typename?: 'PaymentProfileType', transferMethods: { __typename?: 'TransferMethodObjectTypeConnection', edges: Array<{ __typename?: 'TransferMethodObjectTypeEdge', node?: { __typename?: 'TransferMethodObjectType', id: string, type: TransferMethodType, halfLiner: string, oneLiner: string, isCurrentMethod: boolean, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, zipCode?: string | null, statusCode?: string | null, deleted: boolean } | null } | null> } } | null } | null, error?: { __typename?: 'FieldErrorType', fieldName?: string | null, code?: string | null } | null } | null };

export type TransferMethodAddPrepaidCardMutationVariables = Exact<{
  addressLine1: Scalars['String']['input'];
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  state: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  language: Scalars['String']['input'];
  inPersonPickup?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type TransferMethodAddPrepaidCardMutation = { __typename?: 'Mutation', transferMethodAddPrepaidCard?: { __typename?: 'TransferMethodAddPrepaidCard', user?: { __typename?: 'UserType', paymentProfile?: { __typename?: 'PaymentProfileType', transferMethods: { __typename?: 'TransferMethodObjectTypeConnection', edges: Array<{ __typename?: 'TransferMethodObjectTypeEdge', node?: { __typename?: 'TransferMethodObjectType', id: string, type: TransferMethodType, halfLiner: string, oneLiner: string, isCurrentMethod: boolean, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, zipCode?: string | null, statusCode?: string | null, deleted: boolean } | null } | null> } } | null } | null, error?: { __typename?: 'FieldErrorType', fieldName?: string | null, code?: string | null } | null } | null };

export type TransferMethodAddVenmoMutationVariables = Exact<{
  phoneNumber: Scalars['String']['input'];
}>;


export type TransferMethodAddVenmoMutation = { __typename?: 'Mutation', transferMethodAddVenmo?: { __typename?: 'TransferMethodAddVenmo', user?: { __typename?: 'UserType', paymentProfile?: { __typename?: 'PaymentProfileType', transferMethods: { __typename?: 'TransferMethodObjectTypeConnection', edges: Array<{ __typename?: 'TransferMethodObjectTypeEdge', node?: { __typename?: 'TransferMethodObjectType', id: string, type: TransferMethodType, halfLiner: string, oneLiner: string, isCurrentMethod: boolean, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, zipCode?: string | null, statusCode?: string | null, deleted: boolean } | null } | null> } } | null } | null, error?: { __typename?: 'FieldErrorType', fieldName?: string | null, code?: string | null } | null } | null };

export type AddressValidationQueryQueryVariables = Exact<{
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type AddressValidationQueryQuery = { __typename?: 'Query', addressValidation?: { __typename?: 'AddressValidation', address1?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, formattedAddress?: string | null } | null };

export const PersonFragmentDoc = gql`
    fragment Person on PersonType {
  id
  communicationSetting {
    phoneNumber
    email
  }
  invitations {
    code
    paymentAmount
    program {
      id
    }
  }
  applicationDetails {
    program {
      urlFragment
    }
  }
  profile {
    blindDisabled
    language
    firstName
    lastName
    dob
    earnedIncome
    unearnedIncome
  }
}
    `;
export const FieldErrorFragmentDoc = gql`
    fragment FieldError on FieldErrorType {
  fieldName
  code
}
    `;
export const TransferMethodsFragmentDoc = gql`
    fragment TransferMethods on PaymentProfileType {
  transferMethods {
    edges {
      node {
        id
        type
        halfLiner
        oneLiner
        isCurrentMethod
        addressLine1
        addressLine2
        city
        zipCode
        statusCode
        deleted
      }
    }
  }
}
    `;
export const SettingsPageUserFragmentDoc = gql`
    fragment SettingsPageUser on UserType {
  id
  communicationSetting {
    emailNotificationsEnabled
    smsNotificationsEnabled
    whatsappNotificationsEnabled
  }
  paymentProfile {
    ...TransferMethods
  }
}
    ${TransferMethodsFragmentDoc}`;
export const UpdateLanguageDocument = gql`
    mutation UpdateLanguage($language: String!) {
  updateLanguage(language: $language) {
    user {
      id
    }
  }
}
    `;
export type UpdateLanguageMutationFn = Apollo.MutationFunction<UpdateLanguageMutation, UpdateLanguageMutationVariables>;

/**
 * __useUpdateLanguageMutation__
 *
 * To run a mutation, you first call `useUpdateLanguageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLanguageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLanguageMutation, { data, loading, error }] = useUpdateLanguageMutation({
 *   variables: {
 *      language: // value for 'language'
 *   },
 * });
 */
export function useUpdateLanguageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLanguageMutation, UpdateLanguageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLanguageMutation, UpdateLanguageMutationVariables>(UpdateLanguageDocument, options);
      }
export type UpdateLanguageMutationHookResult = ReturnType<typeof useUpdateLanguageMutation>;
export type UpdateLanguageMutationResult = Apollo.MutationResult<UpdateLanguageMutation>;
export type UpdateLanguageMutationOptions = Apollo.BaseMutationOptions<UpdateLanguageMutation, UpdateLanguageMutationVariables>;
export const AddApplicationAnswersDocument = gql`
    mutation AddApplicationAnswers($answers: [ApplicationAnswersInputType!]!) {
  addApplicationAnswers(answers: $answers) {
    success
  }
}
    `;
export type AddApplicationAnswersMutationFn = Apollo.MutationFunction<AddApplicationAnswersMutation, AddApplicationAnswersMutationVariables>;

/**
 * __useAddApplicationAnswersMutation__
 *
 * To run a mutation, you first call `useAddApplicationAnswersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddApplicationAnswersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addApplicationAnswersMutation, { data, loading, error }] = useAddApplicationAnswersMutation({
 *   variables: {
 *      answers: // value for 'answers'
 *   },
 * });
 */
export function useAddApplicationAnswersMutation(baseOptions?: Apollo.MutationHookOptions<AddApplicationAnswersMutation, AddApplicationAnswersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddApplicationAnswersMutation, AddApplicationAnswersMutationVariables>(AddApplicationAnswersDocument, options);
      }
export type AddApplicationAnswersMutationHookResult = ReturnType<typeof useAddApplicationAnswersMutation>;
export type AddApplicationAnswersMutationResult = Apollo.MutationResult<AddApplicationAnswersMutation>;
export type AddApplicationAnswersMutationOptions = Apollo.BaseMutationOptions<AddApplicationAnswersMutation, AddApplicationAnswersMutationVariables>;
export const ApplyDocument = gql`
    mutation Apply($email: String!, $phoneNumber: String!, $firstName: String!, $lastName: String!, $addressLine1: String!, $addressLine2: String, $country: String!, $city: String!, $dob: String, $state: String!, $postalCode: String!, $programUrl: String!, $language: String!, $ethnicity: String, $gender: String, $blindDisabled: Boolean, $isHomeless: Boolean, $applicationId: ID) {
  apply(
    email: $email
    phoneNumber: $phoneNumber
    firstName: $firstName
    lastName: $lastName
    dob: $dob
    addressLine1: $addressLine1
    addressLine2: $addressLine2
    country: $country
    city: $city
    state: $state
    postalCode: $postalCode
    programUrl: $programUrl
    language: $language
    ethnicity: $ethnicity
    gender: $gender
    blindDisabled: $blindDisabled
    isHomeless: $isHomeless
    applicationId: $applicationId
  ) {
    application {
      id
      intercomKey
      person {
        id
      }
    }
    error
  }
}
    `;
export type ApplyMutationFn = Apollo.MutationFunction<ApplyMutation, ApplyMutationVariables>;

/**
 * __useApplyMutation__
 *
 * To run a mutation, you first call `useApplyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyMutation, { data, loading, error }] = useApplyMutation({
 *   variables: {
 *      email: // value for 'email'
 *      phoneNumber: // value for 'phoneNumber'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      addressLine1: // value for 'addressLine1'
 *      addressLine2: // value for 'addressLine2'
 *      country: // value for 'country'
 *      city: // value for 'city'
 *      dob: // value for 'dob'
 *      state: // value for 'state'
 *      postalCode: // value for 'postalCode'
 *      programUrl: // value for 'programUrl'
 *      language: // value for 'language'
 *      ethnicity: // value for 'ethnicity'
 *      gender: // value for 'gender'
 *      blindDisabled: // value for 'blindDisabled'
 *      isHomeless: // value for 'isHomeless'
 *      applicationId: // value for 'applicationId'
 *   },
 * });
 */
export function useApplyMutation(baseOptions?: Apollo.MutationHookOptions<ApplyMutation, ApplyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplyMutation, ApplyMutationVariables>(ApplyDocument, options);
      }
export type ApplyMutationHookResult = ReturnType<typeof useApplyMutation>;
export type ApplyMutationResult = Apollo.MutationResult<ApplyMutation>;
export type ApplyMutationOptions = Apollo.BaseMutationOptions<ApplyMutation, ApplyMutationVariables>;
export const GetProgramsDocument = gql`
    mutation GetPrograms($programUrl: String!, $includeClosedPeriod: Boolean) {
  getPrograms(programUrl: $programUrl, includeClosedPeriod: $includeClosedPeriod) {
    success
  }
}
    `;
export type GetProgramsMutationFn = Apollo.MutationFunction<GetProgramsMutation, GetProgramsMutationVariables>;

/**
 * __useGetProgramsMutation__
 *
 * To run a mutation, you first call `useGetProgramsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetProgramsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getProgramsMutation, { data, loading, error }] = useGetProgramsMutation({
 *   variables: {
 *      programUrl: // value for 'programUrl'
 *      includeClosedPeriod: // value for 'includeClosedPeriod'
 *   },
 * });
 */
export function useGetProgramsMutation(baseOptions?: Apollo.MutationHookOptions<GetProgramsMutation, GetProgramsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetProgramsMutation, GetProgramsMutationVariables>(GetProgramsDocument, options);
      }
export type GetProgramsMutationHookResult = ReturnType<typeof useGetProgramsMutation>;
export type GetProgramsMutationResult = Apollo.MutationResult<GetProgramsMutation>;
export type GetProgramsMutationOptions = Apollo.BaseMutationOptions<GetProgramsMutation, GetProgramsMutationVariables>;
export const GetPersonDocument = gql`
    mutation GetPerson($id: String!) {
  getPerson(id: $id) {
    person {
      communicationSetting {
        email
        phoneNumber
      }
      createdAt
      updatedAt
      invitations {
        invitationSent
        code
      }
      applicationDetails {
        status
        id
        selectedFor
        isLocked
        completed
        assignedAdmin {
          profile {
            firstName
            lastName
          }
        }
      }
      id
      benefitAnswers {
        edges {
          node {
            answer
            category
            householdMember {
              id
            }
          }
        }
      }
      householdMembers {
        id
        name
        dob
        relation
        blindDisabled
        earnedIncome
        unearnedIncome
      }
      locationDetail {
        addressLine1
        addressLine2
        city
        state
        zipCode
        country
        tractCode
      }
      profile {
        firstName
        lastName
        dob
        ethnicity
        language
        blindDisabled
        gender
        medianHouseholdIncome
        earnedIncome
        unearnedIncome
      }
    }
    documents {
      id
      documentType
      name
      rejected
      documentOriginalName
      updatedAt
      createdAt
      verifiedBy {
        profile {
          firstName
          lastName
        }
        email
      }
      uploadedAt
      requestedAs
    }
    flags {
      flagType
      inactive
      id
      person {
        id
        pk
      }
      matchedPerson {
        id
        profile {
          firstName
          lastName
        }
        flagsPerson {
          edges {
            node {
              inactive
              pk
              id
              person {
                pk
                id
              }
            }
          }
        }
      }
    }
    householdMembers {
      name
      dob
      relation
    }
    applicationAnswers {
      category
      response
    }
  }
}
    `;
export type GetPersonMutationFn = Apollo.MutationFunction<GetPersonMutation, GetPersonMutationVariables>;

/**
 * __useGetPersonMutation__
 *
 * To run a mutation, you first call `useGetPersonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetPersonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getPersonMutation, { data, loading, error }] = useGetPersonMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPersonMutation(baseOptions?: Apollo.MutationHookOptions<GetPersonMutation, GetPersonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetPersonMutation, GetPersonMutationVariables>(GetPersonDocument, options);
      }
export type GetPersonMutationHookResult = ReturnType<typeof useGetPersonMutation>;
export type GetPersonMutationResult = Apollo.MutationResult<GetPersonMutation>;
export type GetPersonMutationOptions = Apollo.BaseMutationOptions<GetPersonMutation, GetPersonMutationVariables>;
export const MakeFlagInactiveDocument = gql`
    mutation MakeFlagInactive($id: ID!, $relatedPersonId: ID, $personId: ID!) {
  makeFlagInactive(
    id: $id
    relatedPersonId: $relatedPersonId
    personId: $personId
  ) {
    success
  }
}
    `;
export type MakeFlagInactiveMutationFn = Apollo.MutationFunction<MakeFlagInactiveMutation, MakeFlagInactiveMutationVariables>;

/**
 * __useMakeFlagInactiveMutation__
 *
 * To run a mutation, you first call `useMakeFlagInactiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMakeFlagInactiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [makeFlagInactiveMutation, { data, loading, error }] = useMakeFlagInactiveMutation({
 *   variables: {
 *      id: // value for 'id'
 *      relatedPersonId: // value for 'relatedPersonId'
 *      personId: // value for 'personId'
 *   },
 * });
 */
export function useMakeFlagInactiveMutation(baseOptions?: Apollo.MutationHookOptions<MakeFlagInactiveMutation, MakeFlagInactiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MakeFlagInactiveMutation, MakeFlagInactiveMutationVariables>(MakeFlagInactiveDocument, options);
      }
export type MakeFlagInactiveMutationHookResult = ReturnType<typeof useMakeFlagInactiveMutation>;
export type MakeFlagInactiveMutationResult = Apollo.MutationResult<MakeFlagInactiveMutation>;
export type MakeFlagInactiveMutationOptions = Apollo.BaseMutationOptions<MakeFlagInactiveMutation, MakeFlagInactiveMutationVariables>;
export const DocumentUploadDocument = gql`
    mutation DocumentUpload($file: Upload!, $personId: ID!, $documentType: String!, $householdMemberId: ID) {
  documentUpload(
    file: $file
    personId: $personId
    documentType: $documentType
    householdMemberId: $householdMemberId
  ) {
    documentUploadSuccess
  }
}
    `;
export type DocumentUploadMutationFn = Apollo.MutationFunction<DocumentUploadMutation, DocumentUploadMutationVariables>;

/**
 * __useDocumentUploadMutation__
 *
 * To run a mutation, you first call `useDocumentUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDocumentUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [documentUploadMutation, { data, loading, error }] = useDocumentUploadMutation({
 *   variables: {
 *      file: // value for 'file'
 *      personId: // value for 'personId'
 *      documentType: // value for 'documentType'
 *      householdMemberId: // value for 'householdMemberId'
 *   },
 * });
 */
export function useDocumentUploadMutation(baseOptions?: Apollo.MutationHookOptions<DocumentUploadMutation, DocumentUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DocumentUploadMutation, DocumentUploadMutationVariables>(DocumentUploadDocument, options);
      }
export type DocumentUploadMutationHookResult = ReturnType<typeof useDocumentUploadMutation>;
export type DocumentUploadMutationResult = Apollo.MutationResult<DocumentUploadMutation>;
export type DocumentUploadMutationOptions = Apollo.BaseMutationOptions<DocumentUploadMutation, DocumentUploadMutationVariables>;
export const MultipleDocumentsUploadDocument = gql`
    mutation MultipleDocumentsUpload($files: [Upload]!, $personId: ID!, $documentType: String!, $householdMemberId: ID, $previousFiles: [String]) {
  multipleDocumentsUpload(
    files: $files
    personId: $personId
    documentType: $documentType
    householdMemberId: $householdMemberId
    previousFiles: $previousFiles
  ) {
    documentUploadSuccess
  }
}
    `;
export type MultipleDocumentsUploadMutationFn = Apollo.MutationFunction<MultipleDocumentsUploadMutation, MultipleDocumentsUploadMutationVariables>;

/**
 * __useMultipleDocumentsUploadMutation__
 *
 * To run a mutation, you first call `useMultipleDocumentsUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMultipleDocumentsUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [multipleDocumentsUploadMutation, { data, loading, error }] = useMultipleDocumentsUploadMutation({
 *   variables: {
 *      files: // value for 'files'
 *      personId: // value for 'personId'
 *      documentType: // value for 'documentType'
 *      householdMemberId: // value for 'householdMemberId'
 *      previousFiles: // value for 'previousFiles'
 *   },
 * });
 */
export function useMultipleDocumentsUploadMutation(baseOptions?: Apollo.MutationHookOptions<MultipleDocumentsUploadMutation, MultipleDocumentsUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MultipleDocumentsUploadMutation, MultipleDocumentsUploadMutationVariables>(MultipleDocumentsUploadDocument, options);
      }
export type MultipleDocumentsUploadMutationHookResult = ReturnType<typeof useMultipleDocumentsUploadMutation>;
export type MultipleDocumentsUploadMutationResult = Apollo.MutationResult<MultipleDocumentsUploadMutation>;
export type MultipleDocumentsUploadMutationOptions = Apollo.BaseMutationOptions<MultipleDocumentsUploadMutation, MultipleDocumentsUploadMutationVariables>;
export const RequestDocumentDocument = gql`
    mutation RequestDocument($requestedDocumentList: [String]!, $personId: ID!) {
  requestDocument(
    requestedDocumentList: $requestedDocumentList
    personId: $personId
  ) {
    documentRequestSuccess
  }
}
    `;
export type RequestDocumentMutationFn = Apollo.MutationFunction<RequestDocumentMutation, RequestDocumentMutationVariables>;

/**
 * __useRequestDocumentMutation__
 *
 * To run a mutation, you first call `useRequestDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestDocumentMutation, { data, loading, error }] = useRequestDocumentMutation({
 *   variables: {
 *      requestedDocumentList: // value for 'requestedDocumentList'
 *      personId: // value for 'personId'
 *   },
 * });
 */
export function useRequestDocumentMutation(baseOptions?: Apollo.MutationHookOptions<RequestDocumentMutation, RequestDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestDocumentMutation, RequestDocumentMutationVariables>(RequestDocumentDocument, options);
      }
export type RequestDocumentMutationHookResult = ReturnType<typeof useRequestDocumentMutation>;
export type RequestDocumentMutationResult = Apollo.MutationResult<RequestDocumentMutation>;
export type RequestDocumentMutationOptions = Apollo.BaseMutationOptions<RequestDocumentMutation, RequestDocumentMutationVariables>;
export const SendConfirmationDocument = gql`
    mutation SendConfirmation($applicationDetailsId: ID!) {
  sendConfirmation(applicationDetailsId: $applicationDetailsId) {
    ok
  }
}
    `;
export type SendConfirmationMutationFn = Apollo.MutationFunction<SendConfirmationMutation, SendConfirmationMutationVariables>;

/**
 * __useSendConfirmationMutation__
 *
 * To run a mutation, you first call `useSendConfirmationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendConfirmationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendConfirmationMutation, { data, loading, error }] = useSendConfirmationMutation({
 *   variables: {
 *      applicationDetailsId: // value for 'applicationDetailsId'
 *   },
 * });
 */
export function useSendConfirmationMutation(baseOptions?: Apollo.MutationHookOptions<SendConfirmationMutation, SendConfirmationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendConfirmationMutation, SendConfirmationMutationVariables>(SendConfirmationDocument, options);
      }
export type SendConfirmationMutationHookResult = ReturnType<typeof useSendConfirmationMutation>;
export type SendConfirmationMutationResult = Apollo.MutationResult<SendConfirmationMutation>;
export type SendConfirmationMutationOptions = Apollo.BaseMutationOptions<SendConfirmationMutation, SendConfirmationMutationVariables>;
export const SendDocumentsUploadConfirmationDocument = gql`
    mutation SendDocumentsUploadConfirmation($personId: ID!, $documentType: String) {
  sendDocumentsUploadConfirmation(
    personId: $personId
    documentType: $documentType
  ) {
    ok
  }
}
    `;
export type SendDocumentsUploadConfirmationMutationFn = Apollo.MutationFunction<SendDocumentsUploadConfirmationMutation, SendDocumentsUploadConfirmationMutationVariables>;

/**
 * __useSendDocumentsUploadConfirmationMutation__
 *
 * To run a mutation, you first call `useSendDocumentsUploadConfirmationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendDocumentsUploadConfirmationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendDocumentsUploadConfirmationMutation, { data, loading, error }] = useSendDocumentsUploadConfirmationMutation({
 *   variables: {
 *      personId: // value for 'personId'
 *      documentType: // value for 'documentType'
 *   },
 * });
 */
export function useSendDocumentsUploadConfirmationMutation(baseOptions?: Apollo.MutationHookOptions<SendDocumentsUploadConfirmationMutation, SendDocumentsUploadConfirmationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendDocumentsUploadConfirmationMutation, SendDocumentsUploadConfirmationMutationVariables>(SendDocumentsUploadConfirmationDocument, options);
      }
export type SendDocumentsUploadConfirmationMutationHookResult = ReturnType<typeof useSendDocumentsUploadConfirmationMutation>;
export type SendDocumentsUploadConfirmationMutationResult = Apollo.MutationResult<SendDocumentsUploadConfirmationMutation>;
export type SendDocumentsUploadConfirmationMutationOptions = Apollo.BaseMutationOptions<SendDocumentsUploadConfirmationMutation, SendDocumentsUploadConfirmationMutationVariables>;
export const SaveHouseholdMembersDocument = gql`
    mutation SaveHouseholdMembers($personId: ID!, $householdMembers: [HouseholdMemberInputType!]!) {
  saveHouseholdMembers(personId: $personId, householdMembers: $householdMembers) {
    success
  }
}
    `;
export type SaveHouseholdMembersMutationFn = Apollo.MutationFunction<SaveHouseholdMembersMutation, SaveHouseholdMembersMutationVariables>;

/**
 * __useSaveHouseholdMembersMutation__
 *
 * To run a mutation, you first call `useSaveHouseholdMembersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveHouseholdMembersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveHouseholdMembersMutation, { data, loading, error }] = useSaveHouseholdMembersMutation({
 *   variables: {
 *      personId: // value for 'personId'
 *      householdMembers: // value for 'householdMembers'
 *   },
 * });
 */
export function useSaveHouseholdMembersMutation(baseOptions?: Apollo.MutationHookOptions<SaveHouseholdMembersMutation, SaveHouseholdMembersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveHouseholdMembersMutation, SaveHouseholdMembersMutationVariables>(SaveHouseholdMembersDocument, options);
      }
export type SaveHouseholdMembersMutationHookResult = ReturnType<typeof useSaveHouseholdMembersMutation>;
export type SaveHouseholdMembersMutationResult = Apollo.MutationResult<SaveHouseholdMembersMutation>;
export type SaveHouseholdMembersMutationOptions = Apollo.BaseMutationOptions<SaveHouseholdMembersMutation, SaveHouseholdMembersMutationVariables>;
export const RecoverApplicationDocument = gql`
    mutation RecoverApplication($email: String!, $phoneNumber: String!) {
  recoverApplication(email: $email, phoneNumber: $phoneNumber) {
    ok
  }
}
    `;
export type RecoverApplicationMutationFn = Apollo.MutationFunction<RecoverApplicationMutation, RecoverApplicationMutationVariables>;

/**
 * __useRecoverApplicationMutation__
 *
 * To run a mutation, you first call `useRecoverApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecoverApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recoverApplicationMutation, { data, loading, error }] = useRecoverApplicationMutation({
 *   variables: {
 *      email: // value for 'email'
 *      phoneNumber: // value for 'phoneNumber'
 *   },
 * });
 */
export function useRecoverApplicationMutation(baseOptions?: Apollo.MutationHookOptions<RecoverApplicationMutation, RecoverApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecoverApplicationMutation, RecoverApplicationMutationVariables>(RecoverApplicationDocument, options);
      }
export type RecoverApplicationMutationHookResult = ReturnType<typeof useRecoverApplicationMutation>;
export type RecoverApplicationMutationResult = Apollo.MutationResult<RecoverApplicationMutation>;
export type RecoverApplicationMutationOptions = Apollo.BaseMutationOptions<RecoverApplicationMutation, RecoverApplicationMutationVariables>;
export const ListOfUploadedDocumentsDocument = gql`
    query listOfUploadedDocuments($id: ID!) {
  listOfUploadedDocuments(id: $id)
}
    `;

/**
 * __useListOfUploadedDocumentsQuery__
 *
 * To run a query within a React component, call `useListOfUploadedDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListOfUploadedDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListOfUploadedDocumentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useListOfUploadedDocumentsQuery(baseOptions: Apollo.QueryHookOptions<ListOfUploadedDocumentsQuery, ListOfUploadedDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListOfUploadedDocumentsQuery, ListOfUploadedDocumentsQueryVariables>(ListOfUploadedDocumentsDocument, options);
      }
export function useListOfUploadedDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListOfUploadedDocumentsQuery, ListOfUploadedDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListOfUploadedDocumentsQuery, ListOfUploadedDocumentsQueryVariables>(ListOfUploadedDocumentsDocument, options);
        }
export type ListOfUploadedDocumentsQueryHookResult = ReturnType<typeof useListOfUploadedDocumentsQuery>;
export type ListOfUploadedDocumentsLazyQueryHookResult = ReturnType<typeof useListOfUploadedDocumentsLazyQuery>;
export type ListOfUploadedDocumentsQueryResult = Apollo.QueryResult<ListOfUploadedDocumentsQuery, ListOfUploadedDocumentsQueryVariables>;
export const ListOfUploadedDocumentsIncludingNameDocument = gql`
    query listOfUploadedDocumentsIncludingName($id: ID!) {
  listOfUploadedDocumentsIncludingName(id: $id) {
    name
    documentType
  }
}
    `;

/**
 * __useListOfUploadedDocumentsIncludingNameQuery__
 *
 * To run a query within a React component, call `useListOfUploadedDocumentsIncludingNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useListOfUploadedDocumentsIncludingNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListOfUploadedDocumentsIncludingNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useListOfUploadedDocumentsIncludingNameQuery(baseOptions: Apollo.QueryHookOptions<ListOfUploadedDocumentsIncludingNameQuery, ListOfUploadedDocumentsIncludingNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListOfUploadedDocumentsIncludingNameQuery, ListOfUploadedDocumentsIncludingNameQueryVariables>(ListOfUploadedDocumentsIncludingNameDocument, options);
      }
export function useListOfUploadedDocumentsIncludingNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListOfUploadedDocumentsIncludingNameQuery, ListOfUploadedDocumentsIncludingNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListOfUploadedDocumentsIncludingNameQuery, ListOfUploadedDocumentsIncludingNameQueryVariables>(ListOfUploadedDocumentsIncludingNameDocument, options);
        }
export type ListOfUploadedDocumentsIncludingNameQueryHookResult = ReturnType<typeof useListOfUploadedDocumentsIncludingNameQuery>;
export type ListOfUploadedDocumentsIncludingNameLazyQueryHookResult = ReturnType<typeof useListOfUploadedDocumentsIncludingNameLazyQuery>;
export type ListOfUploadedDocumentsIncludingNameQueryResult = Apollo.QueryResult<ListOfUploadedDocumentsIncludingNameQuery, ListOfUploadedDocumentsIncludingNameQueryVariables>;
export const CountHouseholdMembersDocument = gql`
    query countHouseholdMembers($id: ID!) {
  countHouseholdMembers(personId: $id)
}
    `;

/**
 * __useCountHouseholdMembersQuery__
 *
 * To run a query within a React component, call `useCountHouseholdMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountHouseholdMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountHouseholdMembersQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCountHouseholdMembersQuery(baseOptions: Apollo.QueryHookOptions<CountHouseholdMembersQuery, CountHouseholdMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountHouseholdMembersQuery, CountHouseholdMembersQueryVariables>(CountHouseholdMembersDocument, options);
      }
export function useCountHouseholdMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountHouseholdMembersQuery, CountHouseholdMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountHouseholdMembersQuery, CountHouseholdMembersQueryVariables>(CountHouseholdMembersDocument, options);
        }
export type CountHouseholdMembersQueryHookResult = ReturnType<typeof useCountHouseholdMembersQuery>;
export type CountHouseholdMembersLazyQueryHookResult = ReturnType<typeof useCountHouseholdMembersLazyQuery>;
export type CountHouseholdMembersQueryResult = Apollo.QueryResult<CountHouseholdMembersQuery, CountHouseholdMembersQueryVariables>;
export const AddressAutocompleteQueryDocument = gql`
    query AddressAutocompleteQuery($value: String) {
  addressAutocomplete(value: $value) {
    placeId
    description
  }
}
    `;

/**
 * __useAddressAutocompleteQueryQuery__
 *
 * To run a query within a React component, call `useAddressAutocompleteQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddressAutocompleteQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddressAutocompleteQueryQuery({
 *   variables: {
 *      value: // value for 'value'
 *   },
 * });
 */
export function useAddressAutocompleteQueryQuery(baseOptions?: Apollo.QueryHookOptions<AddressAutocompleteQueryQuery, AddressAutocompleteQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AddressAutocompleteQueryQuery, AddressAutocompleteQueryQueryVariables>(AddressAutocompleteQueryDocument, options);
      }
export function useAddressAutocompleteQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AddressAutocompleteQueryQuery, AddressAutocompleteQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AddressAutocompleteQueryQuery, AddressAutocompleteQueryQueryVariables>(AddressAutocompleteQueryDocument, options);
        }
export type AddressAutocompleteQueryQueryHookResult = ReturnType<typeof useAddressAutocompleteQueryQuery>;
export type AddressAutocompleteQueryLazyQueryHookResult = ReturnType<typeof useAddressAutocompleteQueryLazyQuery>;
export type AddressAutocompleteQueryQueryResult = Apollo.QueryResult<AddressAutocompleteQueryQuery, AddressAutocompleteQueryQueryVariables>;
export const AddressDetailsQueryDocument = gql`
    query AddressDetailsQuery($placeId: String) {
  addressDetails(placeId: $placeId) {
    address1
    city
    state
    postalCode
  }
}
    `;

/**
 * __useAddressDetailsQueryQuery__
 *
 * To run a query within a React component, call `useAddressDetailsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddressDetailsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddressDetailsQueryQuery({
 *   variables: {
 *      placeId: // value for 'placeId'
 *   },
 * });
 */
export function useAddressDetailsQueryQuery(baseOptions?: Apollo.QueryHookOptions<AddressDetailsQueryQuery, AddressDetailsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AddressDetailsQueryQuery, AddressDetailsQueryQueryVariables>(AddressDetailsQueryDocument, options);
      }
export function useAddressDetailsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AddressDetailsQueryQuery, AddressDetailsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AddressDetailsQueryQuery, AddressDetailsQueryQueryVariables>(AddressDetailsQueryDocument, options);
        }
export type AddressDetailsQueryQueryHookResult = ReturnType<typeof useAddressDetailsQueryQuery>;
export type AddressDetailsQueryLazyQueryHookResult = ReturnType<typeof useAddressDetailsQueryLazyQuery>;
export type AddressDetailsQueryQueryResult = Apollo.QueryResult<AddressDetailsQueryQuery, AddressDetailsQueryQueryVariables>;
export const GetApplicationBasicInfoDocument = gql`
    query getApplicationBasicInfo($applicationId: String) {
  personApplication(applicationId: $applicationId) {
    applicationDetail {
      id
      completed
    }
    profile {
      firstName
      lastName
      dob
      blindDisabled
      earnedIncome
      unearnedIncome
      gender
      ethnicity
      language
      person {
        id
      }
    }
    communicationSetting {
      email
      phoneNumber
    }
    locationDetail {
      addressLine1
      addressLine2
      city
      state
      zipCode
    }
    householdMembers {
      name
      dob
      relation
      blindDisabled
      earnedIncome
      unearnedIncome
    }
    documents {
      edges {
        node {
          id
          documentType
          name
          documentOriginalName
          updatedAt
          createdAt
          rejected
          verifiedBy {
            profile {
              firstName
              lastName
            }
            email
          }
          uploadedAt
          person {
            id
          }
          householdMember {
            id
          }
          requestedAs
        }
      }
    }
  }
}
    `;

/**
 * __useGetApplicationBasicInfoQuery__
 *
 * To run a query within a React component, call `useGetApplicationBasicInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApplicationBasicInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApplicationBasicInfoQuery({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *   },
 * });
 */
export function useGetApplicationBasicInfoQuery(baseOptions?: Apollo.QueryHookOptions<GetApplicationBasicInfoQuery, GetApplicationBasicInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetApplicationBasicInfoQuery, GetApplicationBasicInfoQueryVariables>(GetApplicationBasicInfoDocument, options);
      }
export function useGetApplicationBasicInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetApplicationBasicInfoQuery, GetApplicationBasicInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetApplicationBasicInfoQuery, GetApplicationBasicInfoQueryVariables>(GetApplicationBasicInfoDocument, options);
        }
export type GetApplicationBasicInfoQueryHookResult = ReturnType<typeof useGetApplicationBasicInfoQuery>;
export type GetApplicationBasicInfoLazyQueryHookResult = ReturnType<typeof useGetApplicationBasicInfoLazyQuery>;
export type GetApplicationBasicInfoQueryResult = Apollo.QueryResult<GetApplicationBasicInfoQuery, GetApplicationBasicInfoQueryVariables>;
export const GetApplicationHouseholdMembersDocument = gql`
    query getApplicationHouseholdMembers($applicationId: String) {
  personApplication(applicationId: $applicationId) {
    householdMembers {
      id
      name
      dob
      relation
      blindDisabled
      earnedIncome
      unearnedIncome
    }
  }
}
    `;

/**
 * __useGetApplicationHouseholdMembersQuery__
 *
 * To run a query within a React component, call `useGetApplicationHouseholdMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApplicationHouseholdMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApplicationHouseholdMembersQuery({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *   },
 * });
 */
export function useGetApplicationHouseholdMembersQuery(baseOptions?: Apollo.QueryHookOptions<GetApplicationHouseholdMembersQuery, GetApplicationHouseholdMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetApplicationHouseholdMembersQuery, GetApplicationHouseholdMembersQueryVariables>(GetApplicationHouseholdMembersDocument, options);
      }
export function useGetApplicationHouseholdMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetApplicationHouseholdMembersQuery, GetApplicationHouseholdMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetApplicationHouseholdMembersQuery, GetApplicationHouseholdMembersQueryVariables>(GetApplicationHouseholdMembersDocument, options);
        }
export type GetApplicationHouseholdMembersQueryHookResult = ReturnType<typeof useGetApplicationHouseholdMembersQuery>;
export type GetApplicationHouseholdMembersLazyQueryHookResult = ReturnType<typeof useGetApplicationHouseholdMembersLazyQuery>;
export type GetApplicationHouseholdMembersQueryResult = Apollo.QueryResult<GetApplicationHouseholdMembersQuery, GetApplicationHouseholdMembersQueryVariables>;
export const PasswordChangeDocument = gql`
    mutation PasswordChange($oldPassword: String!, $newPassword1: String!, $newPassword2: String!) {
  passwordChange(
    oldPassword: $oldPassword
    newPassword1: $newPassword1
    newPassword2: $newPassword2
  ) {
    success
    errors
  }
}
    `;
export type PasswordChangeMutationFn = Apollo.MutationFunction<PasswordChangeMutation, PasswordChangeMutationVariables>;

/**
 * __usePasswordChangeMutation__
 *
 * To run a mutation, you first call `usePasswordChangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePasswordChangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [passwordChangeMutation, { data, loading, error }] = usePasswordChangeMutation({
 *   variables: {
 *      oldPassword: // value for 'oldPassword'
 *      newPassword1: // value for 'newPassword1'
 *      newPassword2: // value for 'newPassword2'
 *   },
 * });
 */
export function usePasswordChangeMutation(baseOptions?: Apollo.MutationHookOptions<PasswordChangeMutation, PasswordChangeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PasswordChangeMutation, PasswordChangeMutationVariables>(PasswordChangeDocument, options);
      }
export type PasswordChangeMutationHookResult = ReturnType<typeof usePasswordChangeMutation>;
export type PasswordChangeMutationResult = Apollo.MutationResult<PasswordChangeMutation>;
export type PasswordChangeMutationOptions = Apollo.BaseMutationOptions<PasswordChangeMutation, PasswordChangeMutationVariables>;
export const BenefitsAnswersDocument = gql`
    mutation BenefitsAnswers($answers: [BenefitAnswerInputType!]!) {
  addBenefitAnswers(answers: $answers) {
    ok
    error
  }
}
    `;
export type BenefitsAnswersMutationFn = Apollo.MutationFunction<BenefitsAnswersMutation, BenefitsAnswersMutationVariables>;

/**
 * __useBenefitsAnswersMutation__
 *
 * To run a mutation, you first call `useBenefitsAnswersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBenefitsAnswersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [benefitsAnswersMutation, { data, loading, error }] = useBenefitsAnswersMutation({
 *   variables: {
 *      answers: // value for 'answers'
 *   },
 * });
 */
export function useBenefitsAnswersMutation(baseOptions?: Apollo.MutationHookOptions<BenefitsAnswersMutation, BenefitsAnswersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BenefitsAnswersMutation, BenefitsAnswersMutationVariables>(BenefitsAnswersDocument, options);
      }
export type BenefitsAnswersMutationHookResult = ReturnType<typeof useBenefitsAnswersMutation>;
export type BenefitsAnswersMutationResult = Apollo.MutationResult<BenefitsAnswersMutation>;
export type BenefitsAnswersMutationOptions = Apollo.BaseMutationOptions<BenefitsAnswersMutation, BenefitsAnswersMutationVariables>;
export const BenefitsSelectionDocument = gql`
    mutation BenefitsSelection($benefits: [BenefitSelectedInputType!]!) {
  selectBenefits(benefits: $benefits) {
    ok
    error
  }
}
    `;
export type BenefitsSelectionMutationFn = Apollo.MutationFunction<BenefitsSelectionMutation, BenefitsSelectionMutationVariables>;

/**
 * __useBenefitsSelectionMutation__
 *
 * To run a mutation, you first call `useBenefitsSelectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBenefitsSelectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [benefitsSelectionMutation, { data, loading, error }] = useBenefitsSelectionMutation({
 *   variables: {
 *      benefits: // value for 'benefits'
 *   },
 * });
 */
export function useBenefitsSelectionMutation(baseOptions?: Apollo.MutationHookOptions<BenefitsSelectionMutation, BenefitsSelectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BenefitsSelectionMutation, BenefitsSelectionMutationVariables>(BenefitsSelectionDocument, options);
      }
export type BenefitsSelectionMutationHookResult = ReturnType<typeof useBenefitsSelectionMutation>;
export type BenefitsSelectionMutationResult = Apollo.MutationResult<BenefitsSelectionMutation>;
export type BenefitsSelectionMutationOptions = Apollo.BaseMutationOptions<BenefitsSelectionMutation, BenefitsSelectionMutationVariables>;
export const UpdateBlindDisabledDocument = gql`
    mutation UpdateBlindDisabled($blindDisabled: Boolean!, $inviteCode: String, $verificationCode: String) {
  updateBlindDisabled(
    inviteCode: $inviteCode
    blindDisabled: $blindDisabled
    verificationCode: $verificationCode
  ) {
    ok
    error
  }
}
    `;
export type UpdateBlindDisabledMutationFn = Apollo.MutationFunction<UpdateBlindDisabledMutation, UpdateBlindDisabledMutationVariables>;

/**
 * __useUpdateBlindDisabledMutation__
 *
 * To run a mutation, you first call `useUpdateBlindDisabledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBlindDisabledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBlindDisabledMutation, { data, loading, error }] = useUpdateBlindDisabledMutation({
 *   variables: {
 *      blindDisabled: // value for 'blindDisabled'
 *      inviteCode: // value for 'inviteCode'
 *      verificationCode: // value for 'verificationCode'
 *   },
 * });
 */
export function useUpdateBlindDisabledMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBlindDisabledMutation, UpdateBlindDisabledMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBlindDisabledMutation, UpdateBlindDisabledMutationVariables>(UpdateBlindDisabledDocument, options);
      }
export type UpdateBlindDisabledMutationHookResult = ReturnType<typeof useUpdateBlindDisabledMutation>;
export type UpdateBlindDisabledMutationResult = Apollo.MutationResult<UpdateBlindDisabledMutation>;
export type UpdateBlindDisabledMutationOptions = Apollo.BaseMutationOptions<UpdateBlindDisabledMutation, UpdateBlindDisabledMutationVariables>;
export const BenefitsAnswerQueryDocument = gql`
    query BenefitsAnswerQuery($personId: ID!) {
  benefitsAnswers(personId: $personId) {
    answer
    householdMember {
      id
      name
      dob
      relation
      blindDisabled
    }
    category
  }
}
    `;

/**
 * __useBenefitsAnswerQueryQuery__
 *
 * To run a query within a React component, call `useBenefitsAnswerQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useBenefitsAnswerQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBenefitsAnswerQueryQuery({
 *   variables: {
 *      personId: // value for 'personId'
 *   },
 * });
 */
export function useBenefitsAnswerQueryQuery(baseOptions: Apollo.QueryHookOptions<BenefitsAnswerQueryQuery, BenefitsAnswerQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BenefitsAnswerQueryQuery, BenefitsAnswerQueryQueryVariables>(BenefitsAnswerQueryDocument, options);
      }
export function useBenefitsAnswerQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BenefitsAnswerQueryQuery, BenefitsAnswerQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BenefitsAnswerQueryQuery, BenefitsAnswerQueryQueryVariables>(BenefitsAnswerQueryDocument, options);
        }
export type BenefitsAnswerQueryQueryHookResult = ReturnType<typeof useBenefitsAnswerQueryQuery>;
export type BenefitsAnswerQueryLazyQueryHookResult = ReturnType<typeof useBenefitsAnswerQueryLazyQuery>;
export type BenefitsAnswerQueryQueryResult = Apollo.QueryResult<BenefitsAnswerQueryQuery, BenefitsAnswerQueryQueryVariables>;
export const SelectedBenefitsDocument = gql`
    query SelectedBenefits($personId: ID!) {
  selectedBenefits(personId: $personId) {
    category
  }
}
    `;

/**
 * __useSelectedBenefitsQuery__
 *
 * To run a query within a React component, call `useSelectedBenefitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectedBenefitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectedBenefitsQuery({
 *   variables: {
 *      personId: // value for 'personId'
 *   },
 * });
 */
export function useSelectedBenefitsQuery(baseOptions: Apollo.QueryHookOptions<SelectedBenefitsQuery, SelectedBenefitsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelectedBenefitsQuery, SelectedBenefitsQueryVariables>(SelectedBenefitsDocument, options);
      }
export function useSelectedBenefitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelectedBenefitsQuery, SelectedBenefitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelectedBenefitsQuery, SelectedBenefitsQueryVariables>(SelectedBenefitsDocument, options);
        }
export type SelectedBenefitsQueryHookResult = ReturnType<typeof useSelectedBenefitsQuery>;
export type SelectedBenefitsLazyQueryHookResult = ReturnType<typeof useSelectedBenefitsLazyQuery>;
export type SelectedBenefitsQueryResult = Apollo.QueryResult<SelectedBenefitsQuery, SelectedBenefitsQueryVariables>;
export const GetApplicationDataDocument = gql`
    query GetApplicationData($inviteCode: String, $verificationCode: String) {
  personApplication(inviteCode: $inviteCode, verificationCode: $verificationCode) {
    profile {
      firstName
      lastName
      dob
      blindDisabled
      earnedIncome
      unearnedIncome
    }
    householdMembers {
      id
      name
      dob
      relation
      blindDisabled
      earnedIncome
      unearnedIncome
    }
  }
}
    `;

/**
 * __useGetApplicationDataQuery__
 *
 * To run a query within a React component, call `useGetApplicationDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApplicationDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApplicationDataQuery({
 *   variables: {
 *      inviteCode: // value for 'inviteCode'
 *      verificationCode: // value for 'verificationCode'
 *   },
 * });
 */
export function useGetApplicationDataQuery(baseOptions?: Apollo.QueryHookOptions<GetApplicationDataQuery, GetApplicationDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetApplicationDataQuery, GetApplicationDataQueryVariables>(GetApplicationDataDocument, options);
      }
export function useGetApplicationDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetApplicationDataQuery, GetApplicationDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetApplicationDataQuery, GetApplicationDataQueryVariables>(GetApplicationDataDocument, options);
        }
export type GetApplicationDataQueryHookResult = ReturnType<typeof useGetApplicationDataQuery>;
export type GetApplicationDataLazyQueryHookResult = ReturnType<typeof useGetApplicationDataLazyQuery>;
export type GetApplicationDataQueryResult = Apollo.QueryResult<GetApplicationDataQuery, GetApplicationDataQueryVariables>;
export const GetCalendlyScheduledEventDocument = gql`
    query GetCalendlyScheduledEvent($personId: ID!) {
  scheduledEvent(personId: $personId) {
    createdAt
    name
    status
    startTime
    endTime
  }
}
    `;

/**
 * __useGetCalendlyScheduledEventQuery__
 *
 * To run a query within a React component, call `useGetCalendlyScheduledEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCalendlyScheduledEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCalendlyScheduledEventQuery({
 *   variables: {
 *      personId: // value for 'personId'
 *   },
 * });
 */
export function useGetCalendlyScheduledEventQuery(baseOptions: Apollo.QueryHookOptions<GetCalendlyScheduledEventQuery, GetCalendlyScheduledEventQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCalendlyScheduledEventQuery, GetCalendlyScheduledEventQueryVariables>(GetCalendlyScheduledEventDocument, options);
      }
export function useGetCalendlyScheduledEventLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCalendlyScheduledEventQuery, GetCalendlyScheduledEventQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCalendlyScheduledEventQuery, GetCalendlyScheduledEventQueryVariables>(GetCalendlyScheduledEventDocument, options);
        }
export type GetCalendlyScheduledEventQueryHookResult = ReturnType<typeof useGetCalendlyScheduledEventQuery>;
export type GetCalendlyScheduledEventLazyQueryHookResult = ReturnType<typeof useGetCalendlyScheduledEventLazyQuery>;
export type GetCalendlyScheduledEventQueryResult = Apollo.QueryResult<GetCalendlyScheduledEventQuery, GetCalendlyScheduledEventQueryVariables>;
export const RegisterDocument = gql`
    mutation Register($email: String!, $password1: String!, $password2: String!, $securityQuestionQuestion: String!, $securityQuestionAnswer: String!) {
  register(
    email: $email
    password1: $password1
    password2: $password2
    securityQuestionQuestion: $securityQuestionQuestion
    securityQuestionAnswer: $securityQuestionAnswer
  ) {
    success
    errors
  }
}
    `;
export type RegisterMutationFn = Apollo.MutationFunction<RegisterMutation, RegisterMutationVariables>;

/**
 * __useRegisterMutation__
 *
 * To run a mutation, you first call `useRegisterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerMutation, { data, loading, error }] = useRegisterMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password1: // value for 'password1'
 *      password2: // value for 'password2'
 *      securityQuestionQuestion: // value for 'securityQuestionQuestion'
 *      securityQuestionAnswer: // value for 'securityQuestionAnswer'
 *   },
 * });
 */
export function useRegisterMutation(baseOptions?: Apollo.MutationHookOptions<RegisterMutation, RegisterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterMutation, RegisterMutationVariables>(RegisterDocument, options);
      }
export type RegisterMutationHookResult = ReturnType<typeof useRegisterMutation>;
export type RegisterMutationResult = Apollo.MutationResult<RegisterMutation>;
export type RegisterMutationOptions = Apollo.BaseMutationOptions<RegisterMutation, RegisterMutationVariables>;
export const SaveSixDigitVerificationCodeForPersonDocument = gql`
    mutation SaveSixDigitVerificationCodeForPerson($personId: String!, $phoneNumber: String!) {
  saveSixDigitVerificationCodeForPerson(
    personId: $personId
    phoneNumber: $phoneNumber
  ) {
    success
  }
}
    `;
export type SaveSixDigitVerificationCodeForPersonMutationFn = Apollo.MutationFunction<SaveSixDigitVerificationCodeForPersonMutation, SaveSixDigitVerificationCodeForPersonMutationVariables>;

/**
 * __useSaveSixDigitVerificationCodeForPersonMutation__
 *
 * To run a mutation, you first call `useSaveSixDigitVerificationCodeForPersonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveSixDigitVerificationCodeForPersonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveSixDigitVerificationCodeForPersonMutation, { data, loading, error }] = useSaveSixDigitVerificationCodeForPersonMutation({
 *   variables: {
 *      personId: // value for 'personId'
 *      phoneNumber: // value for 'phoneNumber'
 *   },
 * });
 */
export function useSaveSixDigitVerificationCodeForPersonMutation(baseOptions?: Apollo.MutationHookOptions<SaveSixDigitVerificationCodeForPersonMutation, SaveSixDigitVerificationCodeForPersonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveSixDigitVerificationCodeForPersonMutation, SaveSixDigitVerificationCodeForPersonMutationVariables>(SaveSixDigitVerificationCodeForPersonDocument, options);
      }
export type SaveSixDigitVerificationCodeForPersonMutationHookResult = ReturnType<typeof useSaveSixDigitVerificationCodeForPersonMutation>;
export type SaveSixDigitVerificationCodeForPersonMutationResult = Apollo.MutationResult<SaveSixDigitVerificationCodeForPersonMutation>;
export type SaveSixDigitVerificationCodeForPersonMutationOptions = Apollo.BaseMutationOptions<SaveSixDigitVerificationCodeForPersonMutation, SaveSixDigitVerificationCodeForPersonMutationVariables>;
export const CheckSixDigitVerificationCodeForPersonDocument = gql`
    mutation CheckSixDigitVerificationCodeForPerson($personId: String!, $verificationCode: String!) {
  checkSixDigitVerificationCodeForPerson(
    personId: $personId
    verificationCode: $verificationCode
  ) {
    success
  }
}
    `;
export type CheckSixDigitVerificationCodeForPersonMutationFn = Apollo.MutationFunction<CheckSixDigitVerificationCodeForPersonMutation, CheckSixDigitVerificationCodeForPersonMutationVariables>;

/**
 * __useCheckSixDigitVerificationCodeForPersonMutation__
 *
 * To run a mutation, you first call `useCheckSixDigitVerificationCodeForPersonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckSixDigitVerificationCodeForPersonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkSixDigitVerificationCodeForPersonMutation, { data, loading, error }] = useCheckSixDigitVerificationCodeForPersonMutation({
 *   variables: {
 *      personId: // value for 'personId'
 *      verificationCode: // value for 'verificationCode'
 *   },
 * });
 */
export function useCheckSixDigitVerificationCodeForPersonMutation(baseOptions?: Apollo.MutationHookOptions<CheckSixDigitVerificationCodeForPersonMutation, CheckSixDigitVerificationCodeForPersonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CheckSixDigitVerificationCodeForPersonMutation, CheckSixDigitVerificationCodeForPersonMutationVariables>(CheckSixDigitVerificationCodeForPersonDocument, options);
      }
export type CheckSixDigitVerificationCodeForPersonMutationHookResult = ReturnType<typeof useCheckSixDigitVerificationCodeForPersonMutation>;
export type CheckSixDigitVerificationCodeForPersonMutationResult = Apollo.MutationResult<CheckSixDigitVerificationCodeForPersonMutation>;
export type CheckSixDigitVerificationCodeForPersonMutationOptions = Apollo.BaseMutationOptions<CheckSixDigitVerificationCodeForPersonMutation, CheckSixDigitVerificationCodeForPersonMutationVariables>;
export const OnboardingLogosDocument = gql`
    query OnboardingLogos($id: ID!) {
  onboardingLogos(id: $id) {
    position
    image
    url
  }
}
    `;

/**
 * __useOnboardingLogosQuery__
 *
 * To run a query within a React component, call `useOnboardingLogosQuery` and pass it any options that fit your needs.
 * When your component renders, `useOnboardingLogosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnboardingLogosQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOnboardingLogosQuery(baseOptions: Apollo.QueryHookOptions<OnboardingLogosQuery, OnboardingLogosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OnboardingLogosQuery, OnboardingLogosQueryVariables>(OnboardingLogosDocument, options);
      }
export function useOnboardingLogosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OnboardingLogosQuery, OnboardingLogosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OnboardingLogosQuery, OnboardingLogosQueryVariables>(OnboardingLogosDocument, options);
        }
export type OnboardingLogosQueryHookResult = ReturnType<typeof useOnboardingLogosQuery>;
export type OnboardingLogosLazyQueryHookResult = ReturnType<typeof useOnboardingLogosLazyQuery>;
export type OnboardingLogosQueryResult = Apollo.QueryResult<OnboardingLogosQuery, OnboardingLogosQueryVariables>;
export const SpeakBenefitsCounselorDocument = gql`
    mutation SpeakBenefitsCounselor($firstName: String!, $language: String!, $phoneNumber: String!, $email: String!, $personId: ID!) {
  speakBenefitsCounselor(
    firstName: $firstName
    language: $language
    phoneNumber: $phoneNumber
    email: $email
    personId: $personId
  ) {
    ok
  }
}
    `;
export type SpeakBenefitsCounselorMutationFn = Apollo.MutationFunction<SpeakBenefitsCounselorMutation, SpeakBenefitsCounselorMutationVariables>;

/**
 * __useSpeakBenefitsCounselorMutation__
 *
 * To run a mutation, you first call `useSpeakBenefitsCounselorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSpeakBenefitsCounselorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [speakBenefitsCounselorMutation, { data, loading, error }] = useSpeakBenefitsCounselorMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      language: // value for 'language'
 *      phoneNumber: // value for 'phoneNumber'
 *      email: // value for 'email'
 *      personId: // value for 'personId'
 *   },
 * });
 */
export function useSpeakBenefitsCounselorMutation(baseOptions?: Apollo.MutationHookOptions<SpeakBenefitsCounselorMutation, SpeakBenefitsCounselorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SpeakBenefitsCounselorMutation, SpeakBenefitsCounselorMutationVariables>(SpeakBenefitsCounselorDocument, options);
      }
export type SpeakBenefitsCounselorMutationHookResult = ReturnType<typeof useSpeakBenefitsCounselorMutation>;
export type SpeakBenefitsCounselorMutationResult = Apollo.MutationResult<SpeakBenefitsCounselorMutation>;
export type SpeakBenefitsCounselorMutationOptions = Apollo.BaseMutationOptions<SpeakBenefitsCounselorMutation, SpeakBenefitsCounselorMutationVariables>;
export const CodeValidationDocument = gql`
    query CodeValidation($inviteCode: String, $resetToken: String, $verificationCode: String) {
  codeValidation(
    inviteCode: $inviteCode
    resetToken: $resetToken
    verificationCode: $verificationCode
  ) {
    alreadySignedUp
    person {
      ...Person
    }
  }
}
    ${PersonFragmentDoc}`;

/**
 * __useCodeValidationQuery__
 *
 * To run a query within a React component, call `useCodeValidationQuery` and pass it any options that fit your needs.
 * When your component renders, `useCodeValidationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCodeValidationQuery({
 *   variables: {
 *      inviteCode: // value for 'inviteCode'
 *      resetToken: // value for 'resetToken'
 *      verificationCode: // value for 'verificationCode'
 *   },
 * });
 */
export function useCodeValidationQuery(baseOptions?: Apollo.QueryHookOptions<CodeValidationQuery, CodeValidationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CodeValidationQuery, CodeValidationQueryVariables>(CodeValidationDocument, options);
      }
export function useCodeValidationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CodeValidationQuery, CodeValidationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CodeValidationQuery, CodeValidationQueryVariables>(CodeValidationDocument, options);
        }
export type CodeValidationQueryHookResult = ReturnType<typeof useCodeValidationQuery>;
export type CodeValidationLazyQueryHookResult = ReturnType<typeof useCodeValidationLazyQuery>;
export type CodeValidationQueryResult = Apollo.QueryResult<CodeValidationQuery, CodeValidationQueryVariables>;
export const GetApplicationAnswersDocument = gql`
    query GetApplicationAnswers($applicationId: ID!) {
  allUserAnswers(applicationId: $applicationId) {
    category
    response
  }
}
    `;

/**
 * __useGetApplicationAnswersQuery__
 *
 * To run a query within a React component, call `useGetApplicationAnswersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApplicationAnswersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApplicationAnswersQuery({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *   },
 * });
 */
export function useGetApplicationAnswersQuery(baseOptions: Apollo.QueryHookOptions<GetApplicationAnswersQuery, GetApplicationAnswersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetApplicationAnswersQuery, GetApplicationAnswersQueryVariables>(GetApplicationAnswersDocument, options);
      }
export function useGetApplicationAnswersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetApplicationAnswersQuery, GetApplicationAnswersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetApplicationAnswersQuery, GetApplicationAnswersQueryVariables>(GetApplicationAnswersDocument, options);
        }
export type GetApplicationAnswersQueryHookResult = ReturnType<typeof useGetApplicationAnswersQuery>;
export type GetApplicationAnswersLazyQueryHookResult = ReturnType<typeof useGetApplicationAnswersLazyQuery>;
export type GetApplicationAnswersQueryResult = Apollo.QueryResult<GetApplicationAnswersQuery, GetApplicationAnswersQueryVariables>;
export const SendPasswordResetEmailDocument = gql`
    mutation SendPasswordResetEmail($email: String!) {
  sendPasswordResetEmail(email: $email) {
    success
    errors
  }
}
    `;
export type SendPasswordResetEmailMutationFn = Apollo.MutationFunction<SendPasswordResetEmailMutation, SendPasswordResetEmailMutationVariables>;

/**
 * __useSendPasswordResetEmailMutation__
 *
 * To run a mutation, you first call `useSendPasswordResetEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendPasswordResetEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendPasswordResetEmailMutation, { data, loading, error }] = useSendPasswordResetEmailMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useSendPasswordResetEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendPasswordResetEmailMutation, SendPasswordResetEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendPasswordResetEmailMutation, SendPasswordResetEmailMutationVariables>(SendPasswordResetEmailDocument, options);
      }
export type SendPasswordResetEmailMutationHookResult = ReturnType<typeof useSendPasswordResetEmailMutation>;
export type SendPasswordResetEmailMutationResult = Apollo.MutationResult<SendPasswordResetEmailMutation>;
export type SendPasswordResetEmailMutationOptions = Apollo.BaseMutationOptions<SendPasswordResetEmailMutation, SendPasswordResetEmailMutationVariables>;
export const MyRecentPaymentsDocument = gql`
    query MyRecentPayments {
  myRecentPayments {
    id
    transferMethod {
      oneLiner
      halfLiner
      type
    }
    amount
    createdAt
    status
  }
}
    `;

/**
 * __useMyRecentPaymentsQuery__
 *
 * To run a query within a React component, call `useMyRecentPaymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyRecentPaymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyRecentPaymentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyRecentPaymentsQuery(baseOptions?: Apollo.QueryHookOptions<MyRecentPaymentsQuery, MyRecentPaymentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyRecentPaymentsQuery, MyRecentPaymentsQueryVariables>(MyRecentPaymentsDocument, options);
      }
export function useMyRecentPaymentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyRecentPaymentsQuery, MyRecentPaymentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyRecentPaymentsQuery, MyRecentPaymentsQueryVariables>(MyRecentPaymentsDocument, options);
        }
export type MyRecentPaymentsQueryHookResult = ReturnType<typeof useMyRecentPaymentsQuery>;
export type MyRecentPaymentsLazyQueryHookResult = ReturnType<typeof useMyRecentPaymentsLazyQuery>;
export type MyRecentPaymentsQueryResult = Apollo.QueryResult<MyRecentPaymentsQuery, MyRecentPaymentsQueryVariables>;
export const MyScheduledPaymentsDocument = gql`
    query MyScheduledPayments {
  myUpcomingScheduledPayments {
    id
    scheduledDate
    amount
  }
}
    `;

/**
 * __useMyScheduledPaymentsQuery__
 *
 * To run a query within a React component, call `useMyScheduledPaymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyScheduledPaymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyScheduledPaymentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyScheduledPaymentsQuery(baseOptions?: Apollo.QueryHookOptions<MyScheduledPaymentsQuery, MyScheduledPaymentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyScheduledPaymentsQuery, MyScheduledPaymentsQueryVariables>(MyScheduledPaymentsDocument, options);
      }
export function useMyScheduledPaymentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyScheduledPaymentsQuery, MyScheduledPaymentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyScheduledPaymentsQuery, MyScheduledPaymentsQueryVariables>(MyScheduledPaymentsDocument, options);
        }
export type MyScheduledPaymentsQueryHookResult = ReturnType<typeof useMyScheduledPaymentsQuery>;
export type MyScheduledPaymentsLazyQueryHookResult = ReturnType<typeof useMyScheduledPaymentsLazyQuery>;
export type MyScheduledPaymentsQueryResult = Apollo.QueryResult<MyScheduledPaymentsQuery, MyScheduledPaymentsQueryVariables>;
export const MyUpcomingPaymentDocument = gql`
    query MyUpcomingPayment {
  myUpcomingPayment {
    id
    scheduledDate
    amount
  }
  myLastPayment {
    id
    scheduledDate
    amount
  }
}
    `;

/**
 * __useMyUpcomingPaymentQuery__
 *
 * To run a query within a React component, call `useMyUpcomingPaymentQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyUpcomingPaymentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyUpcomingPaymentQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyUpcomingPaymentQuery(baseOptions?: Apollo.QueryHookOptions<MyUpcomingPaymentQuery, MyUpcomingPaymentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyUpcomingPaymentQuery, MyUpcomingPaymentQueryVariables>(MyUpcomingPaymentDocument, options);
      }
export function useMyUpcomingPaymentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyUpcomingPaymentQuery, MyUpcomingPaymentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyUpcomingPaymentQuery, MyUpcomingPaymentQueryVariables>(MyUpcomingPaymentDocument, options);
        }
export type MyUpcomingPaymentQueryHookResult = ReturnType<typeof useMyUpcomingPaymentQuery>;
export type MyUpcomingPaymentLazyQueryHookResult = ReturnType<typeof useMyUpcomingPaymentLazyQuery>;
export type MyUpcomingPaymentQueryResult = Apollo.QueryResult<MyUpcomingPaymentQuery, MyUpcomingPaymentQueryVariables>;
export const GetTransactionDetailsPortalDocument = gql`
    query GetTransactionDetailsPortal {
  transactionDetailsPortal {
    amount
    pending
    type
    mcc
    newBalance
    merchantDescription
    date
  }
}
    `;

/**
 * __useGetTransactionDetailsPortalQuery__
 *
 * To run a query within a React component, call `useGetTransactionDetailsPortalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransactionDetailsPortalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransactionDetailsPortalQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTransactionDetailsPortalQuery(baseOptions?: Apollo.QueryHookOptions<GetTransactionDetailsPortalQuery, GetTransactionDetailsPortalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTransactionDetailsPortalQuery, GetTransactionDetailsPortalQueryVariables>(GetTransactionDetailsPortalDocument, options);
      }
export function useGetTransactionDetailsPortalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTransactionDetailsPortalQuery, GetTransactionDetailsPortalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTransactionDetailsPortalQuery, GetTransactionDetailsPortalQueryVariables>(GetTransactionDetailsPortalDocument, options);
        }
export type GetTransactionDetailsPortalQueryHookResult = ReturnType<typeof useGetTransactionDetailsPortalQuery>;
export type GetTransactionDetailsPortalLazyQueryHookResult = ReturnType<typeof useGetTransactionDetailsPortalLazyQuery>;
export type GetTransactionDetailsPortalQueryResult = Apollo.QueryResult<GetTransactionDetailsPortalQuery, GetTransactionDetailsPortalQueryVariables>;
export const StylesDocument = gql`
    query Styles {
  styles {
    primaryColor
    secondaryColor
    tertiaryColor
    hoverColor
    backgroundColor
    sidebarLogo
    sidebarLogoMobile
    sidebarImage
  }
}
    `;

/**
 * __useStylesQuery__
 *
 * To run a query within a React component, call `useStylesQuery` and pass it any options that fit your needs.
 * When your component renders, `useStylesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStylesQuery({
 *   variables: {
 *   },
 * });
 */
export function useStylesQuery(baseOptions?: Apollo.QueryHookOptions<StylesQuery, StylesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StylesQuery, StylesQueryVariables>(StylesDocument, options);
      }
export function useStylesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StylesQuery, StylesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StylesQuery, StylesQueryVariables>(StylesDocument, options);
        }
export type StylesQueryHookResult = ReturnType<typeof useStylesQuery>;
export type StylesLazyQueryHookResult = ReturnType<typeof useStylesLazyQuery>;
export type StylesQueryResult = Apollo.QueryResult<StylesQuery, StylesQueryVariables>;
export const CardBalanceDocument = gql`
    query CardBalance($id: ID) {
  cardBalance(id: $id)
}
    `;

/**
 * __useCardBalanceQuery__
 *
 * To run a query within a React component, call `useCardBalanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useCardBalanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCardBalanceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCardBalanceQuery(baseOptions?: Apollo.QueryHookOptions<CardBalanceQuery, CardBalanceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CardBalanceQuery, CardBalanceQueryVariables>(CardBalanceDocument, options);
      }
export function useCardBalanceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CardBalanceQuery, CardBalanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CardBalanceQuery, CardBalanceQueryVariables>(CardBalanceDocument, options);
        }
export type CardBalanceQueryHookResult = ReturnType<typeof useCardBalanceQuery>;
export type CardBalanceLazyQueryHookResult = ReturnType<typeof useCardBalanceLazyQuery>;
export type CardBalanceQueryResult = Apollo.QueryResult<CardBalanceQuery, CardBalanceQueryVariables>;
export const GetInitialDataDocument = gql`
    query GetInitialData {
  program {
    name
    paymentFrequency
    paymentAmount
    programDuration
    numberOfMonths
    ssiBenefitsWizardEnabled
    id
    urlFragment
    isActiveProgram
  }
  organizationConfigs {
    facebookLink
    instagramLink
    phoneNumber
    replyToEmail
    timezone
    twitterLink
    typeformId
    typeformSubdomain
    websiteLink
    isTypeformBound
    whatsappPhoneNumber
    gaMeasurementId
    googleTagManagerId
    prepaidCardPickupLocations
  }
  organization {
    version
    webAppUrl
    name
    id
  }
  translations
  documentRequirement {
    type
    required
  }
  languages
  consentTypes {
    id
    name
    translationKey
    isRequired
    displayOrder
    __typename
  }
}
    `;

/**
 * __useGetInitialDataQuery__
 *
 * To run a query within a React component, call `useGetInitialDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInitialDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInitialDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetInitialDataQuery(baseOptions?: Apollo.QueryHookOptions<GetInitialDataQuery, GetInitialDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInitialDataQuery, GetInitialDataQueryVariables>(GetInitialDataDocument, options);
      }
export function useGetInitialDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInitialDataQuery, GetInitialDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInitialDataQuery, GetInitialDataQueryVariables>(GetInitialDataDocument, options);
        }
export type GetInitialDataQueryHookResult = ReturnType<typeof useGetInitialDataQuery>;
export type GetInitialDataLazyQueryHookResult = ReturnType<typeof useGetInitialDataLazyQuery>;
export type GetInitialDataQueryResult = Apollo.QueryResult<GetInitialDataQuery, GetInitialDataQueryVariables>;
export const LoginDocument = gql`
    mutation Login($email: String!, $password: String!) {
  tokenAuth(email: $email, password: $password) {
    success
    token
    refreshToken
    errors
  }
}
    `;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const PasswordResetDocument = gql`
    mutation PasswordReset($token: String!, $newPassword1: String!, $newPassword2: String!) {
  passwordReset(
    token: $token
    newPassword1: $newPassword1
    newPassword2: $newPassword2
  ) {
    success
    errors
  }
}
    `;
export type PasswordResetMutationFn = Apollo.MutationFunction<PasswordResetMutation, PasswordResetMutationVariables>;

/**
 * __usePasswordResetMutation__
 *
 * To run a mutation, you first call `usePasswordResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePasswordResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [passwordResetMutation, { data, loading, error }] = usePasswordResetMutation({
 *   variables: {
 *      token: // value for 'token'
 *      newPassword1: // value for 'newPassword1'
 *      newPassword2: // value for 'newPassword2'
 *   },
 * });
 */
export function usePasswordResetMutation(baseOptions?: Apollo.MutationHookOptions<PasswordResetMutation, PasswordResetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PasswordResetMutation, PasswordResetMutationVariables>(PasswordResetDocument, options);
      }
export type PasswordResetMutationHookResult = ReturnType<typeof usePasswordResetMutation>;
export type PasswordResetMutationResult = Apollo.MutationResult<PasswordResetMutation>;
export type PasswordResetMutationOptions = Apollo.BaseMutationOptions<PasswordResetMutation, PasswordResetMutationVariables>;
export const GetPersonWithHashedIdDocument = gql`
    query GetPersonWithHashedId($hashedId: String!) {
  personWithHashedId(hashedId: $hashedId) {
    id
    communicationSetting {
      phoneNumber
      email
    }
    createdAt
    updatedAt
    invitations {
      code
    }
    applicationDetails {
      status
      isLocked
      reachedVerifyScreen
      selectedFor
      answers {
        edges {
          node {
            category
            response
          }
        }
      }
    }
    pk
    benefitAnswers {
      edges {
        node {
          answer
          category
          householdMember {
            id
          }
        }
      }
    }
    documents {
      edges {
        node {
          id
          documentType
          name
          updatedAt
          createdAt
          verifiedBy {
            profile {
              firstName
              lastName
            }
            email
          }
          uploadedAt
          requestedAs
        }
      }
    }
    profile {
      blindDisabled
      firstName
      lastName
      dob
      medianHouseholdIncome
      earnedIncome
      unearnedIncome
      language
    }
    locationDetail {
      addressLine1
      addressLine2
      city
      state
      zipCode
      country
      tractCode
    }
    householdMembers {
      id
      name
      dob
      relation
      blindDisabled
      earnedIncome
      unearnedIncome
    }
  }
}
    `;

/**
 * __useGetPersonWithHashedIdQuery__
 *
 * To run a query within a React component, call `useGetPersonWithHashedIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPersonWithHashedIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPersonWithHashedIdQuery({
 *   variables: {
 *      hashedId: // value for 'hashedId'
 *   },
 * });
 */
export function useGetPersonWithHashedIdQuery(baseOptions: Apollo.QueryHookOptions<GetPersonWithHashedIdQuery, GetPersonWithHashedIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPersonWithHashedIdQuery, GetPersonWithHashedIdQueryVariables>(GetPersonWithHashedIdDocument, options);
      }
export function useGetPersonWithHashedIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPersonWithHashedIdQuery, GetPersonWithHashedIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPersonWithHashedIdQuery, GetPersonWithHashedIdQueryVariables>(GetPersonWithHashedIdDocument, options);
        }
export type GetPersonWithHashedIdQueryHookResult = ReturnType<typeof useGetPersonWithHashedIdQuery>;
export type GetPersonWithHashedIdLazyQueryHookResult = ReturnType<typeof useGetPersonWithHashedIdLazyQuery>;
export type GetPersonWithHashedIdQueryResult = Apollo.QueryResult<GetPersonWithHashedIdQuery, GetPersonWithHashedIdQueryVariables>;
export const RefreshTokenDocument = gql`
    mutation RefreshToken($refreshToken: String!) {
  refreshToken(refreshToken: $refreshToken) {
    token
    payload
    success
    errors
    refreshToken
  }
}
    `;
export type RefreshTokenMutationFn = Apollo.MutationFunction<RefreshTokenMutation, RefreshTokenMutationVariables>;

/**
 * __useRefreshTokenMutation__
 *
 * To run a mutation, you first call `useRefreshTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshTokenMutation, { data, loading, error }] = useRefreshTokenMutation({
 *   variables: {
 *      refreshToken: // value for 'refreshToken'
 *   },
 * });
 */
export function useRefreshTokenMutation(baseOptions?: Apollo.MutationHookOptions<RefreshTokenMutation, RefreshTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshTokenMutation, RefreshTokenMutationVariables>(RefreshTokenDocument, options);
      }
export type RefreshTokenMutationHookResult = ReturnType<typeof useRefreshTokenMutation>;
export type RefreshTokenMutationResult = Apollo.MutationResult<RefreshTokenMutation>;
export type RefreshTokenMutationOptions = Apollo.BaseMutationOptions<RefreshTokenMutation, RefreshTokenMutationVariables>;
export const UpdateDetailsDocument = gql`
    mutation UpdateDetails($firstName: String, $lastName: String, $phoneNumber: String, $dob: String, $addressLine1: String, $addressLine2: String, $city: String, $state: String, $zipCode: String) {
  updateDetails(
    firstName: $firstName
    lastName: $lastName
    phoneNumber: $phoneNumber
    dob: $dob
    addressLine1: $addressLine1
    addressLine2: $addressLine2
    city: $city
    state: $state
    zipCode: $zipCode
  ) {
    success
  }
}
    `;
export type UpdateDetailsMutationFn = Apollo.MutationFunction<UpdateDetailsMutation, UpdateDetailsMutationVariables>;

/**
 * __useUpdateDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDetailsMutation, { data, loading, error }] = useUpdateDetailsMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      phoneNumber: // value for 'phoneNumber'
 *      dob: // value for 'dob'
 *      addressLine1: // value for 'addressLine1'
 *      addressLine2: // value for 'addressLine2'
 *      city: // value for 'city'
 *      state: // value for 'state'
 *      zipCode: // value for 'zipCode'
 *   },
 * });
 */
export function useUpdateDetailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDetailsMutation, UpdateDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDetailsMutation, UpdateDetailsMutationVariables>(UpdateDetailsDocument, options);
      }
export type UpdateDetailsMutationHookResult = ReturnType<typeof useUpdateDetailsMutation>;
export type UpdateDetailsMutationResult = Apollo.MutationResult<UpdateDetailsMutation>;
export type UpdateDetailsMutationOptions = Apollo.BaseMutationOptions<UpdateDetailsMutation, UpdateDetailsMutationVariables>;
export const LogoutDocument = gql`
    mutation Logout {
  logout {
    ok
  }
}
    `;
export type LogoutMutationFn = Apollo.MutationFunction<LogoutMutation, LogoutMutationVariables>;

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutMutation(baseOptions?: Apollo.MutationHookOptions<LogoutMutation, LogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument, options);
      }
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = Apollo.MutationResult<LogoutMutation>;
export type LogoutMutationOptions = Apollo.BaseMutationOptions<LogoutMutation, LogoutMutationVariables>;
export const MeDocument = gql`
    query Me {
  me {
    id
    email
    createdAt
    pk
    isSuperuser
    communicationSetting {
      phoneNumber
      email
      smsNotificationsEnabled
      emailNotificationsEnabled
      whatsappNotificationsEnabled
    }
    paymentProfile {
      paymentAmount
      paymentFrequencyType
      hyperwalletToken
      numberOfMonths
      frozen
      ...TransferMethods
    }
    person {
      id
      intercomKey
      applicationDetails {
        program {
          id
          urlFragment
          organization {
            id
          }
        }
      }
      profile {
        language
        firstName
        lastName
        earnedIncome
        unearnedIncome
        dob
      }
      locationDetail {
        addressLine1
        addressLine2
        city
        state
        zipCode
        country
      }
    }
  }
}
    ${TransferMethodsFragmentDoc}`;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const SurveyAvailableDocument = gql`
    query SurveyAvailable {
  surveyAvailable
}
    `;

/**
 * __useSurveyAvailableQuery__
 *
 * To run a query within a React component, call `useSurveyAvailableQuery` and pass it any options that fit your needs.
 * When your component renders, `useSurveyAvailableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSurveyAvailableQuery({
 *   variables: {
 *   },
 * });
 */
export function useSurveyAvailableQuery(baseOptions?: Apollo.QueryHookOptions<SurveyAvailableQuery, SurveyAvailableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SurveyAvailableQuery, SurveyAvailableQueryVariables>(SurveyAvailableDocument, options);
      }
export function useSurveyAvailableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SurveyAvailableQuery, SurveyAvailableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SurveyAvailableQuery, SurveyAvailableQueryVariables>(SurveyAvailableDocument, options);
        }
export type SurveyAvailableQueryHookResult = ReturnType<typeof useSurveyAvailableQuery>;
export type SurveyAvailableLazyQueryHookResult = ReturnType<typeof useSurveyAvailableLazyQuery>;
export type SurveyAvailableQueryResult = Apollo.QueryResult<SurveyAvailableQuery, SurveyAvailableQueryVariables>;
export const UsersDocument = gql`
    query Users {
  users {
    pk
    communicationSetting {
      phoneNumber
    }
    person {
      profile {
        firstName
        language
        lastName
        dob
        earnedIncome
        unearnedIncome
      }
    }
    paymentProfile {
      paymentAmount
      paymentFrequencyType
      startDate
      frozen
    }
  }
}
    `;

/**
 * __useUsersQuery__
 *
 * To run a query within a React component, call `useUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useUsersQuery(baseOptions?: Apollo.QueryHookOptions<UsersQuery, UsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
      }
export function useUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersQuery, UsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
        }
export type UsersQueryHookResult = ReturnType<typeof useUsersQuery>;
export type UsersLazyQueryHookResult = ReturnType<typeof useUsersLazyQuery>;
export type UsersQueryResult = Apollo.QueryResult<UsersQuery, UsersQueryVariables>;
export const TransferMethodRemoveDocument = gql`
    mutation transferMethodRemove($id: ID!) {
  transferMethodRemove(id: $id) {
    user {
      id
    }
  }
}
    `;
export type TransferMethodRemoveMutationFn = Apollo.MutationFunction<TransferMethodRemoveMutation, TransferMethodRemoveMutationVariables>;

/**
 * __useTransferMethodRemoveMutation__
 *
 * To run a mutation, you first call `useTransferMethodRemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransferMethodRemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transferMethodRemoveMutation, { data, loading, error }] = useTransferMethodRemoveMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTransferMethodRemoveMutation(baseOptions?: Apollo.MutationHookOptions<TransferMethodRemoveMutation, TransferMethodRemoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TransferMethodRemoveMutation, TransferMethodRemoveMutationVariables>(TransferMethodRemoveDocument, options);
      }
export type TransferMethodRemoveMutationHookResult = ReturnType<typeof useTransferMethodRemoveMutation>;
export type TransferMethodRemoveMutationResult = Apollo.MutationResult<TransferMethodRemoveMutation>;
export type TransferMethodRemoveMutationOptions = Apollo.BaseMutationOptions<TransferMethodRemoveMutation, TransferMethodRemoveMutationVariables>;
export const SendSupportEmailDocument = gql`
    mutation SendSupportEmail($userMessage: String!, $userName: String!, $userEmail: String, $userCategory: String!, $userId: String) {
  sendSupportEmail(
    userMessage: $userMessage
    userName: $userName
    userEmail: $userEmail
    userCategory: $userCategory
    userId: $userId
  ) {
    success
  }
}
    `;
export type SendSupportEmailMutationFn = Apollo.MutationFunction<SendSupportEmailMutation, SendSupportEmailMutationVariables>;

/**
 * __useSendSupportEmailMutation__
 *
 * To run a mutation, you first call `useSendSupportEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendSupportEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendSupportEmailMutation, { data, loading, error }] = useSendSupportEmailMutation({
 *   variables: {
 *      userMessage: // value for 'userMessage'
 *      userName: // value for 'userName'
 *      userEmail: // value for 'userEmail'
 *      userCategory: // value for 'userCategory'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useSendSupportEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendSupportEmailMutation, SendSupportEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendSupportEmailMutation, SendSupportEmailMutationVariables>(SendSupportEmailDocument, options);
      }
export type SendSupportEmailMutationHookResult = ReturnType<typeof useSendSupportEmailMutation>;
export type SendSupportEmailMutationResult = Apollo.MutationResult<SendSupportEmailMutation>;
export type SendSupportEmailMutationOptions = Apollo.BaseMutationOptions<SendSupportEmailMutation, SendSupportEmailMutationVariables>;
export const FaqNinjaWizardTypeDocument = gql`
    query FaqNinjaWizardType($language: String!) {
  ninjaWizardData(language: $language) {
    id
    ninjaCode
    language
    org {
      name
    }
  }
}
    `;

/**
 * __useFaqNinjaWizardTypeQuery__
 *
 * To run a query within a React component, call `useFaqNinjaWizardTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useFaqNinjaWizardTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFaqNinjaWizardTypeQuery({
 *   variables: {
 *      language: // value for 'language'
 *   },
 * });
 */
export function useFaqNinjaWizardTypeQuery(baseOptions: Apollo.QueryHookOptions<FaqNinjaWizardTypeQuery, FaqNinjaWizardTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FaqNinjaWizardTypeQuery, FaqNinjaWizardTypeQueryVariables>(FaqNinjaWizardTypeDocument, options);
      }
export function useFaqNinjaWizardTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FaqNinjaWizardTypeQuery, FaqNinjaWizardTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FaqNinjaWizardTypeQuery, FaqNinjaWizardTypeQueryVariables>(FaqNinjaWizardTypeDocument, options);
        }
export type FaqNinjaWizardTypeQueryHookResult = ReturnType<typeof useFaqNinjaWizardTypeQuery>;
export type FaqNinjaWizardTypeLazyQueryHookResult = ReturnType<typeof useFaqNinjaWizardTypeLazyQuery>;
export type FaqNinjaWizardTypeQueryResult = Apollo.QueryResult<FaqNinjaWizardTypeQuery, FaqNinjaWizardTypeQueryVariables>;
export const RegisterWithConsentDocument = gql`
    mutation RegisterWithConsent($email: String!, $password1: String!, $password2: String!, $securityQuestionQuestion: String!, $securityQuestionAnswer: String!, $consents: [ConsentInput]!) {
  registerWithConsent(
    email: $email
    password1: $password1
    password2: $password2
    securityQuestionQuestion: $securityQuestionQuestion
    securityQuestionAnswer: $securityQuestionAnswer
    consents: $consents
  ) {
    success
    errors
    password
    password2
    token
    refreshToken
  }
}
    `;
export type RegisterWithConsentMutationFn = Apollo.MutationFunction<RegisterWithConsentMutation, RegisterWithConsentMutationVariables>;

/**
 * __useRegisterWithConsentMutation__
 *
 * To run a mutation, you first call `useRegisterWithConsentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterWithConsentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerWithConsentMutation, { data, loading, error }] = useRegisterWithConsentMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password1: // value for 'password1'
 *      password2: // value for 'password2'
 *      securityQuestionQuestion: // value for 'securityQuestionQuestion'
 *      securityQuestionAnswer: // value for 'securityQuestionAnswer'
 *      consents: // value for 'consents'
 *   },
 * });
 */
export function useRegisterWithConsentMutation(baseOptions?: Apollo.MutationHookOptions<RegisterWithConsentMutation, RegisterWithConsentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterWithConsentMutation, RegisterWithConsentMutationVariables>(RegisterWithConsentDocument, options);
      }
export type RegisterWithConsentMutationHookResult = ReturnType<typeof useRegisterWithConsentMutation>;
export type RegisterWithConsentMutationResult = Apollo.MutationResult<RegisterWithConsentMutation>;
export type RegisterWithConsentMutationOptions = Apollo.BaseMutationOptions<RegisterWithConsentMutation, RegisterWithConsentMutationVariables>;
export const UpdateSettingsDocument = gql`
    mutation UpdateSettings($transferMethodId: ID!, $emailNotificationsEnabled: Boolean!, $smsNotificationsEnabled: Boolean!, $optedForWhatsapp: Boolean!, $email: String, $phoneNumber: String) {
  updateSettings(
    transferMethodId: $transferMethodId
    emailNotificationsEnabled: $emailNotificationsEnabled
    smsNotificationsEnabled: $smsNotificationsEnabled
    optedForWhatsapp: $optedForWhatsapp
    phoneNumber: $phoneNumber
    email: $email
  ) {
    user {
      ...SettingsPageUser
    }
    error {
      ...FieldError
    }
  }
}
    ${SettingsPageUserFragmentDoc}
${FieldErrorFragmentDoc}`;
export type UpdateSettingsMutationFn = Apollo.MutationFunction<UpdateSettingsMutation, UpdateSettingsMutationVariables>;

/**
 * __useUpdateSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSettingsMutation, { data, loading, error }] = useUpdateSettingsMutation({
 *   variables: {
 *      transferMethodId: // value for 'transferMethodId'
 *      emailNotificationsEnabled: // value for 'emailNotificationsEnabled'
 *      smsNotificationsEnabled: // value for 'smsNotificationsEnabled'
 *      optedForWhatsapp: // value for 'optedForWhatsapp'
 *      email: // value for 'email'
 *      phoneNumber: // value for 'phoneNumber'
 *   },
 * });
 */
export function useUpdateSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSettingsMutation, UpdateSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSettingsMutation, UpdateSettingsMutationVariables>(UpdateSettingsDocument, options);
      }
export type UpdateSettingsMutationHookResult = ReturnType<typeof useUpdateSettingsMutation>;
export type UpdateSettingsMutationResult = Apollo.MutationResult<UpdateSettingsMutation>;
export type UpdateSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateSettingsMutation, UpdateSettingsMutationVariables>;
export const SettingsPageDocument = gql`
    query SettingsPage {
  me {
    ...SettingsPageUser
  }
}
    ${SettingsPageUserFragmentDoc}`;

/**
 * __useSettingsPageQuery__
 *
 * To run a query within a React component, call `useSettingsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSettingsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSettingsPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useSettingsPageQuery(baseOptions?: Apollo.QueryHookOptions<SettingsPageQuery, SettingsPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SettingsPageQuery, SettingsPageQueryVariables>(SettingsPageDocument, options);
      }
export function useSettingsPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SettingsPageQuery, SettingsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SettingsPageQuery, SettingsPageQueryVariables>(SettingsPageDocument, options);
        }
export type SettingsPageQueryHookResult = ReturnType<typeof useSettingsPageQuery>;
export type SettingsPageLazyQueryHookResult = ReturnType<typeof useSettingsPageLazyQuery>;
export type SettingsPageQueryResult = Apollo.QueryResult<SettingsPageQuery, SettingsPageQueryVariables>;
export const TransferMethodAddBankAccountDocument = gql`
    mutation TransferMethodAddBankAccount($bankAccountId: String!, $branchId: String!, $accountPurpose: String!, $firstName: String!, $lastName: String!, $addressLine1: String!, $addressLine2: String, $city: String!, $state: String!, $postalCode: String!) {
  transferMethodAddBankAccount(
    bankAccountId: $bankAccountId
    branchId: $branchId
    accountPurpose: $accountPurpose
    firstName: $firstName
    lastName: $lastName
    addressLine1: $addressLine1
    addressLine2: $addressLine2
    city: $city
    state: $state
    postalCode: $postalCode
  ) {
    user {
      id
      paymentProfile {
        ...TransferMethods
      }
    }
    error {
      ...FieldError
    }
    errorLabel {
      ...FieldError
    }
  }
}
    ${TransferMethodsFragmentDoc}
${FieldErrorFragmentDoc}`;
export type TransferMethodAddBankAccountMutationFn = Apollo.MutationFunction<TransferMethodAddBankAccountMutation, TransferMethodAddBankAccountMutationVariables>;

/**
 * __useTransferMethodAddBankAccountMutation__
 *
 * To run a mutation, you first call `useTransferMethodAddBankAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransferMethodAddBankAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transferMethodAddBankAccountMutation, { data, loading, error }] = useTransferMethodAddBankAccountMutation({
 *   variables: {
 *      bankAccountId: // value for 'bankAccountId'
 *      branchId: // value for 'branchId'
 *      accountPurpose: // value for 'accountPurpose'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      addressLine1: // value for 'addressLine1'
 *      addressLine2: // value for 'addressLine2'
 *      city: // value for 'city'
 *      state: // value for 'state'
 *      postalCode: // value for 'postalCode'
 *   },
 * });
 */
export function useTransferMethodAddBankAccountMutation(baseOptions?: Apollo.MutationHookOptions<TransferMethodAddBankAccountMutation, TransferMethodAddBankAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TransferMethodAddBankAccountMutation, TransferMethodAddBankAccountMutationVariables>(TransferMethodAddBankAccountDocument, options);
      }
export type TransferMethodAddBankAccountMutationHookResult = ReturnType<typeof useTransferMethodAddBankAccountMutation>;
export type TransferMethodAddBankAccountMutationResult = Apollo.MutationResult<TransferMethodAddBankAccountMutation>;
export type TransferMethodAddBankAccountMutationOptions = Apollo.BaseMutationOptions<TransferMethodAddBankAccountMutation, TransferMethodAddBankAccountMutationVariables>;
export const TransferMethodAddPaypalDocument = gql`
    mutation TransferMethodAddPaypal($email: String!) {
  transferMethodAddPaypal(email: $email) {
    user {
      id
      paymentProfile {
        ...TransferMethods
      }
    }
    error {
      ...FieldError
    }
  }
}
    ${TransferMethodsFragmentDoc}
${FieldErrorFragmentDoc}`;
export type TransferMethodAddPaypalMutationFn = Apollo.MutationFunction<TransferMethodAddPaypalMutation, TransferMethodAddPaypalMutationVariables>;

/**
 * __useTransferMethodAddPaypalMutation__
 *
 * To run a mutation, you first call `useTransferMethodAddPaypalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransferMethodAddPaypalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transferMethodAddPaypalMutation, { data, loading, error }] = useTransferMethodAddPaypalMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useTransferMethodAddPaypalMutation(baseOptions?: Apollo.MutationHookOptions<TransferMethodAddPaypalMutation, TransferMethodAddPaypalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TransferMethodAddPaypalMutation, TransferMethodAddPaypalMutationVariables>(TransferMethodAddPaypalDocument, options);
      }
export type TransferMethodAddPaypalMutationHookResult = ReturnType<typeof useTransferMethodAddPaypalMutation>;
export type TransferMethodAddPaypalMutationResult = Apollo.MutationResult<TransferMethodAddPaypalMutation>;
export type TransferMethodAddPaypalMutationOptions = Apollo.BaseMutationOptions<TransferMethodAddPaypalMutation, TransferMethodAddPaypalMutationVariables>;
export const TransferMethodAddPrepaidCardDocument = gql`
    mutation TransferMethodAddPrepaidCard($addressLine1: String!, $addressLine2: String, $city: String!, $state: String!, $postalCode: String!, $language: String!, $inPersonPickup: Boolean) {
  transferMethodAddPrepaidCard(
    addressLine1: $addressLine1
    addressLine2: $addressLine2
    city: $city
    state: $state
    postalCode: $postalCode
    language: $language
    inPersonPickup: $inPersonPickup
  ) {
    user {
      paymentProfile {
        ...TransferMethods
      }
    }
    error {
      ...FieldError
    }
  }
}
    ${TransferMethodsFragmentDoc}
${FieldErrorFragmentDoc}`;
export type TransferMethodAddPrepaidCardMutationFn = Apollo.MutationFunction<TransferMethodAddPrepaidCardMutation, TransferMethodAddPrepaidCardMutationVariables>;

/**
 * __useTransferMethodAddPrepaidCardMutation__
 *
 * To run a mutation, you first call `useTransferMethodAddPrepaidCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransferMethodAddPrepaidCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transferMethodAddPrepaidCardMutation, { data, loading, error }] = useTransferMethodAddPrepaidCardMutation({
 *   variables: {
 *      addressLine1: // value for 'addressLine1'
 *      addressLine2: // value for 'addressLine2'
 *      city: // value for 'city'
 *      state: // value for 'state'
 *      postalCode: // value for 'postalCode'
 *      language: // value for 'language'
 *      inPersonPickup: // value for 'inPersonPickup'
 *   },
 * });
 */
export function useTransferMethodAddPrepaidCardMutation(baseOptions?: Apollo.MutationHookOptions<TransferMethodAddPrepaidCardMutation, TransferMethodAddPrepaidCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TransferMethodAddPrepaidCardMutation, TransferMethodAddPrepaidCardMutationVariables>(TransferMethodAddPrepaidCardDocument, options);
      }
export type TransferMethodAddPrepaidCardMutationHookResult = ReturnType<typeof useTransferMethodAddPrepaidCardMutation>;
export type TransferMethodAddPrepaidCardMutationResult = Apollo.MutationResult<TransferMethodAddPrepaidCardMutation>;
export type TransferMethodAddPrepaidCardMutationOptions = Apollo.BaseMutationOptions<TransferMethodAddPrepaidCardMutation, TransferMethodAddPrepaidCardMutationVariables>;
export const TransferMethodAddVenmoDocument = gql`
    mutation TransferMethodAddVenmo($phoneNumber: String!) {
  transferMethodAddVenmo(phoneNumber: $phoneNumber) {
    user {
      paymentProfile {
        ...TransferMethods
      }
    }
    error {
      ...FieldError
    }
  }
}
    ${TransferMethodsFragmentDoc}
${FieldErrorFragmentDoc}`;
export type TransferMethodAddVenmoMutationFn = Apollo.MutationFunction<TransferMethodAddVenmoMutation, TransferMethodAddVenmoMutationVariables>;

/**
 * __useTransferMethodAddVenmoMutation__
 *
 * To run a mutation, you first call `useTransferMethodAddVenmoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransferMethodAddVenmoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transferMethodAddVenmoMutation, { data, loading, error }] = useTransferMethodAddVenmoMutation({
 *   variables: {
 *      phoneNumber: // value for 'phoneNumber'
 *   },
 * });
 */
export function useTransferMethodAddVenmoMutation(baseOptions?: Apollo.MutationHookOptions<TransferMethodAddVenmoMutation, TransferMethodAddVenmoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TransferMethodAddVenmoMutation, TransferMethodAddVenmoMutationVariables>(TransferMethodAddVenmoDocument, options);
      }
export type TransferMethodAddVenmoMutationHookResult = ReturnType<typeof useTransferMethodAddVenmoMutation>;
export type TransferMethodAddVenmoMutationResult = Apollo.MutationResult<TransferMethodAddVenmoMutation>;
export type TransferMethodAddVenmoMutationOptions = Apollo.BaseMutationOptions<TransferMethodAddVenmoMutation, TransferMethodAddVenmoMutationVariables>;
export const AddressValidationQueryDocument = gql`
    query AddressValidationQuery($address: String, $city: String, $state: String, $postalCode: String) {
  addressValidation(
    address: $address
    city: $city
    state: $state
    postalCode: $postalCode
  ) {
    address1
    city
    state
    postalCode
    formattedAddress
  }
}
    `;

/**
 * __useAddressValidationQueryQuery__
 *
 * To run a query within a React component, call `useAddressValidationQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddressValidationQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddressValidationQueryQuery({
 *   variables: {
 *      address: // value for 'address'
 *      city: // value for 'city'
 *      state: // value for 'state'
 *      postalCode: // value for 'postalCode'
 *   },
 * });
 */
export function useAddressValidationQueryQuery(baseOptions?: Apollo.QueryHookOptions<AddressValidationQueryQuery, AddressValidationQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AddressValidationQueryQuery, AddressValidationQueryQueryVariables>(AddressValidationQueryDocument, options);
      }
export function useAddressValidationQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AddressValidationQueryQuery, AddressValidationQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AddressValidationQueryQuery, AddressValidationQueryQueryVariables>(AddressValidationQueryDocument, options);
        }
export type AddressValidationQueryQueryHookResult = ReturnType<typeof useAddressValidationQueryQuery>;
export type AddressValidationQueryLazyQueryHookResult = ReturnType<typeof useAddressValidationQueryLazyQuery>;
export type AddressValidationQueryQueryResult = Apollo.QueryResult<AddressValidationQueryQuery, AddressValidationQueryQueryVariables>;